import { jsx, jsxs, Fragment } from 'theme-ui/jsx-runtime';
import { useThemeUI, get, merge, ThemeProvider, Button as Button$1, Badge as Badge$1, Box as Box$1, Text, Avatar as Avatar$1, Divider as Divider$1, createElement, Spinner, Label, Switch as Switch$1 } from 'theme-ui';
import * as React from 'react';
import React__default, { useState, useCallback, useEffect } from 'react';
import { size, useFloating, autoUpdate, offset, flip, shift, useListNavigation, useTypeahead, useClick, useDismiss, useRole, useInteractions, useListItem, useMergeRefs as useMergeRefs$1, FloatingPortal, FloatingFocusManager, FloatingList, arrow, useTransitionStyles, useHover, FloatingArrow, useId, useTransitionStatus, FloatingOverlay } from '@floating-ui/react';
import { isUndefined } from 'lodash';
import omit from 'lodash/omit';
import isUndefined$1 from 'lodash/isUndefined';
import { createPortal } from 'react-dom';
import { Transition } from 'react-transition-group';
import { useScrollLock } from 'usehooks-ts';
import get$1 from 'lodash/get';

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var baseColors = {
    primary: {
        50: '#eafff6',
        100: '#cbffe7',
        200: '#9cfed4',
        300: '#4df7b9',
        400: '#1ee9a5',
        500: '#00d090',
        600: '#00aa76',
        700: '#008862',
        800: '#006b4e',
        900: '#005843',
        950: '#003227'
    },
    neutral: {
        50: '#f5f5f6',
        100: '#e6e6e7',
        200: '#cfcfd2',
        300: '#adadb3',
        400: '#84848c',
        500: '#71717a',
        600: '#5a5a60',
        700: '#4d4c52',
        800: '#434347',
        900: '#3c3b3e',
        950: '#252527'
    },
    negative: {
        50: '#fef2f2',
        100: '#fee3e2',
        200: '#fdcdcb',
        300: '#faaaa7',
        400: '#f67773',
        500: '#ec4c47',
        600: '#d92e29',
        700: '#b6241f',
        800: '#97211d',
        900: '#7d221f',
        950: '#440d0b'
    },
    success: {
        50: '#f0fdf5',
        100: '#dcfce8',
        200: '#bbf7d1',
        300: '#86efad',
        400: '#4ade80',
        500: '#22c55e',
        600: '#16a34a',
        700: '#15803c',
        800: '#166533',
        900: '#14532b',
        950: '#052e14'
    },
    warning: {
        50: '#fff4ed',
        100: '#ffe6d5',
        200: '#feccaa',
        300: '#fdac74',
        400: '#fb8a3c',
        500: '#f97316',
        600: '#ea670c',
        700: '#c2570c',
        800: '#9a4a12',
        900: '#7c3d12',
        950: '#432007'
    },
    info: {
        50: '#eff5ff',
        100: '#dbe8fe',
        200: '#bfd7fe',
        300: '#93bbfd',
        400: '#609afa',
        500: '#3b82f6',
        600: '#2570eb',
        700: '#1d64d8',
        800: '#1e55af',
        900: '#1e478a',
        950: '#172e54'
    },
    white: '#fff',
    black: '#000',
    alpha: {
        primary: {
            100: 'rgba(30,233,165,0.1)',
            200: 'rgba(30,233,165,0.2)'
        },
        neutral: {
            50: 'rgba(132,132,140,0.05)',
            100: 'rgba(132,132,140,0.1)',
            150: 'rgba(207, 207, 210, 0.4)',
            200: 'rgba(132,132,140,0.2)'
        },
        negative: {
            100: 'rgba(246,119,115,0.1)',
            200: 'rgba(246,119,115,0.2)'
        }
    },
    gradients: {
        black: 'linear-gradient(90deg, #000 0%, #4E4E4E 100%)',
        aqua: 'linear-gradient(90deg, #4DF7B9 0%, #4DF6DC 100%)'
    }
};
var elementColors = {
    surface: {
        primary: {
            default: baseColors.primary[300],
            hover: baseColors.primary[400],
            active: baseColors.primary[500]
        },
        primarySubtle: {
            hover: baseColors.alpha.primary[100],
            active: baseColors.alpha.primary[200]
        },
        secondary: {
            default: baseColors.neutral[800],
            hover: baseColors.neutral[900],
            active: baseColors.neutral[950]
        },
        neutral: {
            subtle: baseColors.neutral[50],
            default: baseColors.neutral[300],
            hover: baseColors.neutral[500],
            active: baseColors.neutral[500],
            strong: baseColors.neutral[950]
        },
        neutralSubtle: {
            hover: baseColors.alpha.neutral[100],
            active: baseColors.alpha.neutral[200]
        },
        danger: {
            default: baseColors.negative[500],
            hover: baseColors.negative[600],
            active: baseColors.negative[700]
        },
        dangerSubtle: {
            hover: baseColors.alpha.negative[100],
            active: baseColors.alpha.negative[200]
        },
        controls: {
            disabled: baseColors.alpha.neutral[150]
        },
        disabled: baseColors.alpha.neutral[50]
    },
    border: {
        primary: baseColors.primary[600],
        neutral: {
            default: baseColors.neutral[200],
            hover: baseColors.neutral[500],
            active: baseColors.neutral[600]
        },
        subtle: baseColors.neutral[100],
        danger: baseColors.negative[500],
        disabled: baseColors.neutral[200],
        white: baseColors.white
    },
    text: {
        primary: baseColors.primary[600],
        default: baseColors.neutral[950],
        low: baseColors.neutral[600],
        subtle: baseColors.neutral[400],
        error: baseColors.negative[500],
        invert: baseColors.white,
        disabled: baseColors.neutral[200],
        warning: baseColors.warning[600],
        info: baseColors.info[600],
        success: baseColors.success[600]
    },
    icon: {
        primary: baseColors.primary[600],
        default: baseColors.neutral[950],
        subtle: baseColors.neutral[300],
        invert: baseColors.white,
        danger: baseColors.negative[500],
        warning: baseColors.warning[500],
        low: baseColors.neutral[600],
        success: baseColors.success[500],
        info: baseColors.info[500],
        disabled: baseColors.neutral[200]
    },
    shadow: {
        primary: baseColors.neutral[600],
        focusVisible: baseColors.info[300]
    },
    overlay: {
        50: 'rgba(0, 0, 0, 0.50)'
    }
};
var additionalColors = {
    voice: {
        ownedMedia: '#FFB836',
        media: '#7189FF',
        influencer: '#FF805F',
        celebrity: '#63C8FF',
        partner: '#B697F4'
    },
    tags: {
        default: {
            background: elementColors.surface.neutral.subtle,
            hover: baseColors.neutral[100],
            border: elementColors.border.subtle
        },
        white: {
            background: baseColors.white,
            hover: baseColors.neutral[50],
            border: elementColors.border.subtle
        },
        purple: {
            background: '#F1E6FF',
            hover: '#E3CDFF',
            border: '#B881FF'
        },
        blue: {
            background: '#E6F1FF',
            hover: '#CDE4FF',
            border: '#81BBFF'
        },
        green: {
            background: '#CCF6E9',
            hover: '#99ECD3',
            border: '#00D090'
        },
        yellow: {
            background: '#FDF8E6',
            hover: '#FBF1CD',
            border: '#F6DC83'
        },
        orange: {
            background: '#FFF0E6',
            hover: '#FFE2CD',
            border: '#FFB681'
        },
        red: {
            background: '#FFE6E6',
            hover: '#FFCDCD',
            border: '#FF8181'
        },
        brown: {
            background: '#F9EADF',
            hover: '#F3D5C0',
            border: '#E09661'
        },
        darkGray: {
            background: '#EFEFF0',
            hover: '#DEDEE1',
            border: '#ADADB3'
        }
    }
};
var colors = __assign(__assign(__assign({}, baseColors), additionalColors), elementColors);

var styles = {
    badgeIndicator: {
        container: {
            position: 'relative',
            width: 'fit-content',
            height: 'fit-content'
        },
        default: {
            display: 'flex',
            borderRadius: '50px',
            border: 'default',
            borderColor: 'border.white'
        },
        label: {
            sm: {
                variant: 'text.text2XsSemibold',
                color: 'white'
            },
            md: {
                variant: 'text.textXsSemibold',
                color: 'white'
            }
        },
        placement: {
            bottom: {
                position: 'absolute',
                right: 0,
                bottom: 0
            },
            top: {
                position: 'absolute',
                right: -4,
                top: -4
            }
        },
        placementWithLabel: {
            bottom: {
                position: 'absolute',
                right: 0,
                bottom: 0
            },
            top: {
                position: 'absolute',
                right: -6,
                top: -6
            }
        },
        sizes: {
            xs: {
                width: 6,
                height: 6
            },
            sm: {
                width: 8,
                height: 8
            },
            md: {
                width: 10,
                height: 10
            },
            lg: {
                width: 12,
                height: 12
            },
            xl: {
                width: 14,
                height: 14
            },
            xxl: {
                width: 16,
                height: 16
            }
        },
        sizesWithLabel: {
            sm: {
                maxWidth: 'fit-content',
                paddingY: 1,
                paddingX: 5.5,
                minHeight: 16,
                minWidth: 16
            },
            md: {
                maxWidth: 'fit-content',
                paddingY: 2,
                paddingX: 7,
                minHeight: 20,
                minWidth: 20
            }
        },
        types: {
            primary: {
                backgroundColor: 'surface.primary.active'
            },
            success: {
                backgroundColor: 'icon.success'
            },
            info: {
                backgroundColor: 'icon.info'
            },
            alert: {
                backgroundColor: 'icon.danger'
            },
            warning: {
                backgroundColor: 'icon.warning'
            },
            neutral: {
                backgroundColor: 'icon.low'
            }
        }
    }
};

/**
 * Base styles for the badge component.
 */
var defaultBadge = {
    variant: 'text.textXsMedium',
    borderRadius: '16px',
    padding: '2px 8px',
    textAlign: 'center',
    color: 'text.default'
};
/**
 * Base styles for the tag component.
 */
var defaultTag = {
    variant: 'text.textXsMedium',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 'spacing-4',
    paddingX: 'spacing-8',
    paddingY: 'spacing-4',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: 'radius4',
    maxWidth: '200px',
    '&.clickable:not([aria-disabled="true"])': {
        cursor: 'pointer'
    },
    '&.with-icon > .icon-container svg': {
        fontSize: 3,
        color: 'icon.default'
    },
    '&.with-delete': {
        paddingRight: 'spacing-6'
    },
    '&:hover .tag-delete-button': {
        color: 'icon.default'
    },
    '&[aria-disabled="true"]:hover .tag-delete-button': {
        cursor: 'not-allowed',
        color: 'icon.disabled'
    }
};
var defaultTagLabel = {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    variant: 'text.textXsMedium'
};
var defaultTagSublabel = __assign(__assign({}, defaultTagLabel), { variant: 'text.textXsRegular' });
var defaultTagCloseButton = {
    cursor: 'pointer',
    color: 'icon.subtle',
    fontSize: 3
};
var defaultInputFocus = {
    '&:focus-visible': {
        outlineOffset: '1px',
        outline: '3px solid',
        outlineColor: 'shadow.focusVisible'
    }
};

var defaultButtonTheme = __assign({}, defaultInputFocus);
var buttonTheme = __assign({ sizes: {
        tiny: {
            minHeight: 20,
            cursor: 'pointer',
            padding: '0px 7px',
            display: 'inline-flex',
            gap: '4px',
            alignItems: 'center',
            justifyContent: 'center',
            span: {
                variant: 'text.textXsMedium'
            },
            svg: {
                width: '16px',
                height: '16px',
                verticalAlign: 'bottom',
                strokeWidth: '2px'
            },
            '&.onlyIcon': {
                svg: {
                    marginLeft: '0px',
                    marginRight: '0px'
                },
                padding: '2px'
            }
        },
        small: {
            minHeight: 32,
            cursor: 'pointer',
            padding: '0px 9px',
            display: 'inline-flex',
            gap: '4px',
            alignItems: 'center',
            justifyContent: 'center',
            span: {
                variant: 'text.textXsMedium'
            },
            svg: {
                width: '16px',
                height: '16px',
                verticalAlign: 'bottom',
                strokeWidth: '2px'
            },
            '&.onlyIcon': {
                svg: {
                    marginLeft: '0px',
                    marginRight: '0px'
                },
                padding: '7px'
            }
        },
        medium: {
            minHeight: 40,
            cursor: 'pointer',
            padding: '0px 11px',
            display: 'inline-flex',
            gap: '8px',
            alignItems: 'center',
            justifyContent: 'center',
            span: {
                variant: 'text.textSmMedium'
            },
            svg: {
                width: '20px',
                height: '20px',
                verticalAlign: 'bottom'
            },
            '&.onlyIcon': {
                svg: {
                    marginLeft: '0px',
                    marginRight: '0px'
                },
                padding: '9px'
            }
        },
        large: {
            minHeight: 48,
            cursor: 'pointer',
            padding: '0px 15px',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            span: {
                variant: 'text.textMdMedium'
            },
            svg: {
                width: '24px',
                height: '24px',
                verticalAlign: 'bottom'
            },
            '&.onlyIcon': {
                svg: {
                    marginLeft: '0px',
                    marginRight: '0px'
                },
                padding: '11px'
            }
        }
    }, close: {
        background: 'transparent'
    }, danger: __assign({ color: 'text.invert', bg: 'surface.danger.default', border: '1px solid', borderColor: 'transparent', borderRadius: 'radius4', '&:hover': {
            bg: 'surface.danger.hover'
        }, '&:disabled': {
            color: 'text.disabled',
            bg: 'surface.disabled',
            cursor: 'not-allowed',
            svg: {
                color: 'icon.disabled'
            }
        }, '&:not(:disabled):active': {
            bg: 'surface.danger.active'
        }, svg: {
            color: 'icon.invert'
        } }, defaultButtonTheme), tertiary: __assign({ color: 'text.default', bg: 'transparent', border: '1px solid', borderColor: 'border.neutral.default', borderRadius: 'radius4', '&:hover': {
            bg: 'surface.neutralSubtle.hover',
            border: '1px solid',
            borderColor: 'border.neutral.hover'
        }, '&:disabled': {
            color: 'text.disabled',
            bg: 'transparent',
            border: '1px solid',
            borderColor: 'border.neutral.default',
            cursor: 'not-allowed',
            svg: {
                color: 'icon.disabled'
            }
        }, '&:not(:disabled):active': {
            bg: 'surface.neutralSubtle.active',
            border: '1px solid',
            borderColor: 'border.neutral.active'
        } }, defaultButtonTheme), secondary: __assign({ color: 'text.invert', bg: 'surface.secondary.default', border: '1px solid', borderColor: 'transparent', fontWeight: 'medium', borderRadius: 'radius4', '&:hover': {
            bg: 'surface.secondary.hover'
        }, '&:disabled': {
            color: 'text.disabled',
            bg: 'surface.disabled',
            cursor: 'not-allowed',
            svg: {
                color: 'icon.disabled'
            }
        }, '&:not(:disabled):active': {
            bg: 'surface.secondary.active'
        }, svg: {
            color: 'icon.invert'
        } }, defaultButtonTheme), primary: __assign({ color: 'text.default', bg: 'surface.primary.default', border: '1px solid', borderColor: 'transparent', borderRadius: 'radius4', '&:hover': {
            bg: 'surface.primary.hover'
        }, '&:disabled': {
            color: 'text.disabled',
            bg: 'surface.disabled',
            cursor: 'not-allowed',
            svg: {
                color: 'icon.disabled'
            }
        }, '&:not(:disabled):active': {
            bg: 'surface.primary.active'
        } }, defaultButtonTheme), textPrimary: __assign({ color: 'text.primary', border: '1px solid', borderColor: 'transparent', bg: 'transparent', borderRadius: 'radius4', '&:hover': {
            bg: 'surface.primarySubtle.hover'
        }, '&:disabled': {
            color: 'text.disabled',
            bg: 'transparent',
            cursor: 'not-allowed',
            svg: {
                color: 'icon.disabled'
            }
        }, '&:not(:disabled):active': {
            bg: 'surface.primarySubtle.active'
        }, svg: {
            color: 'icon.primary'
        } }, defaultButtonTheme), textGray: __assign({ color: 'text.default', border: '1px solid', borderColor: 'transparent', bg: 'transparent', borderRadius: 'radius4', '&:hover': {
            bg: 'surface.neutralSubtle.hover'
        }, '&:disabled': {
            color: 'text.disabled',
            bg: 'transparent',
            cursor: 'not-allowed',
            svg: {
                color: 'icon.disabled'
            }
        }, '&:not(:disabled):active': {
            bg: 'surface.neutralSubtle.active'
        } }, defaultButtonTheme), textDanger: __assign({ color: 'text.error', border: '1px solid', borderColor: 'transparent', bg: 'transparent', borderRadius: 'radius4', '&:hover': {
            bg: 'surface.dangerSubtle.hover'
        }, '&:disabled': {
            color: 'text.disabled',
            bg: 'transparent',
            cursor: 'not-allowed',
            svg: {
                color: 'icon.disabled'
            }
        }, '&:not(:disabled):active': {
            bg: 'surface.dangerSubtle.active'
        }, svg: {
            color: 'icon.danger'
        } }, defaultButtonTheme), round: __assign({ color: 'text.default', bg: 'surface.primary.default', border: '1px solid', borderColor: 'transparent', borderRadius: '999px', '&:hover': {
            bg: 'surface.primary.hover'
        }, '&:disabled': {
            color: 'text.disabled',
            bg: 'surface.disabled',
            cursor: 'not-allowed',
            svg: {
                color: 'icon.disabled'
            }
        }, '&:not(:disabled):active': {
            bg: 'surface.primary.active'
        } }, defaultButtonTheme), tertiaryPrimary: __assign({ color: 'text.primary', bg: 'transparent', border: '1px solid', borderColor: 'border.primary', borderRadius: 'radius4', svg: {
            color: 'icon.primary'
        }, '&:hover': {
            bg: 'surface.primarySubtle.hover',
            border: '1px solid',
            borderColor: 'border.primary'
        }, '&:disabled': {
            color: 'text.disabled',
            bg: 'transparent',
            border: '1px solid',
            borderColor: 'border.disabled',
            cursor: 'not-allowed',
            svg: {
                color: 'icon.disabled'
            }
        }, '&:not(:disabled):active': {
            bg: 'surface.primarySubtle.active',
            border: '1px solid',
            borderColor: 'border.disabled'
        } }, defaultButtonTheme) }, Object.entries({
    inlinePrimary: {
        text: 'text.primary',
        icon: 'icon.primary'
    },
    inlineGray: {
        text: 'text.default',
        icon: 'icon.default'
    },
    inlineDanger: {
        text: 'text.error',
        icon: 'icon.danger'
    },
    inlineWhite: {
        text: 'text.disabled',
        icon: 'icon.disabled'
    }
}).reduce(function (acc, _a) {
    var key = _a[0], color = _a[1];
    acc[key] = __assign({ color: color.text, background: 'none', padding: '0px !important', '&:hover': {
            textDecoration: 'underline'
        }, '&:disabled': {
            color: 'text.disabled',
            cursor: 'not-allowed',
            svg: {
                color: 'icon.disabled'
            }
        }, '&:not(:disabled):active': {
            textDecoration: 'underline'
        }, svg: {
            color: color.icon
        } }, defaultButtonTheme);
    return acc;
}, {}));

var container = {
    padding: 'spacing-12',
    borderRadius: 'radius8',
    border: '1px solid',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
};
var containerNotError = {
    borderColor: 'neutral.100',
};
var fileStatusCardTheme = {
    fileStatusCard: {
        "container-error": __assign(__assign({}, container), { borderColor: 'border.danger', backgroundColor: '#F677731A' }),
        "container-in-progress": __assign(__assign({}, container), containerNotError),
        "container-completed": __assign(__assign({}, container), containerNotError),
        content: {
            width: '100%',
            marginLeft: 'spacing-12'
        },
        infoContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 'spacing-8',
        },
        errorInfo: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'start',
            marginBottom: 'spacing-8'
        },
        errorIcon: {
            width: 16,
            height: 16,
            marginRight: 'spacing-4',
            color: 'text.error'
        },
        tryAgain: {
            minHeight: 0,
        }
    }
};

var defaultStyles$5 = {
    container: {
        display: 'inline-flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        border: 'default',
        borderRadius: 'radius8',
        borderColor: 'border.default'
    }
};
var inlineNotificationTheme = {
    inlineNotification: {
        small: {
            container: __assign(__assign({}, defaultStyles$5.container), { paddingY: 'spacing-4', paddingX: 'spacing-12', minHeight: 32, borderRadius: 'radius4' })
        },
        medium: {
            container: __assign(__assign({}, defaultStyles$5.container), { paddingY: 'spacing-12', paddingX: 'spacing-16', minHeight: 48 })
        },
        colors: {
            success: {
                container: {
                    backgroundColor: 'success.50',
                    borderColor: 'success.200'
                }
            },
            warning: {
                container: {
                    backgroundColor: 'warning.50',
                    borderColor: 'warning.200'
                }
            },
            error: {
                container: {
                    backgroundColor: 'negative.50',
                    borderColor: 'negative.200'
                }
            },
            info: {
                container: {
                    backgroundColor: 'info.50',
                    borderColor: 'info.200'
                }
            },
            neutral: {
                container: {
                    backgroundColor: 'neutral.50',
                    borderColor: 'border.subtle'
                }
            }
        },
        textContainer: {
            flex: 1
        },
        message: {
            color: 'text.default',
            fontSize: '2',
            fontWeight: 'regular',
            lineHeight: '20px'
        },
        link: {
            color: 'text.low',
            fontSize: '2',
            lineHeight: '20px',
            ':hover': {
                color: 'text.default'
            }
        },
        icon: {
            marginRight: 'spacing-8',
            width: 20,
            height: 20,
            alignSelf: 'flex-start'
        },
        actionContainer: {
            display: 'flex',
            justifyContent: 'flex-end'
        },
        divider: {
            marginLeft: 'spacing-24',
            marginRight: 'spacing-16',
            marginY: 0
        },
        actionButton: {
            maxHeight: 20,
            minHeight: 0
        }
    }
};

var inputTheme = {
    width: '100%',
    paddingY: 'spacing-4',
    fontFamily: 'body',
    color: 'text.default',
    borderRadius: 'radius4',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'border.neutral.default',
    '&:hover': {
        borderColor: 'border.neutral.hover'
    },
    '&:focus': {
        outline: 'none',
        borderColor: 'border.neutral.active',
        boxShadow: '0px 0px 0px 1px #5A5A60'
    },
    '&[aria-invalid="true"]': {
        borderColor: 'border.danger',
        '&:focus': {
            boxShadow: '0px 0px 0px 1px #EC4C47'
        }
    },
    '&[aria-disabled="true"]': {
        color: 'text.disabled',
        '&:hover': {
            borderColor: 'border.disabled'
        },
        backgroundColor: 'surface.disabled',
        '::placeholder': {
            color: 'text.disabled'
        }
    },
    '&.with-start-icon': {
        paddingLeft: '36px'
    },
    '&.with-end-icon': {
        paddingRight: '36px'
    },
    small: {
        fontSize: '12px',
        height: '32px',
        paddingX: 'spacing-8'
    },
    medium: {
        fontSize: '14px',
        height: '40px',
        paddingX: 'spacing-8'
    },
    large: {
        fontSize: '16px',
        height: '48px',
        paddingX: 'spacing-12'
    }
};

var defaultStyles$4 = {
    container: {
        display: 'flex',
        '.modal-accent-icon': {
            width: '88px',
            height: '88px'
        },
        width: '100%',
        justifyContent: 'center',
        marginBottom: 'spacing-16'
    }
};
var modalAccentIconTheme = {
    aligned: __assign(__assign({}, defaultStyles$4), { container: __assign(__assign({}, defaultStyles$4.container), { display: 'none' }) }),
    centered: defaultStyles$4
};

var defaultStyles$3 = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginTop: 'spacing-40',
    gap: 'spacing-16',
    width: '100%'
};
var modalActionsTheme = {
    aligned: defaultStyles$3,
    centered: __assign(__assign({}, defaultStyles$3), { justifyContent: 'center' })
};

var defaultStyles$2 = {
    overlay: {
        background: 'overlay.50',
        display: 'grid',
        placeItems: 'center',
        zIndex: 'overlay',
        transitionProperty: 'opacity',
        transitionTimingFunction: 'linear',
        "&[data-status='open'], &[data-status='close']": {
            transitionDuration: '150ms'
        },
        "&[data-status='initial'], &[data-status='close']": {
            opacity: 0
        }
    },
    box: {
        background: 'white',
        borderRadius: 'radius8',
        display: 'flex',
        flexDirection: 'column',
        padding: 'spacing-32',
        boxShadow: 'xl',
        maxWidth: '100%',
        margin: 'spacing-24',
        transitionProperty: 'transform',
        transitionTimingFunction: 'ease-out',
        transform: 'none',
        "&[data-status='open'], &[data-status='close']": {
            transitionDuration: '300ms'
        },
        "&[data-status='initial'], &[data-status='close']": {
            transform: 'translate(0, -50px)'
        }
    },
    closeButton: {
        position: 'absolute',
        top: 16,
        right: 16
    }
};
var modalContentTheme = {
    aligned: defaultStyles$2,
    centered: __assign(__assign({}, defaultStyles$2), { box: __assign(__assign({}, defaultStyles$2.box), { alignItems: 'center' }) }),
    sizes: {
        small: {
            width: '400px'
        },
        medium: {
            width: '600px'
        },
        large: {
            width: '800px'
        }
    }
};

var defaultStyles$1 = {
    variant: 'text.textMdRegular',
    color: 'text.low'
};
var modalDescriptionTheme = {
    aligned: __assign(__assign({}, defaultStyles$1), { marginTop: 'spacing-8' }),
    centered: __assign(__assign({}, defaultStyles$1), { textAlign: 'center', marginTop: 'spacing-4' })
};

var defaultStyles = {
    container: {
        display: 'flex',
        alignItems: 'center',
        '.modal-heading-icon': {
            marginRight: 'spacing-8'
        }
    },
    text: {
        variant: 'text.heading2XsSemibold',
        color: 'text.default',
        fontWeight: 'medium'
    }
};
var modalHeadingTheme = {
    aligned: defaultStyles,
    centered: __assign(__assign({}, defaultStyles), { container: __assign(__assign({}, defaultStyles.container), { '.modal-heading-icon': __assign(__assign({}, defaultStyles.container['.modal-heading-icon']), { display: 'none' }) }) })
};

var modalTheme = {
    modal: {
        content: modalContentTheme,
        heading: modalHeadingTheme,
        accentIcon: modalAccentIconTheme,
        description: modalDescriptionTheme,
        actions: modalActionsTheme
    }
};

var progressBarTheme = {
    progressBar: {
        label: {
            marginBottom: 'spacing-4'
        },
        container: {
            display: 'flex',
            flexDirection: 'row',
            gap: '4px',
            alignItems: 'center'
        },
        bar: {
            width: '100%',
            flex: 1,
            transition: 'width 0.3s ease',
            appearance: 'none',
            '&::-webkit-progress-bar': {
                backgroundColor: 'neutral.50',
                borderRadius: 'radius16'
            },
        },
        percentage: {
            color: 'text.low',
            width: '36px',
            textAlign: 'right'
        },
        completeIcon: {
            width: '36px'
        },
        loader: {
            color: 'text.low'
        },
        hint: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '4px',
            marginTop: 'spacing-4'
        }
    }
};

var selectTheme = {
    medium: {
        height: 40,
        fontSize: 2,
        divider: {
            marginRight: '2px',
            height: '20px',
            maxHeight: '20px',
            alignSelf: 'unset !important'
        },
        endIcons: {
            width: '44px',
            toggleIcon: {
                fontSize: '20px !important',
                color: 'inherit'
            }
        }
    },
    small: {
        height: 32,
        fontSize: 1,
        divider: {
            marginRight: '2px',
            height: '20px',
            maxHeight: '16px',
            alignSelf: 'unset !important'
        },
        endIcons: {
            width: '40px',
            toggleIcon: {
                fontSize: '16px !important',
                color: 'inherit'
            }
        }
    },
    large: {
        height: 48,
        fontSize: 3,
        paddingRight: 'spacing-12',
        paddingLeft: 'spacing-12',
        divider: {
            marginRight: '2px',
            height: '20px',
            maxHeight: '20px',
            alignSelf: 'unset !important'
        },
        endIcons: {
            width: '49px',
            toggleIcon: {
                fontSize: '24px !important',
                color: 'inherit'
            }
        }
    }
};

var tabTheme = {
    sizes: {
        small: {
            minHeight: 32,
            paddingX: 'spacing-10',
            svg: {
                width: '16px',
                height: '16px'
            },
            '&.onlyIcon': {
                paddingX: 'spacing-8',
            },
            tabLabel: {
                variant: 'text.textXsMedium'
            }
        },
        medium: {
            minHeight: 40,
            paddingX: 'spacing-12',
            svg: {
                width: '20px',
                height: '20px'
            },
            '&.onlyIcon': {
                paddingX: 'spacing-10',
            },
            tabLabel: {
                variant: 'text.textSmMedium'
            }
        },
        large: {
            minHeight: 48,
            paddingX: 'spacing-16',
            svg: {
                width: '24px',
                height: '24px'
            },
            '&.onlyIcon': {
                paddingX: 'spacing-12',
            },
            tabLabel: {
                variant: 'text.textMdMedium'
            }
        }
    },
    status: {
        default: {
            borderBottomColor: 'border.subtle',
            color: 'text.low',
            cursor: 'pointer',
            '&:hover': {
                borderBottomColor: 'border.neutral.hover',
                color: 'text.default'
            }
        },
        active: {
            borderBottomColor: 'border.primary',
            color: 'text.default',
            cursor: 'pointer'
        },
        disabled: {
            borderBottomColor: 'border.subtle',
            color: 'text.disabled',
            cursor: 'not-allowed',
            path: {
                fill: 'text.disabled'
            }
        }
    },
    button: {
        border: 'none',
        background: 'none',
        borderBottom: '2px solid',
        borderBottomColor: 'border.subtle',
        width: 'fit-content',
    },
    label: {
        color: 'text.default',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 'spacing-8',
    }
};

var toastTheme = {
    toast: {
        container: {
            backgroundColor: 'white',
            border: 'default',
            borderColor: 'border.subtle',
            borderRadius: 'radius8',
            margin: 'spacing-8',
            boxShadow: 'md'
        },
        closeButtonContainer: {
            position: 'absolute',
            top: 'spacing-12',
            zIndex: 10,
            right: 'spacing-12',
            padding: 'spacing-2',
            cursor: 'pointer'
        },
        closeButtonContainerBasic: {
            display: 'flex',
            alignItems: 'center',
            padding: 'spacing-2'
        },
        headerBasic: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        header: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 'spacing-8',
            marginBottom: 'spacing-8'
        },
        titleIconWrapper: {
            alignItems: 'center',
            gap: 'spacing-8',
            display: 'flex',
            flexDirection: 'row'
        },
        actionCloseWrapper: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 'spacing-16',
            flexGrow: 1,
            justifyContent: 'flex-end'
        },
        action: {
            display: 'flex',
            justifyContent: 'flex-end'
        }
    }
};

var makeTheme = function (t) { return t; };
var mainFont = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"';
/**
 * Creates typography variants for a given type, size and css rules
 */
var createTypographyVariants = function (type, size, cssRules) {
    var variants = {};
    ['Regular', 'Medium', 'Semibold', 'Bold'].forEach(function (fontWeight) {
        var variant = "".concat(type).concat(size).concat(fontWeight);
        variants[variant] = __assign({ fontFamily: type === 'heading' ? 'heading' : 'body', fontStyle: 'normal', fontWeight: fontWeight.toLowerCase() }, cssRules);
    });
    return variants;
};
var theme = makeTheme(__assign(__assign(__assign(__assign(__assign(__assign({ fonts: {
        body: mainFont,
        heading: mainFont,
        monospace: 'SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
        sans: mainFont
    }, fontSizes: [10, 12, 14, 16, 20, 24, 30, 38, 46], fontWeights: {
        regular: 400,
        medium: 500,
        semibold: 600,
        bold: 700
    }, lineHeights: ['16px', '18px', '22px', '24px', '26px', '32px', '38px', '48px', '60px', '74px'], zIndices: {
        card: 5,
        overlay: 10,
        dropdown: 20,
        tooltip: 9999
    }, space: {
        'spacing-0': '0px',
        'spacing-2': '2px',
        'spacing-4': '4px',
        'spacing-6': '6px',
        'spacing-8': '8px',
        'spacing-10': '10px',
        'spacing-12': '12px',
        'spacing-16': '16px',
        'spacing-20': '20px',
        'spacing-24': '24px',
        'spacing-32': '32px',
        'spacing-40': '40px',
        'spacing-48': '48px',
        'spacing-56': '56px',
        'spacing-64': '64px',
        'spacing-72': '72px',
        'spacing-96': '96px',
        'spacing-128': '128px',
        'spacing-256': '256px',
        'spacing-320': '320px',
        'spacing-512': '512px'
    }, shadows: {
        '1dp': '0px 1px 3px rgba(0, 0, 0, 0.12), 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.20)',
        '2dp': '0px 1px 5px rgba(0, 0, 0, 0.20), 0px 3px 4px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.14))',
        '3dp': '0px 1px 8px rgba(0, 0, 0, 0.20), 0px 3px 4px rgba(0, 0, 0, 0.12), 0px 3px 3px rgba(0, 0, 0, 0.14)',
        '4dp': '0px 1px 10px rgba(0, 0, 0, 0.20), 0px 4px 5px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.14)',
        '6dp': '0px 3px 5px rgba(0, 0, 0, 0.20), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 6px 10px rgba(0, 0, 0, 0.14)',
        '8dp': '0px 4px 5px rgba(0, 0, 0, 0.20), 0px 3px 14px rgba(0, 0, 0, 0.12), 0px 8px 10px rgba(0, 0, 0, 0.14)',
        '9dp': '0px 5px 6px rgba(0, 0, 0, 0.20), 0px 3px 16px rgba(0, 0, 0, 0.12), 0px 9px 12px rgba(0, 0, 0, 0.14)',
        '12dp': '0px 7px 8px rgba(0, 0, 0, 0.20), 0px 5px 22px rgba(0, 0, 0, 0.12), 0px 12px 17px rgba(0, 0, 0, 0.14)',
        '16dp': '0px 8px 10px rgba(0, 0, 0, 0.20), 0px 6px 30px rgba(0, 0, 0, 0.12), 0px 16px 24px rgba(0, 0, 0, 0.14)',
        '24dp': '0px 11px 15px rgba(0, 0, 0, 0.20), 0px 9px 46px rgba(0, 0, 0, 0.12), 0px 24px 38px rgba(0, 0, 0, 0.14)',
        md: '0px 4px 11px 0px rgba(13, 22, 38, 0.1)',
        lg: '0px 0px 1px 0px rgba(13, 22, 38, 0.05), 0px 4px 14px 0px rgba(13, 22, 38, 0.2)',
        xl: '0px 0px 24px 0px rgba(13, 22, 38, 0.14), 0px 6px 30px 0px rgba(13, 22, 38, 0.12), 0px 4px 10px 0px rgba(13, 22, 38, 0.02)',
        'focus-within': '0px 0px 0px 1px rgba(90, 90, 96, 1)',
        'focus-within:error': '0px 0px 0px 1px rgba(236, 76, 71, 1)',
        'focus-visible': '0px 0px 0px 3px rgba(147, 187, 253, 1), 0px 0px 0px 1px rgba(255, 255, 255, 1)'
    }, transitions: {
        property: {
            none: 'none',
            all: 'all',
            colors: 'background-color, border-color, color, fill, stroke',
            opacity: 'opacity',
            shadow: 'box-shadow',
            transform: 'transform'
        },
        type: {
            linear: 'linear',
            in: 'cubic-bezier(0.4, 0, 1, 1)',
            out: 'cubic-bezier(0, 0, 0.2, 1)',
            inOut: 'cubic-bezier(0.4, 0, 0.2, 1)'
        },
        duration: {
            '225': '225ms'
        }
    }, radii: {
        square: 0,
        radius0: '0px',
        radius2: '2px',
        radius4: '4px',
        radius8: '8px',
        radius16: '16px',
        radiusFull: '100%',
        circle: '100%'
    }, borders: {
        default: '1px solid'
    }, text: __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({ default: {
            // @deprecated
            variant: 'text.body1'
        }, 
        // @deprecated
        h1: {
            fontFamily: 'heading',
            fontSize: 8 // 46px
        }, h2: {
            // @deprecated
            fontFamily: 'heading',
            fontSize: 7 // 38px
        }, h3: {
            // @deprecated
            fontFamily: 'heading',
            fontSize: 6 // 30px
        }, h4: {
            // @deprecated
            fontFamily: 'heading',
            fontSize: 5 // 24px
        }, h5: {
            // @deprecated
            fontFamily: 'heading',
            fontSize: 4 // 20px
        }, h6: {
            // @deprecated
            fontFamily: 'heading',
            fontSize: 3,
            fontWeight: 'medium',
            lineHeight: 3
        }, body1: {
            // @deprecated
            fontSize: 3,
            fontFamily: 'body'
        }, body2: {
            // @deprecated
            fontSize: 2,
            fontFamily: 'body'
        }, caption: {
            // @deprecated
            fontSize: 1,
            fontFamily: 'body'
        }, overline: {
            // @deprecated
            fontSize: 0,
            fontFamily: 'body'
        }, p: {
            // @deprecated
            variant: 'text.body1'
        }, span: {
            // @deprecated
            variant: 'text.body2',
            lineHeight: 2
        } }, createTypographyVariants('heading', 'Xl', {
        fontSize: '48px',
        lineHeight: '60px',
        letterSpacing: '-0.96px'
    })), createTypographyVariants('heading', 'Lg', {
        fontSize: '40px',
        lineHeight: '48px',
        letterSpacing: '-0.8px'
    })), createTypographyVariants('heading', 'Md', {
        fontSize: '32px',
        lineHeight: '38px',
        letterSpacing: '-0.64px'
    })), createTypographyVariants('heading', 'Sm', {
        fontSize: '28px',
        lineHeight: '36px'
    })), createTypographyVariants('heading', 'Xs', {
        fontSize: '24px',
        lineHeight: '32px'
    })), createTypographyVariants('heading', '2Xs', {
        fontSize: '20px',
        lineHeight: '30px'
    })), createTypographyVariants('text', 'Lg', {
        fontSize: '18px',
        lineHeight: '28px'
    })), createTypographyVariants('text', 'Md', {
        fontSize: '16px',
        lineHeight: '24px'
    })), createTypographyVariants('text', 'Sm', {
        fontSize: '14px',
        lineHeight: '20px'
    })), createTypographyVariants('text', 'Xs', {
        fontSize: '12px',
        lineHeight: '16px'
    })), createTypographyVariants('text', '2Xs', {
        fontSize: '10px',
        lineHeight: '14px',
        textTransform: 'uppercase'
    })), links: {
        default: __assign({ color: 'text.primary', cursor: 'pointer', textDecoration: 'underline' }, defaultInputFocus)
    }, tableCells: {
        th: {
            simple: {
                fontSize: 1,
                fontFamily: 'heading',
                textTransform: 'uppercase',
                fontStyle: 'normal',
                fontWeight: 'bold',
                lineHeight: 1,
                padding: '19px 8px',
                borderBottomWidth: '1px',
                borderBottomStyle: 'solid',
                borderBottomColor: 'border.subtle',
                textAlign: 'left'
            }
        },
        td: {
            simple: {
                fontFamily: 'body',
                fontSize: 2,
                fontStyle: 'normal',
                fontWeight: 'regular',
                lineHeight: 3,
                padding: '8px',
                borderBottomWidth: '1px',
                borderBottomStyle: 'solid',
                borderBottomColor: 'border.subtle'
            }
        },
        thSortLabel: {
            simple: {
                '&:hover': {
                    backgroundColor: 'surface.neutralSubtle.hover'
                },
                padding: 'spacing-6',
                borderRadius: 'radius4'
            }
        }
    }, tableBody: {
        simple: {
            'tr:hover': {
                backgroundColor: 'surface.neutralSubtle.hover'
            }
        }
    }, tables: {
        simple: {
            borderSpacing: 0,
            borderCollapse: 'separate',
            color: 'text.default'
        }
    }, boxes: {
        center: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        dropdown: {
            fontFamily: 'body',
            bg: 'white',
            border: '1px solid',
            borderColor: 'border.neutral.default',
            borderRadius: 'radius4',
            py: 'spacing-8',
            maxHeight: '260px',
            overflow: 'auto',
            boxShadow: '0px 4px 11px 0px #0D16261A',
            zIndex: 'dropdown'
        },
        option: {
            variant: 'text.textSmRegular',
            color: 'text.default',
            cursor: 'pointer',
            py: 'spacing-8',
            px: 'spacing-16',
            '&:focus-visible': {
                bg: 'surface.neutralSubtle.hover',
                outline: 'none'
            },
            '&[tabindex="0"]': {
                bg: 'surface.neutralSubtle.hover',
                outline: 'none'
            },
            '&:hover': {
                bg: 'surface.neutralSubtle.hover'
            }
        },
        multiValueSelect: {
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: 'spacing-4',
            paddingLeft: 'spacing-8',
            paddingRight: 'spacing-32',
            paddingY: '6px',
            minHeight: '40px',
            border: 'solid 1px',
            borderColor: 'border.neutral.default',
            borderRadius: 'radius4',
            input: {
                minWidth: '200px',
                flexGrow: 1,
                border: 'none',
                color: 'text.default',
                variant: 'text.textSmRegular',
                '&:focus-visible': {
                    outline: 'none'
                },
                '&::placeholder': {
                    color: 'text.subtle'
                },
                '&:disabled': {
                    color: 'text.disabled',
                    cursor: 'not-allowed',
                    backgroundColor: 'transparent'
                }
            },
            '&:hover': {
                borderColor: 'border.neutral.hover'
            },
            '&:focus-within': {
                borderColor: 'border.neutral.active',
                boxShadow: '0px 0px 0px 1px #5A5A60'
            },
            '&[aria-invalid="true"]': {
                borderColor: 'border.danger',
                '&:focus-within': {
                    boxShadow: '0px 0px 0px 1px #EC4C47'
                }
            },
            '&[aria-disabled="true"]': {
                cursor: 'not-allowed',
                borderColor: 'border.disabled',
                backgroundColor: 'surface.disabled'
            },
            '.multi-value-select-loading': {
                position: 'absolute',
                right: 'spacing-8',
                top: 'spacing-12'
            },
            '.multi-value-select-clear': {
                position: 'absolute',
                right: 'spacing-4',
                top: 'spacing-8',
                minHeight: 'auto !important',
                padding: '2px !important',
                svg: {
                    width: '16px',
                    height: '16px'
                }
            }
        }
    }, colors: colors, spinner: {
        color: 'primary.500'
    }, buttons: buttonTheme, badges: {
        beta: __assign(__assign({}, defaultBadge), { background: 'gradients.aqua' })
    }, tabs: tabTheme, tags: {
        box: defaultTag,
        label: defaultTagLabel,
        sublabel: defaultTagSublabel,
        close: defaultTagCloseButton,
        sizes: {
            small: {
                box: {
                    height: '20px',
                    '&.multiline': {
                        height: '40px'
                    }
                }
            },
            medium: {
                box: {
                    height: '24px',
                    '&.multiline': {
                        height: '44px'
                    }
                }
            },
            large: {
                box: {
                    height: '28px',
                    paddingX: 'spacing-10',
                    '&.multiline': {
                        height: '48px',
                        gap: 'spacing-6'
                    },
                    '&.with-delete': {
                        paddingRight: 'spacing-8'
                    }
                },
                label: {
                    variant: 'text.textSmMedium'
                },
                sublabel: {
                    variant: 'text.textSmRegular',
                    lineHeight: '20px'
                }
            }
        },
        colorVariants: __assign({}, Object.keys(additionalColors.tags).reduce(function (acc, key) {
            acc[key] = {
                backgroundColor: "tags.".concat(key, ".background"),
                borderColor: "tags.".concat(key, ".border"),
                '&.clickable:hover ': {
                    backgroundColor: "tags.".concat(key, ".hover")
                }
            };
            return acc;
        }, {}))
    }, images: {
        avatar: {
            rounded: {
                width: 'avatar.large',
                borderRadius: 'radius8',
                border: 'default',
                borderColor: 'border.subtle'
            },
            circle: {
                width: 'avatar.large',
                borderRadius: 'circle',
                border: 'default',
                borderColor: 'border.subtle'
            },
            square: {
                width: 'avatar.large',
                borderRadius: 'square',
                border: 'default',
                borderColor: 'border.subtle'
            }
        }
    }, input: inputTheme, sizes: {
        avatar: {
            large: 65,
            small: 45
        }
    }, divider: {
        vertical: {
            borderLeftWidth: '1px',
            borderColor: 'border.subtle',
            alignSelf: 'stretch'
        },
        horizontal: {
            borderBottomWidth: '1px',
            borderColor: 'border.subtle',
            width: '100%'
        },
        dashed: {
            borderStyle: 'dashed'
        },
        solid: {
            borderStyle: 'solid'
        }
    }, forms: {
        input: inputTheme,
        switch: {
            backgroundColor: 'surface.neutral.default',
            'input ~ & + span': {
                color: 'text.default',
                variant: 'text.textSmMedium',
                marginLeft: 'spacing-8'
            },
            'input ~ & + span:empty': {
                display: 'none'
            },
            'input:hover ~ &': {
                backgroundColor: 'surface.neutral.hover'
            },
            'input:checked:hover ~ &': {
                backgroundColor: 'primary.600'
            },
            'input:checked ~ &': {
                backgroundColor: 'surface.primary.active',
                ':hover': {
                    backgroundColor: 'primary.600'
                }
            },
            'input:disabled ~ &, input:disabled:checked ~ &': {
                backgroundColor: 'surface.controls.disabled',
                opacity: '100%'
            },
            'input:disabled ~ & + span': {
                color: 'text.disabled',
                cursor: 'not-allowed'
            },
            sizes: {
                small: {
                    width: '32px',
                    height: '16px',
                    'input ~ & + span': {
                        variant: 'text.textXsMedium'
                    },
                    'input:checked ~ &': {
                        '> div': {
                            transform: 'translateX(130%)'
                        }
                    },
                    div: {
                        width: '12px',
                        height: '12px'
                    }
                },
                medium: {
                    width: '40px',
                    height: '20px',
                    'input ~ & + span': {
                        variant: 'text.textSmRegular'
                    },
                    'input:checked ~ &': {
                        '> div': {
                            transform: 'translateX(120%)'
                        }
                    },
                    div: {
                        width: '16px',
                        height: '16px'
                    }
                },
                large: {
                    width: '40px',
                    height: '24px',
                    'input ~ & + span': {
                        variant: 'text.textMdRegular'
                    },
                    'input:checked ~ &': {
                        '> div': {
                            transform: 'translateX(80%)'
                        }
                    },
                    div: {
                        width: '20px',
                        height: '20px'
                    }
                }
            }
        },
        select: selectTheme,
        statusIndicator: {
            dot: {
                custom: {
                    background: 'icon.primary',
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    margin: 0
                },
                success: {
                    background: 'icon.success',
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    margin: 0
                },
                info: {
                    background: 'icon.info',
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    margin: 0
                },
                alert: {
                    background: 'icon.danger',
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    margin: 0
                },
                warning: {
                    background: 'icon.warning',
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    margin: 0
                },
                neutral: {
                    background: 'icon.low',
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    margin: 0
                },
                disabled: {
                    background: 'icon.disabled',
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    margin: 0
                }
            },
            differential: {
                up: {
                    fontSize: 2,
                    color: 'icon.success'
                },
                down: {
                    fontSize: 2,
                    color: 'icon.danger'
                }
            }
        },
        search: {
            padding: '10px',
            borderColor: 'border.neutral.default',
            backgroundColor: 'whitesmoke',
            '&:focus': {
                borderColor: 'border.neutral.active',
                boxShadow: 'none'
            }
        },
        checkbox: {
            default: {
                display: 'inline-flex',
                '& > input:focus-visible + svg': __assign(__assign({}, defaultInputFocus['&:focus-visible']), { outlineOffset: '-2px' })
            },
            checked: {
                color: 'surface.primary.active'
            },
            indeterminate: {
                color: 'surface.primary.active'
            },
            unchecked: {
                color: 'surface.neutral.default'
            },
            disabled: {
                color: 'surface.controls.disabled'
            },
            hovered: {
                color: 'surface.neutral.hover'
            },
            sizes: {
                large: {
                    width: '24px',
                    height: '24px'
                },
                medium: {
                    width: '20px',
                    height: '20px'
                },
                small: {
                    width: '16px',
                    height: '16px'
                }
            }
        },
        radio: {
            default: {
                display: 'inline-flex',
                '& > input:focus-visible + svg': __assign(__assign({}, defaultInputFocus['&:focus-visible']), { outlineOffset: '-2px' })
            },
            checked: {
                color: 'surface.primary.active'
            },
            unchecked: {
                color: 'surface.neutral.default'
            },
            disabled: {
                color: 'surface.controls.disabled'
            },
            hovered: {
                color: 'surface.neutral.hover'
            },
            sizes: {
                large: {
                    width: '24px',
                    height: '24px'
                },
                medium: {
                    width: '20px',
                    height: '20px'
                },
                small: {
                    width: '16px',
                    height: '16px'
                }
            }
        }
    }, drawer: {
        header: {
            default: {
                container: {
                    padding: 'spacing-32',
                    paddingBottom: 'spacing-16',
                    flexShrink: 0
                },
                topContentContainer: {
                    display: 'flex',
                    alignItems: 'center'
                },
                topContentTitleContainer: {
                    display: 'flex',
                    alignItems: 'center',
                    flex: 1
                },
                backButton: {
                    fontSize: 4,
                    marginRight: 'spacing-8',
                    marginLeft: '-8px'
                },
                closeButton: {
                    fontSize: 4,
                    marginRight: '-8px'
                },
                topContentTitle: {
                    fontWeight: 'medium'
                },
                titleContainer: {
                    marginY: 'spacing-16',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                },
                title: {
                    fontWeight: 'medium'
                }
            }
        },
        content: {
            default: {
                container: {
                    padding: 'spacing-32',
                    paddingTop: 'spacing-8',
                    overflow: 'auto',
                    flex: 1,
                    width: '100%'
                }
            }
        },
        actions: {
            default: {
                container: {
                    display: 'flex',
                    flexShrink: 0,
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    paddingX: 'spacing-32',
                    paddingY: 'spacing-8',
                    border: '1px solid',
                    borderColor: 'border.subtle',
                    minHeight: '56px'
                }
            }
        }
    } }, modalTheme), inlineNotificationTheme), styles), toastTheme), fileStatusCardTheme), progressBarTheme));
var useLMTheme = useThemeUI;
var getThemeProp = get;
var getFromTheme = function (prop) { return function (t) { return getThemeProp(t, prop); }; };
var getFontSizeValue = function (index) { return theme.fontSizes[index]; };

var LMThemeProvider = function LMThemeProvider(props) {
    var children = props.children, themeOverrides = props.themeOverrides;
    var theme$1 = React__default.useMemo(function () { return merge(theme, themeOverrides || {}); }, [themeOverrides]);
    return jsx(ThemeProvider, __assign({ theme: theme$1 }, { children: children }));
};
var LMThemeProvider$1 = React__default.memo(LMThemeProvider);

var withDefaultStylePropsCoreHOC = function (passReference) {
    return function (Component, defaultStyleProps) {
        return React__default.forwardRef(function WithDefaultStyleProps(props, ref) {
            var styleProps = React__default.useMemo(function () { return (props.styleProps ? __assign(__assign({}, defaultStyleProps), props.styleProps) : defaultStyleProps); }, [props.styleProps]);
            if (styleProps === undefined) {
                return jsx(Component, __assign({ ref: passReference ? ref : undefined }, props));
            }
            return jsx(Component, __assign({ ref: passReference ? ref : undefined }, props, { styleProps: styleProps }));
        });
    };
};
var withDefaultStyleProps = withDefaultStylePropsCoreHOC(true);
var withDefaultStylePropsNoRef = withDefaultStylePropsCoreHOC(false);

var buildLMComponent = function (renderFn, defaultStyleProps) {
    var Component;
    if (renderFn.length > 1) {
        var forwardedComponent = React__default.forwardRef(renderFn);
        Component = withDefaultStyleProps(forwardedComponent, defaultStyleProps);
    }
    else
        Component = withDefaultStylePropsNoRef(renderFn, defaultStyleProps);
    Component.displayName = renderFn.name;
    return Component;
};
function makeLMStyles(styleFn) {
    function useStyles(props) {
        return React__default.useMemo(function () { return styleFn(props); }, [props]);
    }
    return useStyles;
}

var Button = buildLMComponent(function Button(props, ref) {
    var children = props.children, rightIcon = props.rightIcon, leftIcon = props.leftIcon, styleProps = props.styleProps, _a = props.variant, variant = _a === void 0 ? 'primary' : _a, _b = props.size, size = _b === void 0 ? 'medium' : _b, _c = props.disabled, disabled = _c === void 0 ? false : _c, rest = __rest(props, ["children", "rightIcon", "leftIcon", "styleProps", "variant", "size", "disabled"]);
    var theme = useLMTheme().theme;
    var className = '';
    if (children === undefined && (rightIcon !== undefined || leftIcon !== undefined)) {
        className = 'onlyIcon';
    }
    return (jsxs(Button$1, __assign({ ref: ref, variant: "buttons.".concat(variant), className: className, sx: __assign(__assign({}, getThemeProp(theme, "buttons.sizes.".concat(size))), styleProps), disabled: disabled }, rest, { children: [leftIcon, children !== undefined && jsx("span", { children: children }), rightIcon] })));
});

var Badge = buildLMComponent(function Badge(props, ref) {
    var label = props.label, styleProps = props.styleProps, _a = props.variant, variant = _a === void 0 ? 'beta' : _a, rest = __rest(props, ["label", "styleProps", "variant"]);
    return (jsx(Badge$1, __assign({ ref: ref, variant: "badges.".concat(variant), sx: __assign({}, styleProps) }, rest, { children: label })));
});

var defaultStyleProps$1 = {
    position: 'relative'
};
var Box = buildLMComponent(function Box(props, ref) {
    var styleProps = props.styleProps, rest = __rest(props, ["styleProps"]);
    return jsx(Box$1, __assign({ ref: ref }, rest, { sx: styleProps }));
}, defaultStyleProps$1);

var PopoverContext = React__default.createContext(null);

/**
 * Floating UI Popover custom hook
 * @returns Popover props + event interactions
 */
var usePopover = function (props) {
    var id = props.id, strategy = props.strategy, _a = props.placement, placement = _a === void 0 ? 'bottom' : _a, _b = props.modal, modal = _b === void 0 ? false : _b, open = props.open, onOpenChange = props.onOpenChange, _c = props.autoClick, autoClick = _c === void 0 ? false : _c, _d = props.offsetValue, offsetValue = _d === void 0 ? 5 : _d, _e = props.navigation, navigation = _e === void 0 ? false : _e, _f = props.virtualNavigation, virtualNavigation = _f === void 0 ? false : _f, _g = props.typeahead, navigationTypeAheadEnabled = _g === void 0 ? true : _g, _h = props.useReferenceWidth, useReferenceWidth = _h === void 0 ? false : _h, propsActiveIndex = props.activeIndex, onActiveIndexChange = props.onActiveIndexChange;
    // Keep the custom middlewares.
    var middlewares = [];
    // The options (popover) min-width matches the input (target) width.
    if (useReferenceWidth) {
        middlewares.push(size({
            apply: function (_a) {
                var rects = _a.rects, elements = _a.elements;
                Object.assign(elements.floating.style, {
                    minWidth: "".concat(rects.reference.width, "px")
                });
            }
        }));
    }
    var data = useFloating({
        placement: placement,
        strategy: strategy,
        open: open,
        onOpenChange: onOpenChange,
        whileElementsMounted: autoUpdate,
        middleware: __spreadArray([
            offset(offsetValue),
            flip({
                crossAxis: placement.includes('-'),
                fallbackAxisSideDirection: 'end',
                padding: 5
            }),
            shift()
        ], middlewares, true)
    });
    var context = data.context;
    // Keep track of the option elements
    var optionsRef = React__default.useRef([]);
    // Keep track of the option labels
    var labelsRef = React__default.useRef([]);
    // Keep track of the active index.
    var _j = useState(null), activeIndex = _j[0], setActiveIndex = _j[1];
    var handleActiveIndexChange = React__default.useCallback(function (index) {
        setActiveIndex(index);
        onActiveIndexChange && onActiveIndexChange(index);
    }, [onActiveIndexChange]);
    // Focus the first option when the navigation is enabled and was initially disabled.
    var initiallyDisabled = React__default.useRef(!navigation);
    React__default.useEffect(function () {
        if (initiallyDisabled.current && navigation) {
            handleActiveIndexChange(0);
            initiallyDisabled.current = false;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navigation]);
    React__default.useEffect(function () {
        if (propsActiveIndex !== undefined)
            setActiveIndex(propsActiveIndex);
    }, [propsActiveIndex]);
    // Handle keyboard navigation.
    var listNavigation = useListNavigation(context, {
        listRef: optionsRef,
        activeIndex: activeIndex,
        onNavigate: handleActiveIndexChange,
        enabled: navigation,
        virtual: virtualNavigation
    });
    // Handle typeahead navigation.
    var typeahead = useTypeahead(context, {
        listRef: labelsRef,
        activeIndex: activeIndex,
        onMatch: handleActiveIndexChange,
        enabled: navigation && navigationTypeAheadEnabled
    });
    var click = useClick(context, { enabled: autoClick }); // { enabled: true } property enables an embedded onClick event, which adds a second onClick event that collides with the provided one. Removing it defaults it to true.
    var dismiss = useDismiss(context);
    var role = useRole(context);
    var interactions = useInteractions([typeahead, listNavigation, click, dismiss, role]);
    return React__default.useMemo(function () { return (__assign(__assign(__assign({ id: id, open: open, onOpenChange: onOpenChange }, interactions), data), { modal: modal, optionsRef: optionsRef, labelsRef: labelsRef, activeIndex: activeIndex, setActiveIndex: handleActiveIndexChange })); }, [id, open, onOpenChange, interactions, data, modal, optionsRef, labelsRef, activeIndex, handleActiveIndexChange]);
};
/**
 * @returns Popover context
 */
var usePopoverContext = function (propsContext) {
    if (propsContext === void 0) { propsContext = PopoverContext; }
    var context = React__default.useContext(propsContext);
    if (context == null) {
        throw new Error('Popover components must be wrapped in <Popover />');
    }
    return context;
};
var usePopoverItem = function (optionLabel) {
    var activeIndex = usePopoverContext(PopoverContext).activeIndex;
    var _a = useListItem({ label: optionLabel }), ref = _a.ref, index = _a.index;
    return { activeIndex: activeIndex, ref: ref, index: index };
};

/**
 * @returns top level Popover
 */
var Popover = buildLMComponent(function Popover(_a) {
    var children = _a.children, _b = _a.modal, modal = _b === void 0 ? false : _b, restOptions = __rest(_a, ["children", "modal"]);
    var popover = usePopover(__assign({ modal: modal }, restOptions));
    return jsx(PopoverContext.Provider, __assign({ value: popover }, { children: children }));
});
/**
 * @returns Element that opens the Popover component when clicked
 */
var PopoverTrigger = buildLMComponent(function PopoverTrigger(_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var context = usePopoverContext(PopoverContext);
    var childrenRef = children.ref;
    var ref = useMergeRefs$1([context.refs.setReference, childrenRef]);
    return React.cloneElement(children, context.getReferenceProps(__assign(__assign(__assign({ ref: ref }, props), children.props), { 'data-state': context.open ? 'open' : 'closed' })));
});
/**
 * Content of the Popover once open
 * @returns Box element with portal and focus management config
 */
var PopoverContent = buildLMComponent(function PopoverContent(_a, propRef) {
    var styleProps = _a.styleProps, disableFocusManagement = _a.disableFocusManagement, returnFocus = _a.returnFocus, props = __rest(_a, ["styleProps", "disableFocusManagement", "returnFocus"]);
    var _b = usePopoverContext(PopoverContext), floatingContext = _b.context, context = __rest(_b, ["context"]);
    var ref = useMergeRefs$1([context.refs.setFloating, propRef]);
    if (!floatingContext.open)
        return null;
    return (jsx(FloatingPortal, __assign({ id: context.id }, { children: jsx(FloatingFocusManager, __assign({ context: floatingContext, modal: context.modal, disabled: disableFocusManagement, initialFocus: -1, returnFocus: returnFocus }, { children: jsx(Box, __assign({ ref: ref, styleProps: __assign(__assign({}, context.floatingStyles), styleProps) }, context.getFloatingProps(props), { children: props.children })) })) })));
});
var PopoverListContext = React.createContext({});
var PopoverListComponent = function (props) {
    var _a = usePopoverContext(PopoverContext), optionsRef = _a.optionsRef, labelsRef = _a.labelsRef;
    var popoverListContext = {
        onOptionSelected: props.onOptionSelected
    };
    return (jsx(PopoverListContext.Provider, __assign({ value: popoverListContext }, { children: jsx(FloatingList, __assign({ elementsRef: optionsRef, labelsRef: labelsRef }, { children: props.children })) })));
};
var PopoverList = buildLMComponent(PopoverListComponent);
var PopoverItem = buildLMComponent(function PopoverItem(props, propsRef) {
    var label = props.label, children = props.children, selected = props.selected, styleProps = props.styleProps, rest = __rest(props, ["label", "children", "selected", "styleProps"]);
    var optionLabel = label || (typeof children === 'string' ? children : null);
    var _a = usePopoverItem(optionLabel), activeIndex = _a.activeIndex, ref = _a.ref, index = _a.index;
    var mergedRef = useMergeRefs$1([ref, propsRef]);
    var isActive = index === activeIndex;
    return (jsx(Box, __assign({ ref: mergedRef, tabIndex: isActive ? 0 : -1, styleProps: __assign({ backgroundColor: selected ? 'alpha.primary.100' : '' }, styleProps) }, rest, { children: children })));
});

var MenuTrigger = buildLMComponent(function MenuTrigger(props) {
    return jsx(PopoverTrigger, __assign({}, props));
});

var Typography = buildLMComponent(function Typography(props, ref) {
    var align = props.align, _a = props.as, as = _a === void 0 ? 'p' : _a, variant = props.variant, styleProps = props.styleProps, id = props.id, rest = __rest(props, ["align", "as", "variant", "styleProps", "id"]);
    var theme = useLMTheme().theme;
    var variantKey = variant ? variant : as.toString();
    var variantExists = !!get(theme, "text.".concat(variantKey));
    return (jsx(Text, __assign({ id: id, as: as, ref: ref, variant: variantExists ? variantKey : 'default', sx: __assign({ textAlign: align }, styleProps) }, rest)));
});

var useTimeout = function () {
    var timeoutId = React__default.useRef();
    var clear = React__default.useCallback(function () {
        if (timeoutId.current)
            clearTimeout(timeoutId.current);
    }, []);
    var run = React__default.useCallback(function (callback, delay) {
        clear();
        timeoutId.current = setTimeout(callback, delay);
    }, [clear]);
    React__default.useEffect(function () {
        return function () {
            clear();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return { run: run, clear: clear };
};

var tooltipStyles$2 = {
    padding: '8px 16px',
    borderRadius: 4
};

var ARROW_HEIGHT = 5;
var GAP = 4;
var TRANSITION_DURATION = 150;
var DEFAULT_DELAY = 500;
var TooltipContent = buildLMComponent(function (props, ref) {
    var title = props.title, content = props.content, styleProps = props.styleProps, labelStyleProps = props.labelStyleProps, rest = __rest(props, ["title", "content", "styleProps", "labelStyleProps"]);
    var theme = useLMTheme().theme;
    var color = (styleProps === null || styleProps === void 0 ? void 0 : styleProps.backgroundColor) || getThemeProp(theme, 'colors.surface.neutral.strong');
    return (jsxs(Box, __assign({ role: 'tooltip-content', styleProps: __assign(__assign({ backgroundColor: color }, tooltipStyles$2), styleProps), ref: ref }, rest, { children: [title &&
                (typeof title === 'string' ? (jsx(Typography, __assign({ variant: "h6", as: "h6", styleProps: { whiteSpace: 'pre-line', labelStyleProps: labelStyleProps }, color: "white" }, { children: title }))) : (title)), typeof content === 'string' ? (jsx(Typography, __assign({ variant: "span", as: "span", styleProps: labelStyleProps, color: "white" }, { children: content }))) : (content)] })));
});
var Tooltip = buildLMComponent(function Tooltip(props) {
    var children = props.children, title = props.title, content = props.content, _a = props.placement, placement = _a === void 0 ? 'top' : _a, styleProps = props.styleProps, labelStyleProps = props.labelStyleProps, _b = props.arrow, arrow$1 = _b === void 0 ? true : _b, open = props.open, delay = props.delay, _c = props.offset, offset$1 = _c === void 0 ? GAP : _c, portalRef = props.portalRef, onOpen = props.onOpen, onClose = props.onClose, rest = __rest(props, ["children", "title", "content", "placement", "styleProps", "labelStyleProps", "arrow", "open", "delay", "offset", "portalRef", "onOpen", "onClose"]);
    var _d = React__default.useState(false), isOpen = _d[0], setIsOpen = _d[1];
    var _e = useTimeout(), run = _e.run, clear = _e.clear;
    var arrowRef = React__default.useRef(null);
    var theme = useLMTheme().theme;
    React__default.useEffect(function () {
        if (!isUndefined(open) && isOpen !== open)
            setIsOpen(open);
    }, [open, isOpen]);
    var handleClose = React__default.useCallback(function (event) {
        run(function () {
            setIsOpen(false);
            if (onClose && isOpen)
                onClose(event);
        }, 100);
    }, [isOpen, onClose, run]);
    var handleOpenChange = React__default.useCallback(function (open, event) {
        clear();
        open ? setIsOpen(open) : handleClose(event);
        if (onOpen && open && !isOpen)
            onOpen(event);
    }, [setIsOpen, onOpen, isOpen, handleClose, clear]);
    var handleEnter = React__default.useCallback(function (e) {
        handleOpenChange(true, e);
    }, [handleOpenChange]);
    var handleLeave = React__default.useCallback(function (e) {
        handleOpenChange(false, e);
    }, [handleOpenChange]);
    var _f = useFloating({
        placement: placement,
        open: !isUndefined(open) ? open : isOpen,
        onOpenChange: handleOpenChange,
        whileElementsMounted: autoUpdate,
        middleware: [
            offset(arrow$1 ? ARROW_HEIGHT + offset$1 : offset$1),
            arrow({
                element: arrowRef,
                padding: ARROW_HEIGHT + GAP
            }),
            flip({
                fallbackAxisSideDirection: 'start',
                padding: arrow$1 ? ARROW_HEIGHT + offset$1 : offset$1
            })
        ]
    }), refs = _f.refs, floatingStyles = _f.floatingStyles, context = _f.context, computedPlacement = _f.placement;
    var _g = useTransitionStyles(context, {
        duration: TRANSITION_DURATION
    }), isMounted = _g.isMounted, styles = _g.styles;
    // Configure the delay for opening and closing separately.
    var hoverConfig = {
        delay: {
            open: delay === true ? DEFAULT_DELAY : delay ? delay : 0,
            close: 0
        }
    };
    var hover = useHover(context, hoverConfig);
    var role = useRole(context, { role: 'tooltip' });
    var _h = useInteractions([hover, role]), getReferenceProps = _h.getReferenceProps, getFloatingProps = _h.getFloatingProps;
    var arrowStyles = React__default.useMemo(function () {
        // This is ensuring the style of the arrow when the placement is changed from the initial one
        if (computedPlacement.includes('right')) {
            return { left: undefined };
        }
        else if (computedPlacement.includes('left')) {
            return { right: undefined };
        }
        else if (computedPlacement.includes('top')) {
            return { bottom: undefined };
        }
        else if (computedPlacement.includes('bottom')) {
            return { top: undefined };
        }
    }, [computedPlacement]);
    var color = (styleProps === null || styleProps === void 0 ? void 0 : styleProps.backgroundColor) || getThemeProp(theme, 'colors.surface.neutral.strong');
    return (jsxs(Fragment, { children: [React__default.cloneElement(children, __assign({ ref: refs.setReference }, getReferenceProps())), isMounted && (jsx(FloatingPortal, __assign({ root: portalRef }, { children: jsxs(Box, __assign({ ref: refs.setFloating }, rest, { styleProps: __assign(__assign(__assign({}, styles), floatingStyles), { zIndex: 'tooltip' }) }, getFloatingProps(), { onMouseEnter: handleEnter, onMouseLeave: handleLeave }, { children: [arrow$1 && (jsx(FloatingArrow, { ref: arrowRef, context: context, height: ARROW_HEIGHT, fill: color, style: __assign({}, arrowStyles), name: "tooltipArrow" })), jsx(TooltipContent, { title: title, content: content, styleProps: styleProps, labelStyleProps: labelStyleProps })] })) })))] }));
});

var MenuContext = React__default.createContext({});

var useMenuContext = function () { return React__default.useContext(MenuContext); };
var useMenuItem = function (value) {
    var context = useMenuContext();
    var registerOption = context.registerOption, unregisterOption = context.unregisterOption, isValueDisplayed = context.isValueDisplayed;
    var displayed = React__default.useMemo(function () { return isValueDisplayed(value); }, [isValueDisplayed, value]);
    React__default.useEffect(function () {
        var valueToRegister = value;
        registerOption(valueToRegister);
        return function () { return unregisterOption(valueToRegister); };
    }, [registerOption, unregisterOption, value]);
    return __assign(__assign({}, context), { displayed: displayed });
};

var SvgIcon = buildLMComponent(function SvgIcon(props, ref) {
    var _a = props.color, color = _a === void 0 ? 'icon.default' : _a, title = props.title, _b = props.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, children = props.children, styleProps = props.styleProps, Component = props.Component, rest = __rest(props, ["color", "title", "viewBox", "children", "styleProps", "Component"]);
    var hasSvgAsChild = React__default.isValidElement(children) && children.type === 'svg';
    var SvgComponent = Component ? Component : 'svg';
    return (jsxs(SvgComponent, __assign({ "aria-hidden": title ? undefined : true, role: title ? 'img' : undefined, viewBox: viewBox, width: '1em', height: '1em', strokeWidth: 1.5, fontSize: 24, fill: hasSvgAsChild ? undefined : 'currentColor', display: 'inline-block' }, rest, { sx: __assign({ color: color, flexShrink: 0 }, styleProps) }, (hasSvgAsChild ? children.props : {}), { ref: ref }, { children: [title && jsx("title", { children: title }), hasSvgAsChild ? children.props.children : children] })));
});

function createSvgIcon(path, displayName, additionalProps) {
    var styles = (additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.styleProps) || {};
    function Component(props, ref) {
        var styleProps = props.styleProps, rest = __rest(props, ["styleProps"]);
        return (jsx(SvgIcon, __assign({ "data-testid": "".concat(displayName, "Icon"), ref: ref }, additionalProps, { styleProps: __assign(__assign({}, styles), styleProps) }, rest, { children: path })));
    }
    Component.displayName = "".concat(displayName, "Icon");
    return React__default.memo(React__default.forwardRef(Component));
}

var XOutline = createSvgIcon([jsx("path", { stroke: "none", d: "M0 0h24v24H0z" }, "0"), jsx("path", { d: "M18 6 6 18M6 6l12 12" }, "1")], 'XOutline', {
    stroke: 'currentColor',
    strokeLinecap: 'round',
    strokeWidth: '1.5',
    fill: 'none',
    viewBox: '0 0 24 24'
});

var useStyles$3 = makeLMStyles(function (props) { return ({
    filterButtonStyles: __assign({ display: 'flex', minWidth: 'fit-content', flexDirection: 'row', '&:not(:disabled):active': {
            border: '1px solid',
            borderColor: 'border.primary',
            background: 'surface.primarySubtle.active'
        } }, ((props === null || props === void 0 ? void 0 : props.isPressed)
        ? {
            border: '1px solid',
            borderColor: 'border.primary',
            background: 'surface.primarySubtle.active'
        }
        : {})),
    infoBadgeStyles: {
        background: 'surface.primary.default'
    },
    tooltipStyles: {
        listStyleType: 'none',
        margin: 0,
        padding: 0
    },
    tooltipValueStyles: {
        color: 'text.invert'
    },
    closeIconStyles: {
        width: '16px !important',
        height: '16px !important',
        cursor: 'pointer'
    }
}); });

var FilterButton = buildLMComponent(function FilterButton(props, ref) {
    var filterName = props.filterName, propsSelectedValues = props.selectedValues, isPressed = props.isPressed, onClose = props.onClose, _a = props.displayCloseButton, displayCloseButton = _a === void 0 ? true : _a, rest = __rest(props, ["filterName", "selectedValues", "isPressed", "onClose", "displayCloseButton"]);
    var _b = useMenuContext(), contextSelectedValues = _b.selectedValues, openContext = _b.open, renderValue = _b.renderValue, onClear = _b.onClear;
    var selectedValues = React__default.useMemo(function () { return (propsSelectedValues ? propsSelectedValues : contextSelectedValues); }, [contextSelectedValues, propsSelectedValues]);
    var open = React__default.useMemo(function () { return (isPressed !== undefined ? isPressed : openContext); }, [isPressed, openContext]);
    var styles = useStyles$3({ isPressed: open });
    var handleClose = useCallback(function (e) {
        e.stopPropagation();
        onClear && onClear();
        onClose && onClose();
    }, [onClose, onClear]);
    return (jsx(MenuTrigger, { children: jsx(Button, __assign({}, rest, { ref: ref, variant: 'tertiary', styleProps: __assign(__assign({}, styles.filterButtonStyles), rest === null || rest === void 0 ? void 0 : rest.styleProps), rightIcon: selectedValues.length > 0 && displayCloseButton ? (jsx(XOutline, { styleProps: styles.closeIconStyles, onClick: handleClose })) : undefined }, { children: jsx(Typography, __assign({ variant: 'textSmRegular', as: "span", styleProps: { fontWeight: '400 !important' } }, { children: selectedValues.length > 1 ? (jsxs(Fragment, { children: [filterName + ' · ', jsx(Tooltip, __assign({ placement: "bottom", content: jsx(Box, __assign({ as: 'ul', styleProps: styles.tooltipStyles }, { children: selectedValues.map(function (value, index) { return (jsx(Typography, __assign({ as: 'li', variant: "textXsRegular", styleProps: styles.tooltipValueStyles }, { children: value }), index)); }) })) }, { children: jsx(Badge, { label: selectedValues.length.toString(), styleProps: styles.infoBadgeStyles }) }))] })) : (jsxs(Fragment, { children: [filterName, selectedValues.length !== 0 ? (jsx(Fragment, { children: jsxs(Typography, __assign({ as: 'span', variant: 'textSmMedium' }, { children: [' ', "\u00B7 ", renderValue ? renderValue(selectedValues[0]) : selectedValues[0]] })) })) : null] })) })) })) }));
});

var ChevronLeftOutline = createSvgIcon([jsx("path", { stroke: "none", d: "M0 0h24v24H0z" }, "0"), jsx("path", { d: "m15 6-6 6 6 6" }, "1")], 'ChevronLeftOutline', {
    stroke: 'currentColor',
    strokeLinecap: 'round',
    strokeWidth: '1.5',
    fill: 'none',
    viewBox: '0 0 24 24'
});

var ChevronRightOutline = createSvgIcon([jsx("path", { stroke: "none", d: "M0 0h24v24H0z" }, "0"), jsx("path", { d: "m9 6 6 6-6 6" }, "1")], 'ChevronRightOutline', {
    stroke: 'currentColor',
    strokeLinecap: 'round',
    strokeWidth: '1.5',
    fill: 'none',
    viewBox: '0 0 24 24'
});

var useStyles$2 = makeLMStyles(function () { return ({
    filterBarComponent: {
        display: 'flex',
        alignItems: 'center',
        padding: '12px 48px',
        background: 'white',
        maxWidth: '1440px',
        maxHeight: '64px'
    },
    leftShadowContainer: {
        background: 'linear-gradient(90deg, #FFF 8.22%, rgba(255, 255, 255, 0.00) 99.67%)',
        width: '200px',
        content: '""',
        opacity: 1,
        top: 0,
        bottom: 0,
        left: 0,
        zIndex: 1,
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center'
    },
    rightShadowContainer: {
        background: 'linear-gradient(90deg, rgba(255, 255, 255, 0) -7.64%, #FFF 83.8%)',
        width: '200px',
        content: '""',
        opacity: 1,
        top: 0,
        bottom: 0,
        right: 0,
        position: 'absolute',
        zIndex: 1,
        pointerEvents: 'none',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center'
    },
    filterBarFilterContainer: {
        display: 'flex',
        gap: '8px',
        width: '100%',
        overflowX: 'auto',
        '&::-webkit-scrollbar': {
            display: 'none'
        }
    },
    filterBarFilterButtons: {},
    filterBarRightButtons: {
        display: 'flex',
        gap: 'spacing-8',
        marginLeft: 'spacing-24',
        minWidth: 'fit-content'
    },
    filterBarFilters: {
        display: 'flex'
    },
    applyButton: {
        minWidth: 'fit-content'
    },
    clearFiltersButton: {
        minWidth: 'fit-content',
        border: 'none',
        '&:hover, &:not(:disabled):active': {
            border: 'none'
        }
    },
    chevronStyles: {
        pointerEvents: 'all',
        cursor: 'pointer',
        '&:hover': {
            opacity: 0.6
        }
    }
}); });

var FilterBar = buildLMComponent(function FilterBar(props, ref) {
    var children = props.children, handleApply = props.handleApply, handleClear = props.handleClear, applyLabel = props.applyLabel, clearLabel = props.clearLabel, rest = __rest(props, ["children", "handleApply", "handleClear", "applyLabel", "clearLabel"]);
    var _a = React__default.useState(false), isLeftShadowVisible = _a[0], setIsLeftShadowVisible = _a[1];
    var _b = React__default.useState(false), isRightShadowVisible = _b[0], setIsRightShadowVisible = _b[1];
    var filterBtnsContainerRef = React__default.useRef(null);
    var styles = useStyles$2();
    var handleScroll = function () {
        setIsLeftShadowVisible(filterBtnsContainerRef.current.scrollLeft !== 0);
        setIsRightShadowVisible(!(filterBtnsContainerRef.current.scrollLeft + filterBtnsContainerRef.current.offsetWidth >= filterBtnsContainerRef.current.scrollWidth));
    };
    React__default.useEffect(function () {
        handleScroll();
    }, []);
    var handleChevronClick = function (direction) {
        var scrollAmount = direction === 'right' ? 300 : -300;
        filterBtnsContainerRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    };
    return (jsxs(Box, __assign({ ref: ref }, rest, { styleProps: __assign(__assign({}, styles.filterBarComponent), rest === null || rest === void 0 ? void 0 : rest.styleProps) }, { children: [jsxs(Box, { children: [isLeftShadowVisible && (jsx(Box, __assign({ styleProps: styles.leftShadowContainer }, { children: jsx(ChevronLeftOutline, { "data-testid": 'left-chevron', styleProps: styles.chevronStyles, onClick: function () { return handleChevronClick('left'); } }) }))), isRightShadowVisible && (jsx(Box, __assign({ styleProps: styles.rightShadowContainer }, { children: jsx(ChevronRightOutline, { "data-testid": 'right-chevron', styleProps: styles.chevronStyles, onClick: function () { return handleChevronClick('right'); } }) }))), jsx(Box, __assign({ "data-testid": 'filter-bar-container', ref: filterBtnsContainerRef, styleProps: styles.filterBarFilterContainer, onScroll: handleScroll }, { children: children }))] }), jsxs(Box, __assign({ styleProps: styles.filterBarRightButtons }, { children: [jsx(Button, __assign({ styleProps: styles.applyButton, onClick: handleApply }, { children: applyLabel || 'Apply' })), jsx(Button, __assign({ variant: 'tertiary', styleProps: styles.clearFiltersButton, onClick: handleClear }, { children: clearLabel || 'Clear filters' }))] }))] })));
});

var TabsContext = React__default.createContext(null);

var Tab = buildLMComponent(function Tab(props, ref) {
    var label = props.label, _a = props.size, size = _a === void 0 ? 'medium' : _a, _b = props.disabled, disabled = _b === void 0 ? false : _b, _c = props.active, activeProp = _c === void 0 ? false : _c, icon = props.icon, _d = props.iconPosition, iconPosition = _d === void 0 ? 'left' : _d, onClick = props.onClick, styleProps = props.styleProps, labelStyleProps = props.labelStyleProps, value = props.value;
    var theme = useLMTheme().theme;
    var context = React__default.useContext(TabsContext);
    var active = React__default.useMemo(function () { return activeProp || (!isUndefined(value) && (context === null || context === void 0 ? void 0 : context.value) === value); }, [context, value, activeProp]);
    var status = React__default.useMemo(function () { return (disabled ? 'disabled' : active ? 'active' : 'default'); }, [active, disabled]);
    var iconClass = React__default.useMemo(function () { return (icon && !label) ? 'onlyIcon' : ''; }, [icon, label]);
    var styledIcon = icon ? React__default.cloneElement(icon, { className: "".concat(icon.props.className || '', " tabsIcon").trim() }) : null;
    var handleClick = React__default.useCallback(function (ev) {
        if (context && !isUndefined(value))
            context.onSelected(value);
        if (onClick)
            onClick(ev);
    }, [context, onClick, value]);
    return (jsx("button", __assign({ ref: ref, className: iconClass, sx: __assign(__assign(__assign(__assign({}, getThemeProp(theme, "tabs.button")), getThemeProp(theme, "tabs.sizes.".concat(size))), getThemeProp(theme, "tabs.status.".concat(status))), styleProps), role: "tab", "aria-selected": active, disabled: disabled, onClick: handleClick }, { children: jsxs(Typography, __assign({ as: 'span', styleProps: __assign(__assign(__assign(__assign({}, getThemeProp(theme, "tabs.label")), getThemeProp(theme, "tabs.sizes.".concat(size, ".tabLabel"))), getThemeProp(theme, "tabs.status.".concat(status))), labelStyleProps) }, { children: [iconPosition == 'left' ? styledIcon : null, label, iconPosition == 'right' ? styledIcon : null] })) })));
});

var Link = buildLMComponent(function Link(props, ref) {
    var styleProps = props.styleProps, children = props.children, href = props.href, target = props.target, _a = props.as, as = _a === void 0 ? 'a' : _a, _b = props.variant, variant = _b === void 0 ? 'default' : _b, rest = __rest(props, ["styleProps", "children", "href", "target", "as", "variant"]);
    var linkProps = { href: href, target: target };
    return (jsx(Typography, __assign({ ref: ref }, linkProps, { as: as, variant: variant, role: "link", styleProps: __assign({ variant: 'links.default' }, styleProps) }, rest, { children: children })));
});

var Avatar = buildLMComponent(function Avatar(props, ref) {
    var src = props.src, _a = props.variant, variant = _a === void 0 ? 'rounded' : _a, styleProps = props.styleProps, _b = props.border, border = _b === void 0 ? true : _b, _c = props.size, size = _c === void 0 ? 'large' : _c, rest = __rest(props, ["src", "variant", "styleProps", "border", "size"]);
    return (jsx(Avatar$1, __assign({ ref: ref, src: src, variant: "avatar.".concat(variant), sx: __assign({ border: !border ? 'none' : undefined, width: "avatar.".concat(size), height: "avatar.".concat(size) }, styleProps) }, rest)));
});

var Divider = buildLMComponent(function Divider(props, ref) {
    var _a = props.variant, variant = _a === void 0 ? 'solid' : _a, _b = props.orientation, orientation = _b === void 0 ? 'vertical' : _b, styleProps = props.styleProps, rest = __rest(props, ["variant", "orientation", "styleProps"]);
    var theme = useLMTheme().theme;
    return (jsx(Divider$1, __assign({ ref: ref, sx: __assign(__assign(__assign({}, get(theme, "divider.".concat(variant))), get(theme, "divider.".concat(orientation))), styleProps) }, rest)));
});

var defaultMetric = {
    threshold: 1000,
    showDecimalIfInteger: false
};
var currencySymbols = {
    EUR: '€',
    USD: '$',
    GBP: '£',
    JPY: '¥',
    CNY: '¥'
};
var ranges = [
    {
        divider: 1e6,
        suffix: 'M',
        decimal: 1
    },
    {
        divider: 1e3,
        suffix: 'K',
        decimal: 0
    }
];
var toMetric = function (value, _a) {
    var _b = _a === void 0 ? defaultMetric : _a, decimals = _b.decimals, _c = _b.threshold, threshold = _c === void 0 ? 1000 : _c, showDecimalIfInteger = _b.showDecimalIfInteger;
    var n = value;
    var numberRange = ranges.find(function (range) { return n >= range.divider; });
    if (n < threshold || !numberRange) {
        if (n % 1 === 0) {
            if (showDecimalIfInteger) {
                return n.toFixed(decimals);
            }
            return n.toString();
        }
        return n.toFixed(decimals);
    }
    var choosenDecimals = decimals === undefined ? numberRange.decimal : decimals;
    var parsedNumber = n / numberRange.divider;
    return parsedNumber.toFixed(choosenDecimals) + numberRange.suffix;
};
var toCurrencyDefaultParams = {
    currency: 'EUR',
    baseCurrency: 'EUR',
    currencyPosition: 'end'
};
var toCurrency = function (n, customParams) {
    // This method could also convert the values in the future. For now it only display the parsed value with the symbol requested
    var params = __assign(__assign({}, toCurrencyDefaultParams), customParams);
    var value = toMetric(n, params.metricParams);
    var symbol = currencySymbols[params.currency];
    return params.currencyPosition === 'start' ? "".concat(symbol).concat(value) : "".concat(value).concat(symbol);
};
var useNumberFormatter = function () {
    return { toMetric: toMetric, toCurrency: toCurrency };
};

var InfoOutlined = createSvgIcon(jsx("path", { fill: "currentColor", d: "M11 7H13V9H11V7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" }), 'InfoOutlined');

var defaultStyleProps = {
    display: 'flex',
    width: '100%',
    minHeight: 0
};
var firstSectionStyle = {
    minWidth: '20%',
    position: 'relative',
    padding: '0px 0px 40px 0'
};
var sectionStyle = {
    display: 'flex',
    flex: 1,
    paddingTop: 0,
    paddingBottom: 30,
    position: 'relative'
};
var svgStyle = {
    position: 'relative',
    marginTop: 18,
    height: 'calc(100% - 18px)',
    width: '100%'
};
var labelStyle = {
    position: 'absolute',
    right: 12,
    color: 'text.subtle',
    display: 'flex',
    alignItems: 'center'
};
var percentageStyle = {
    fontWeight: 'medium',
    color: 'text.subtle'
};
var valueStyle = {
    textAlign: 'end',
    color: 'text.subtle'
};
var tooltipStyles$1 = {
    maxWidth: 200
};
var infoIconStyles$1 = {
    fontSize: 18,
    marginLeft: '4px'
};

// Add colors to support more than 4 sections showing
var defaultColors = ['primary.500', 'primary.400', 'primary.300', 'primary.200'];
var Funnel = buildLMComponent(function Funnel(props, ref) {
    var id = props.id, data = props.data, totalValue = props.totalValue, colors = props.colors, styleProps = props.styleProps, labelStyleProps = props.labelStyleProps, percentageStyleProps = props.percentageStyleProps, valueStyleProps = props.valueStyleProps, rest = __rest(props, ["id", "data", "totalValue", "colors", "styleProps", "labelStyleProps", "percentageStyleProps", "valueStyleProps"]);
    var toMetric = useNumberFormatter().toMetric;
    var theme = useLMTheme().theme;
    var funnelColors = React__default.useMemo(function () { return colors || defaultColors.map(function (color) { return get(theme, "colors.".concat(color)); }); }, [theme, colors]);
    var defaultColor = get(theme, 'colors.primary.500');
    var _a = React__default.useMemo(function () {
        var totalNumber = totalValue || Math.max.apply(Math, data.map(function (data) { return data.value; }));
        return {
            totalNumber: totalNumber,
            basePercentage: Math.ceil((data[0].value / totalNumber) * 100)
        };
    }, [data, totalValue]), totalNumber = _a.totalNumber, basePercentage = _a.basePercentage;
    var funnelSectionsProps = React__default.useMemo(function () {
        var baseOffset = Math.max(0, Math.floor((100 - basePercentage) / 2));
        var y0 = Math.min(50, baseOffset);
        var y3 = Math.max(50, 100 - baseOffset);
        var sectionProps = [];
        for (var i = 1; i < data.length; i++) {
            var percentage = Math.ceil((data[i].value / totalNumber) * 100);
            var offset = Math.max(0, Math.floor((100 - percentage) / 2));
            var y1 = Math.min(50, offset);
            var y2 = Math.max(50, 100 - offset);
            sectionProps.push({ y0: y0, y1: y1, y2: y2, y3: y3, percentage: percentage, label: data[i].label, value: data[i].value || 0, info: data[i].info });
            y0 = y1;
            y3 = y2;
        }
        return sectionProps;
    }, [data, totalNumber, basePercentage]);
    var displayLabelAndValue = React__default.useCallback(function (label, percentage, value, info) {
        return (jsxs(Fragment, { children: [jsxs(Typography, __assign({ variant: "caption", styleProps: __assign(__assign({}, labelStyle), labelStyleProps), id: "".concat(id, "-label") }, { children: [label, info && (jsx(Tooltip, __assign({ content: info, placement: "bottom", styleProps: tooltipStyles$1, id: "".concat(id, "-info") }, { children: jsx(InfoOutlined, { styleProps: infoIconStyles$1 }) })))] })), jsxs(Box, __assign({ sx: { position: 'absolute', right: 12, bottom: 0, textAlign: 'end' } }, { children: [jsxs(Typography, __assign({ variant: "caption", styleProps: __assign(__assign({}, percentageStyle), percentageStyleProps), id: "".concat(id, "-percentage") }, { children: [percentage, "%"] })), jsx(Typography, __assign({ variant: "caption", styleProps: __assign(__assign({}, valueStyle), valueStyleProps), id: "".concat(id, "-value") }, { children: toMetric(value) }))] }))] }));
    }, [labelStyleProps, id, percentageStyleProps, valueStyleProps, toMetric]);
    return (jsxs(Box, __assign({ styleProps: __assign({}, styleProps) }, rest, { ref: ref, id: id }, { children: [jsx(Box, __assign({ styleProps: firstSectionStyle }, { children: displayLabelAndValue(data[0].label, basePercentage, data[0].value, data[0].info) })), jsx(Divider, { variant: "dashed" }), funnelSectionsProps.map(function (props, index) {
                return (jsxs(React__default.Fragment, { children: [jsxs(Box, __assign({ styleProps: sectionStyle }, { children: [jsxs("svg", __assign({ viewBox: '0 0 100 100', preserveAspectRatio: "none", sx: svgStyle }, { children: [jsx("title", { children: "section_".concat(index) }), jsx("polygon", { fill: funnelColors[index] || defaultColor, points: "0,".concat(props.y0, " 100,").concat(props.y1, " 100,").concat(props.y2, " 0,").concat(props.y3), sx: { strokeWidth: 0 } })] })), displayLabelAndValue(props.label, props.percentage, props.value, props.info)] })), jsx(Divider, { variant: "dashed" })] }, "section_".concat(index)));
            })] })));
}, defaultStyleProps);

var TabsProvider = function (props) {
    var tabsProps = props.tabsProps, children = props.children;
    var value = tabsProps.value, onSelected = tabsProps.onSelected;
    return jsx(TabsContext.Provider, __assign({ value: { value: value, onSelected: onSelected } }, { children: children }));
};

var baseTabsStyleProps = {
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content'
};
var baseSeparatorProps = {
    width: 1,
    height: 16,
    backgroundColor: 'border.subtle',
    marginRight: '4px'
};

var Tabs = buildLMComponent(function Tabs(props, ref) {
    var value = props.value, onSelected = props.onSelected, children = props.children, styleProps = props.styleProps, rest = __rest(props, ["value", "onSelected", "children", "styleProps"]);
    return (jsx(TabsProvider, __assign({ tabsProps: { value: value, onSelected: onSelected } }, { children: jsx(Box, __assign({ ref: ref, sx: __assign(__assign({}, baseTabsStyleProps), styleProps) }, rest, { children: React__default.Children.map(children, function (child, index) {
                return (jsxs(Fragment, { children: [child, index !== React__default.Children.count(children) - 1 && jsx("div", { sx: baseSeparatorProps })] }));
            }) })) })));
});

var Profile = buildLMComponent(function Profile(props) {
    var title = props.title, subtitle = props.subtitle, description = props.description, image = props.image, _a = props.variant, variant = _a === void 0 ? 'header' : _a, avatarVariant = props.avatarVariant, styleProps = props.styleProps, rest = __rest(props, ["title", "subtitle", "description", "image", "variant", "avatarVariant", "styleProps"]);
    var descriptionContent = description ? (jsx(Typography, __assign({ as: 'span', styleProps: { color: 'grey', fontWeight: 400, lineHeight: '22px' }, id: "profile-description" }, { children: description }))) : null;
    var headerContent = (jsxs(Box, { children: [jsx(Typography, __assign({ as: 'h4', styleProps: { fontWeight: 700, lineHeight: '38px' }, id: "profile-header-title" }, { children: title })), jsx(Typography, __assign({ as: 'p', styleProps: { marginBottom: '8px', fontWeight: 500, lineHeight: '22px' }, id: "profile-header-subtitle" }, { children: subtitle })), descriptionContent] }));
    var headerAvatar = jsx(Avatar, { variant: avatarVariant || 'rounded', src: image, styleProps: { marginRight: 16 } });
    var contactAvatar = jsx(Avatar, { variant: avatarVariant || 'circle', src: image, size: "small", styleProps: { marginRight: 16 } });
    var contactContent = (jsxs(Box, { children: [jsx(Typography, __assign({ as: 'p', styleProps: { fontWeight: 500, lineHeight: '22px' }, id: "profile-contact-title" }, { children: title })), jsx(Typography, __assign({ styleProps: { marginBottom: '8px', fontWeight: 500, lineHeight: '16px', fontSize: '12px' } }, { children: subtitle })), descriptionContent] }));
    return (jsx(Box, __assign({}, rest, { styleProps: __assign({ display: 'inline-block' }, styleProps) }, { children: variant === 'header' ? (jsxs(Box, __assign({ styleProps: { display: 'flex', flexDirection: 'row' } }, { children: [image && headerAvatar, headerContent] }))) : (jsxs(Box, __assign({ styleProps: { display: 'flex', flexDirection: 'row' } }, { children: [image && contactAvatar, contactContent] }))) })));
});

var keyMetricContainerStyles = {
    display: 'inline-flex',
    flexDirection: 'column',
    textAlign: 'center'
};
var titleStyles = {
    fontSize: 12,
    color: 'text.subtle',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
};
var tooltipStyles = {
    maxWidth: 200
};
var infoIconStyles = {
    fontSize: 18,
    marginLeft: '4px'
};
var valueStyles = {
    fontWeight: 700,
    fontSize: 18,
    color: 'text.default'
};

var KeyMetric = buildLMComponent(function KeyMetric(props, ref) {
    var id = props.id, title = props.title, value = props.value, info = props.info, titleStyleProps = props.titleStyleProps, valueStyleProps = props.valueStyleProps, styleProps = props.styleProps, metricProps = props.metricProps, currencyProps = props.currencyProps, rest = __rest(props, ["id", "title", "value", "info", "titleStyleProps", "valueStyleProps", "styleProps", "metricProps", "currencyProps"]);
    var _a = useNumberFormatter(), toMetric = _a.toMetric, toCurrency = _a.toCurrency;
    var shownValue = React__default.useMemo(function () {
        if (value === null)
            return '-';
        if (typeof value === 'string')
            return value;
        if (currencyProps)
            return toCurrency(value, __assign(__assign({}, currencyProps), { metricParams: metricProps }));
        return toMetric(value, metricProps);
    }, [currencyProps, metricProps, toCurrency, toMetric, value]);
    return (jsxs(Box, __assign({ id: id, ref: ref }, rest, { styleProps: styleProps }, { children: [jsxs(Typography, __assign({ as: 'span', styleProps: __assign(__assign({}, titleStyles), titleStyleProps), id: "".concat(id, "-title") }, { children: [title, info && (jsx(Tooltip, __assign({ content: info, placement: "top", styleProps: tooltipStyles }, { children: jsx(InfoOutlined, { styleProps: infoIconStyles, id: "".concat(id, "-info") }) })))] })), jsx(Typography, __assign({ as: 'span', styleProps: __assign(__assign({}, valueStyles), valueStyleProps), id: "".concat(id, "-value") }, { children: shownValue }))] })));
}, keyMetricContainerStyles);

var keyMetricsContainer = {
    display: 'flex',
    gap: '10px',
    padding: '5px'
};

var KeyMetrics = buildLMComponent(function KeyMetrics(props, ref) {
    var id = props.id, metrics = props.metrics, styleProps = props.styleProps, _a = props.justify, justify = _a === void 0 ? 'space-evenly' : _a, rest = __rest(props, ["id", "metrics", "styleProps", "justify"]);
    return (jsx(Box, __assign({ id: id, ref: ref }, rest, { styleProps: __assign(__assign(__assign({}, keyMetricsContainer), { justifyContent: justify }), styleProps) }, { children: metrics.map(function (metricProps, index) { return (createElement(KeyMetric, __assign({ id: "".concat(id, "-keyMetric-").concat(metrics[index].title) }, metricProps, { key: index }))); }) })));
});

var Loader = buildLMComponent(function Loader(props, ref) {
    var _a = props.strokeWidth, strokeWidth = _a === void 0 ? 2 : _a, _b = props.size, size = _b === void 0 ? 48 : _b, _c = props.duration, duration = _c === void 0 ? 1000 : _c, styleProps = props.styleProps, rest = __rest(props, ["strokeWidth", "size", "duration", "styleProps"]);
    return jsx(Spinner, __assign({ ref: ref, variant: "spinner", role: "loader" }, { strokeWidth: strokeWidth, size: size, duration: duration }, { sx: styleProps }, rest));
});

var Tag = buildLMComponent(function Tag(props, ref) {
    var theme = useLMTheme().theme;
    var icon = props.icon, label = props.label, onDelete = props.onDelete, styleProps = props.styleProps, disabled = props.disabled, _a = props.size, size = _a === void 0 ? 'medium' : _a, sublabel = props.sublabel, className = props.className, onClick = props.onClick, interactive = props.interactive, _b = props.color, color = _b === void 0 ? 'default' : _b, title = props.title, rest = __rest(props, ["icon", "label", "onDelete", "styleProps", "disabled", "size", "sublabel", "className", "onClick", "interactive", "color", "title"]);
    var classNames = React__default.useMemo(function () {
        var classNames = [];
        if (className)
            classNames.push(className);
        if (sublabel)
            classNames.push('multiline');
        if (onDelete)
            classNames.push('with-delete');
        if (icon)
            classNames.push('with-icon');
        if (onClick || interactive)
            classNames.push('clickable');
        return classNames;
    }, [className, icon, onClick, onDelete, sublabel, interactive]);
    return (jsxs(Box, __assign({ ref: ref, variant: "tags.colorVariants.".concat(color), className: classNames.join(' ') || undefined, styleProps: __assign(__assign(__assign({}, getThemeProp(theme, "tags.box")), getThemeProp(theme, "tags.sizes.".concat(size, ".box"))), styleProps) }, rest, { onClick: onClick, "aria-disabled": disabled }, { children: [icon && (jsx(Box, __assign({ className: 'icon-container', styleProps: { display: 'flex', alignItems: 'center' } }, { children: icon }))), jsxs(Box, __assign({ styleProps: { display: 'flex', flexDirection: 'column' } }, { children: [sublabel && (jsx(Typography, __assign({ as: 'span', title: typeof sublabel === 'string' ? sublabel : undefined, styleProps: __assign(__assign({}, getThemeProp(theme, "tags.sublabel")), getThemeProp(theme, "tags.sizes.".concat(size, ".sublabel"))) }, { children: sublabel }))), jsx(Typography, __assign({ as: 'span', title: title !== undefined ? title : typeof label === 'string' ? label : undefined, styleProps: __assign(__assign({}, getThemeProp(theme, "tags.label")), getThemeProp(theme, "tags.sizes.".concat(size, ".label"))) }, { children: label }))] })), onDelete && (jsx(XOutline, { onClick: disabled ? undefined : onDelete, styleProps: __assign({}, getThemeProp(theme, 'tags.close')), className: 'tag-delete-button' }))] })));
});

var TableColumnGroup = function TableColumnGroup(props) {
    var columnGroupConfig = props.columnGroupConfig, headers = props.headers;
    return (jsx("colgroup", { children: headers === null || headers === void 0 ? void 0 : headers.map(function (header) { return (jsx("col", { sx: columnGroupConfig === null || columnGroupConfig === void 0 ? void 0 : columnGroupConfig[header.name] }, header.name.toString())); }) }));
};

var TableContext = React__default.createContext({});
var useTableContext = function () { return React__default.useContext(TableContext); };

var isNoChildrenComponentProps = function (props) { return 'headers' in props; };

var Table = function Table(props, ref) {
    var _a = props.variant, variant = _a === void 0 ? 'simple' : _a, _b = props.fluid, fluid = _b === void 0 ? false : _b, styleProps = props.styleProps, sortable = props.sortable, sortColumn = props.sortColumn, sortOrder = props.sortOrder, onSortChange = props.onSortChange;
    var onSortChangeHandler = React__default.useCallback(function (sort, order) {
        onSortChange && onSortChange(sort, order);
    }, [onSortChange]);
    var contextValue = React__default.useMemo(function () { return ({
        sortable: sortable || false,
        sortColumn: sortColumn || null,
        sortOrder: sortOrder || 'asc',
        onSortChange: onSortChangeHandler
    }); }, [onSortChangeHandler, sortColumn, sortOrder, sortable]);
    // The parent is in charge of making sure the same object is sent to avoid re-renderings.
    var thList = React__default.useMemo(function () {
        var _a;
        if (isNoChildrenComponentProps(props)) {
            return (jsx(TableRow, __assign({ variant: variant }, { children: (_a = props.headers) === null || _a === void 0 ? void 0 : _a.map(function (header) { return (jsx(TableHeader, __assign({ id: header.id || header.name.toString(), variant: variant, sortable: header.sortable, defaultSort: header.defaultSort }, { children: header.alias }), header.name.toString())); }) }), "headers"));
        }
    }, [props, variant]);
    // The parent is in charge of making sure the same objects are sent to avoid re-rendering.
    var tdList = React__default.useMemo(function () {
        var _a;
        if (isNoChildrenComponentProps(props)) {
            return (_a = props.rows) === null || _a === void 0 ? void 0 : _a.map(function (row) {
                var _a;
                return (jsx(TableRow, __assign({ variant: variant }, { children: (_a = props.headers) === null || _a === void 0 ? void 0 : _a.map(function (header) { return (jsx(TableCell, __assign({ variant: variant }, { children: row[header.name] || '' }), header.name.toString())); }) }), row['id']));
            });
        }
    }, [props, variant]);
    var content = React__default.useMemo(function () {
        if (isNoChildrenComponentProps(props)) {
            return (jsxs(Fragment, { children: [props.columnGroupConfig && jsx(TableColumnGroup, { headers: props.headers, columnGroupConfig: props.columnGroupConfig }), jsx(TableHead, __assign({ variant: variant }, { children: thList })), jsx(TableBody, __assign({ variant: variant }, { children: tdList }))] }));
        }
        else {
            return props.children;
        }
    }, [props, thList, tdList, variant]);
    var rest = React__default.useMemo(function () {
        if (isNoChildrenComponentProps(props)) {
            var rest_1 = omit(props, [
                'headers',
                'rows',
                'columnGroupConfig',
                'variant',
                'fluid',
                'styleProps',
                'sortable',
                'sortColumn',
                'sortOrder',
                'onSortChange'
            ]);
            return rest_1;
        }
        else {
            var rest_2 = omit(props, ['children', 'variant', 'fluid', 'styleProps', 'sortable', 'sortColumn', 'sortOrder', 'onSortChange']);
            return rest_2;
        }
    }, [props]);
    return (jsx(TableContext.Provider, __assign({ value: contextValue }, { children: jsx("table", __assign({ sx: __assign({ variant: "tables.".concat(variant), width: fluid ? '100%' : 'auto' }, styleProps) }, rest, { ref: ref }, { children: content })) })));
};
var Table$1 = buildLMComponent(Table);

var TableBody = buildLMComponent(function TableBody(props) {
    var children = props.children, styleProps = props.styleProps, _a = props.variant, variant = _a === void 0 ? 'simple' : _a, rest = __rest(props, ["children", "styleProps", "variant"]);
    return (jsx("tbody", __assign({ sx: __assign({ variant: "tableBody.".concat(variant) }, styleProps) }, rest, { children: children })));
});

var TableRow = buildLMComponent(function TableRow(props) {
    var children = props.children, styleProps = props.styleProps, rest = __rest(props, ["children", "styleProps"]);
    return (jsx("tr", __assign({ sx: styleProps }, rest, { children: children })));
});

var TableCell = buildLMComponent(function TableCell(props) {
    var children = props.children, styleProps = props.styleProps, _a = props.variant, variant = _a === void 0 ? 'simple' : _a, rest = __rest(props, ["children", "styleProps", "variant"]);
    return (jsx("td", __assign({ sx: __assign({ variant: "tableCells.td.".concat(variant) }, styleProps) }, rest, { children: children })));
});

var ArrowDownOutline = createSvgIcon([jsx("path", { stroke: "none", d: "M0 0h24v24H0z" }, "0"), jsx("path", { d: "M12 5v14m6-6-6 6m-6-6 6 6" }, "1")], 'ArrowDownOutline', {
    stroke: 'currentColor',
    strokeLinecap: 'round',
    strokeWidth: '1.5',
    fill: 'none',
    viewBox: '0 0 24 24'
});

var ArrowUpOutline = createSvgIcon([jsx("path", { stroke: "none", d: "M0 0h24v24H0z" }, "0"), jsx("path", { d: "M12 5v14m6-8-6-6m-6 6 6-6" }, "1")], 'ArrowUpOutline', {
    stroke: 'currentColor',
    strokeLinecap: 'round',
    strokeWidth: '1.5',
    fill: 'none',
    viewBox: '0 0 24 24'
});

var TableSortLabel = buildLMComponent(function TableHeaderSortLabel(props, ref) {
    var columnId = props.columnId, children = props.children, defaultSort = props.defaultSort, _a = props.variant, variant = _a === void 0 ? 'simple' : _a, onClick = props.onClick, styleProps = props.styleProps, rest = __rest(props, ["columnId", "children", "defaultSort", "variant", "onClick", "styleProps"]);
    var theme = useLMTheme().theme;
    var _b = useTableContext(), sortColumn = _b.sortColumn, sortOrder = _b.sortOrder, onSortChange = _b.onSortChange;
    var isActive = sortColumn && sortColumn === columnId;
    var sortIcon = React__default.useMemo(function () {
        var sortToDisplay = sortOrder;
        if (!isActive)
            sortToDisplay = defaultSort || sortOrder;
        var _a = {
            className: 'sortIcon',
            styleProps: {
                display: 'flex',
                alignItems: 'center',
                visibility: isActive ? 'visible' : 'hidden',
                opacity: isActive ? '1' : '0.4',
                fontSize: 3,
                marginLeft: 'spacing-4'
            }
        }, iconStyleProps = _a.styleProps, commonProps = __rest(_a, ["styleProps"]);
        return sortToDisplay === 'asc' ? (jsx(ArrowUpOutline, __assign({}, commonProps, { styleProps: __assign(__assign({}, iconStyleProps), { marginTop: '-1px' }) }))) : (jsx(ArrowDownOutline, __assign({}, commonProps, { styleProps: iconStyleProps })));
    }, [sortOrder, isActive, defaultSort]);
    var onClickHandler = React__default.useCallback(function (ev) {
        onClick && onClick(ev);
        if (isActive)
            onSortChange(columnId, sortOrder === 'asc' ? 'desc' : 'asc');
        else
            onSortChange(columnId, defaultSort || sortOrder);
    }, [columnId, isActive, onSortChange, defaultSort, sortOrder, onClick]);
    var styles = React__default.useMemo(function () {
        var themeStyles = getThemeProp(theme, "tableCells.thSortLabel.".concat(variant));
        return __assign(__assign(__assign({ cursor: 'pointer', userSelect: 'none', display: 'inline-flex', alignItems: 'center' }, themeStyles), styleProps), { '&:hover': __assign(__assign({ '.sortIcon': { visibility: 'visible' } }, themeStyles['&:hover']), (styleProps && styleProps['&:hover'] ? styleProps['&:hover'] : {})) });
    }, [styleProps, theme, variant]);
    return (jsxs(Box, __assign({}, rest, { ref: ref, as: 'span', onClick: onClickHandler, styleProps: styles }, { children: [children, sortIcon] })));
});

var TableHeader = buildLMComponent(function TableHeader(props, ref) {
    var children = props.children, styleProps = props.styleProps, _a = props.variant, variant = _a === void 0 ? 'simple' : _a, sortableColumn = props.sortable, defaultSort = props.defaultSort, _b = props.disablePaddingXOnSort, disablePaddingXOnSort = _b === void 0 ? true : _b, id = props.id, rest = __rest(props, ["children", "styleProps", "variant", "sortable", "defaultSort", "disablePaddingXOnSort", "id"]);
    var sortableTable = useTableContext().sortable;
    var isSortable = sortableTable && sortableColumn && id;
    var content = React__default.useMemo(function () {
        if (!isSortable)
            return children;
        else if (React__default.isValidElement(children))
            return React__default.cloneElement(children, __assign({ columnId: id, defaultSort: defaultSort, variant: variant }, children.props));
        else
            return (jsx(TableSortLabel, __assign({ columnId: id, defaultSort: defaultSort, variant: variant }, { children: children })));
    }, [children, defaultSort, id, isSortable, variant]);
    var styles = React__default.useMemo(function () {
        var computed = __assign({}, styleProps);
        if (isSortable && disablePaddingXOnSort) {
            computed.paddingX = 0;
        }
        return computed;
    }, [disablePaddingXOnSort, styleProps, isSortable]);
    return (jsx("th", __assign({ id: id, ref: ref, sx: __assign({ variant: "tableCells.th.".concat(variant) }, styles) }, rest, { children: content })));
});

var TableHead = buildLMComponent(function TableHead(props) {
    var children = props.children, styleProps = props.styleProps, rest = __rest(props, ["children", "styleProps"]);
    return (jsx("thead", __assign({ sx: styleProps }, rest, { children: children })));
});

var TableFooter = buildLMComponent(function TableFooter(props) {
    var children = props.children, styleProps = props.styleProps, rest = __rest(props, ["children", "styleProps"]);
    return (jsx("tfoot", __assign({ sx: styleProps }, rest, { children: children })));
});

var InputLabel = buildLMComponent(function InputLabel(props, ref) {
    var children = props.children, htmlFor = props.htmlFor, required = props.required, labelIcons = props.labelIcons, actionIcons = props.actionIcons, styleProps = props.styleProps, _a = props.variant, variant = _a === void 0 ? 'medium' : _a, _b = props.disabled, disabled = _b === void 0 ? false : _b, rest = __rest(props, ["children", "htmlFor", "required", "labelIcons", "actionIcons", "styleProps", "variant", "disabled"]);
    var isString = typeof children === 'string';
    var ariaLabel = isString ? children : undefined;
    var getVariantTextSize = function () {
        switch (variant) {
            case 'small':
                return 'text.textXsMedium';
            case 'medium':
                return 'text.textSmRegular';
            case 'large':
                return 'text.textMdRegular';
        }
    };
    return (jsxs(Box, __assign({ ref: ref, variant: 'text.textSmMedium', styleProps: __assign({ color: disabled ? 'text.disabled' : 'text.default', display: 'flex', alignItems: 'center', marginBottom: 'spacing-2', gap: 'spacing-2', minHeight: '24px', pointerEvents: disabled ? 'none' : 'auto', svg: {
                color: disabled ? 'icon.disabled' : 'icon.default',
                width: '16px',
                height: '16px'
            } }, styleProps) }, rest, { children: [isString ? (jsx(Label, __assign({ as: 'label', sx: {
                    width: 'auto',
                    alignItems: 'center',
                    color: disabled ? 'text.disabled' : 'text.default',
                    cursor: disabled ? 'not-allowed' : 'pointer'
                }, variant: getVariantTextSize(), htmlFor: disabled ? undefined : htmlFor, "aria-label": ariaLabel, "aria-disabled": disabled }, { children: jsx(Box, __assign({ as: 'span', styleProps: {
                        wordBreak: 'break-word',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden'
                    } }, { children: children })) }))) : (children), required && (jsx(Box, __assign({ as: 'span', styleProps: { color: disabled ? 'text.disabled' : 'text.error', flexShrink: 0 } }, { children: "*" }))), jsx(Box, __assign({ as: 'span', styleProps: {
                    display: 'flex',
                    alignItems: 'center',
                    marginLeft: 'spacing-2',
                    svg: {
                        verticalAlign: 'middle', // Ensures SVG aligns properly with text
                    },
                } }, { children: labelIcons })), actionIcons && (jsx(Box, __assign({ as: 'span', styleProps: {
                    display: 'flex',
                    flexGrow: '1',
                    flexShrink: 0,
                    justifyContent: 'flex-end',
                    gap: 'spacing-2',
                    marginLeft: 'spacing-20'
                } }, { children: actionIcons })))] })));
});

var InputHint = buildLMComponent(function InputHint(props, ref) {
    var children = props.children, isError = props.isError, rest = __rest(props, ["children", "isError"]);
    if (!children) {
        return null;
    }
    return (jsx(Typography, __assign({ ref: ref, as: 'p', variant: 'textXsRegular', styleProps: {
            marginTop: 'spacing-2',
            paddingY: 'spacing-4',
            wordBreak: 'break-word',
            color: isError ? 'text.error' : 'text.low'
        } }, rest, { children: children })));
});

var Icon = function (_a) {
    var _b = _a.isLeft, isLeft = _b === void 0 ? false : _b, Component = _a.component, iconStyle = _a.iconStyle, isDisabled = _a.isDisabled;
    return (jsx("div", __assign({ sx: __assign({ position: 'absolute', top: '50%', transform: 'translateY(-50%)', left: isLeft ? 0 : 'auto', right: isLeft ? 'auto' : 0, marginLeft: isLeft ? 'spacing-8' : 0, marginRight: isLeft ? 0 : 'spacing-8', display: 'flex', alignItems: 'center', pointerEvents: 'none', svg: {
                fontSize: 4,
                color: isDisabled ? 'icon.disabled' : 'icon.default'
            } }, iconStyle) }, { children: Component })));
};
var Input = buildLMComponent(function Input(props, ref) {
    var _a = props.sizeVariant, sizeVariant = _a === void 0 ? 'medium' : _a, helptext = props.helptext, error = props.error, placeholder = props.placeholder, label = props.label, startIcon = props.startIcon, endIcon = props.endIcon, readOnly = props.readOnly, styleProps = props.styleProps, iconStyle = props.iconStyle, role = props.role, required = props.required, disabled = props.disabled, className = props.className, id = props.id, rest = __rest(props, ["sizeVariant", "helptext", "error", "placeholder", "label", "startIcon", "endIcon", "readOnly", "styleProps", "iconStyle", "role", "required", "disabled", "className", "id"]);
    var theme = useLMTheme().theme;
    var InputLabelSizeMapping = {
        small: 'small',
        medium: 'small',
        large: 'medium'
    };
    return (jsxs(Box, __assign({ styleProps: {
            textAlign: 'left'
        } }, { children: [jsx(InputLabel, __assign({ disabled: disabled, required: required, variant: InputLabelSizeMapping[sizeVariant] }, { children: label })), jsxs(Box, __assign({ styleProps: {
                    display: 'flex',
                    alignItems: 'center'
                } }, { children: [startIcon && jsx(Icon, { component: startIcon, isLeft: true, isDisabled: disabled, iconStyle: iconStyle }), jsx("input", __assign({ ref: ref, id: id, "data-testid": id, placeholder: placeholder, className: "".concat(className || '', " ").concat(startIcon ? 'with-start-icon' : '', " ").concat(endIcon ? 'with-end-icon' : ''), sx: __assign(__assign(__assign({}, getThemeProp(theme, "forms.input")), getThemeProp(theme, "forms.input.".concat(sizeVariant))), { styleProps: styleProps }), disabled: disabled, required: required, readOnly: readOnly, role: role || 'textbox', "aria-invalid": !!error, "aria-disabled": disabled }, rest)), endIcon && jsx(Icon, { component: endIcon, isLeft: false, isDisabled: disabled, iconStyle: iconStyle })] })), !error && helptext && jsx(InputHint, { children: helptext }), error && typeof error === 'string' && jsx(InputHint, __assign({ isError: true }, { children: error }))] })));
});

var ChevronDownOutline = createSvgIcon([jsx("path", { stroke: "none", d: "M0 0h24v24H0z" }, "0"), jsx("path", { d: "m6 9 6 6 6-6" }, "1")], 'ChevronDownOutline', {
    stroke: 'currentColor',
    strokeLinecap: 'round',
    strokeWidth: '1.5',
    fill: 'none',
    viewBox: '0 0 24 24'
});

var ChevronUpOutline = createSvgIcon([jsx("path", { stroke: "none", d: "M0 0h24v24H0z" }, "0"), jsx("path", { d: "m6 15 6-6 6 6" }, "1")], 'ChevronUpOutline', {
    stroke: 'currentColor',
    strokeLinecap: 'round',
    strokeWidth: '1.5',
    fill: 'none',
    viewBox: '0 0 24 24'
});

var SelectContext = React__default.createContext({});
var Select = buildLMComponent(function Select(props) {
    var optionValue = props.optionValue, defaultValue = props.defaultValue, onChange = props.onChange, children = props.children, styleProps = props.styleProps, error = props.error, disabled = props.disabled, _a = props.placeholder, placeholder = _a === void 0 ? '' : _a, _b = props.size, size = _b === void 0 ? 'medium' : _b, helpText = props.helpText, required = props.required, label = props.label, inputProps = props.inputProps, searchable = props.searchable, clearable = props.clearable, onClear = props.onClear;
    var _c = React__default.useState(defaultValue), selectedOption = _c[0], setSelectedOption = _c[1];
    var _d = React__default.useState([]), displayedOptions = _d[0], setDisplayedOptions = _d[1];
    var _e = React__default.useState(false), isOpen = _e[0], setIsOpen = _e[1];
    var _f = React__default.useState(false), navigate = _f[0], setNavigate = _f[1];
    var _g = React__default.useState(''), searchValue = _g[0], setSearchValue = _g[1];
    var theme = useLMTheme().theme;
    var inputRef = React__default.useRef(null);
    // Create context values for select options
    var handleSelectOption = React__default.useCallback(function (newValue) {
        !optionValue && setSelectedOption(newValue);
        if (onChange)
            onChange(newValue);
    }, [onChange, optionValue]);
    // Managing displayed options
    var addDisplayedOption = React__default.useCallback(function (selectedOption) {
        setDisplayedOptions(function (prev) {
            if (prev.find(function (option) { return option.key === selectedOption.key; }))
                return prev;
            return __spreadArray(__spreadArray([], prev, true), [selectedOption], false);
        });
    }, []);
    var removeDisplayedOption = React__default.useCallback(function (selectedOption) {
        setDisplayedOptions(function (prev) { return prev.filter(function (option) { return option.key !== selectedOption.key; }); });
    }, []);
    var selectContext = {
        setSelectedOption: handleSelectOption,
        addDisplayedOption: addDisplayedOption,
        removeDisplayedOption: removeDisplayedOption,
        selectedOption: selectedOption,
        searchValue: searchValue
    };
    // Set selected option if optionValue or defaultValue is provided
    React__default.useEffect(function () {
        if (optionValue) {
            setSelectedOption(optionValue);
        }
        else if (defaultValue) {
            setSelectedOption(defaultValue);
        }
    }, [defaultValue, optionValue]);
    var handleOpenChange = React__default.useCallback(function (open) {
        if (!searchable)
            setIsOpen(open);
        else {
            setSearchValue('');
            setIsOpen(false);
        }
    }, [searchable]);
    var handleOpen = React__default.useCallback(function () {
        var _a;
        if (disabled)
            return;
        if (!searchable) {
            setIsOpen(function (open) { return !open; });
            return;
        }
        setIsOpen(true);
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [disabled, searchable]);
    var handleInputChange = React__default.useCallback(function (event) {
        setSearchValue(event.target.value);
    }, []);
    var handleKeyboard = React__default.useCallback(function (event) {
        var _a;
        if (event.key === 'ArrowDown' && displayedOptions.length !== 0) {
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
        }
        else if (event.key === 'Enter') {
            handleOpen();
        }
    }, [displayedOptions.length, handleOpen]);
    var handleOptionSelected = React__default.useCallback(function () {
        setSearchValue('');
        setIsOpen(false);
    }, []);
    var inputValue = React__default.useMemo(function () {
        var _a;
        return searchable && isOpen ? searchValue : ((_a = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) === null || _a === void 0 ? void 0 : _a.toString()) || '';
    }, [searchValue, searchable, selectedOption, isOpen]);
    var inputStyles = React__default.useMemo(function () {
        var styles = {
            cursor: !disabled ? (searchable ? 'text' : 'pointer') : 'initial',
            fontSize: getThemeProp(theme, "forms.select.".concat(size, ".fontSize")),
            backgroundColor: !disabled ? (isOpen ? 'surface.neutralSubtle.hover' : undefined) : 'surface.disabled',
            height: getThemeProp(theme, "forms.select.".concat(size, ".height")),
            paddingRight: getThemeProp(theme, "forms.select.".concat(size, ".paddingRight")),
            paddingLeft: getThemeProp(theme, "forms.select.".concat(size, ".paddingLeft"))
        };
        !error && (styles.borderColor = !disabled ? (isOpen ? 'border.neutralActive' : undefined) : 'border.disabled');
        return styles;
    }, [disabled, error, isOpen, size, theme, searchable]);
    var inputEndIcons = React__default.useMemo(function () {
        var clearIcon = clearable && selectedOption ? (jsx(Button, { styleProps: {
                marginRight: '2px',
                cursor: 'pointer',
                pointerEvents: 'all'
            }, leftIcon: jsx(XOutline, {}), variant: "textGray", size: "tiny", disabled: disabled, onClick: function () {
                onClear === null || onClear === void 0 ? void 0 : onClear();
                setSelectedOption(undefined);
            } })) : undefined;
        var divider = clearable && selectedOption ? (jsx(Divider, { orientation: "vertical", styleProps: __assign({}, getThemeProp(theme, "forms.select.".concat(size, ".divider"))) })) : undefined;
        var openCloseIcon = isOpen ? (jsx(ChevronUpOutline, { styleProps: __assign({}, getThemeProp(theme, "forms.select.".concat(size, ".endIcons.toggleIcon"))) })) : (jsx(ChevronDownOutline, { styleProps: __assign({}, getThemeProp(theme, "forms.select.".concat(size, ".endIcons.toggleIcon"))) }));
        return (jsxs(Fragment, { children: [clearIcon, divider, openCloseIcon] }));
    }, [clearable, selectedOption, disabled, theme, size, isOpen, onClear]);
    var getIconStyles = React__default.useCallback(function () {
        var styles = {
            size: 20,
            color: !disabled ? 'text.default' : 'icon.disabled',
            cursor: !disabled ? (searchable ? 'text' : 'pointer') : 'initial'
        };
        if (clearable && selectedOption)
            styles.width = getThemeProp(theme, "forms.select.".concat(size, ".endIcons.width"));
        return styles;
    }, [clearable, disabled, searchable, selectedOption, size, theme]);
    return (jsx(SelectContext.Provider, __assign({ value: selectContext }, { children: jsxs(Popover, __assign({ placement: 'bottom-start', offsetValue: 4, open: isOpen, onOpenChange: handleOpenChange, navigation: searchable ? navigate : true, useReferenceWidth: true }, { children: [jsx(PopoverTrigger, { children: jsx(Box, __assign({ role: "combobox", onClick: handleOpen }, { children: jsx(Input, __assign({ label: label, value: inputValue, ref: inputRef, placeholder: placeholder, required: required, styleProps: __assign(__assign({}, inputStyles), styleProps), endIcon: inputEndIcons, readOnly: !searchable, iconStyle: getIconStyles(), error: error, role: "searchbox", disabled: disabled, helptext: helpText, onFocus: function () { return setNavigate(false); }, onBlur: function () { return setNavigate(true); }, onChange: handleInputChange, onKeyUp: handleKeyboard }, inputProps)) })) }), jsx(PopoverContent, __assign({ returnFocus: false, disableFocusManagement: !(isOpen && navigate), styleProps: { variant: 'boxes.dropdown' } }, { children: jsxs(PopoverList, __assign({ onOptionSelected: handleOptionSelected }, { children: [children, displayedOptions.length === 0 && (jsx(Box, __assign({ sx: { height: 38, alignItems: 'center', display: 'flex', width: styleProps === null || styleProps === void 0 ? void 0 : styleProps.width } }, { children: jsx(Typography, __assign({ variant: 'textXsRegular', sx: { color: 'text.subtle', paddingX: 'spacing-16' } }, { children: "No results found." })) })))] })) }))] })) })));
});

var Dropdown = buildLMComponent(function Dropdown(props, ref) {
    var children = props.children, label = props.label, leftIcon = props.leftIcon, _a = props.variant, variant = _a === void 0 ? 'primary' : _a, _b = props.size, size = _b === void 0 ? 'medium' : _b, onChange = props.onChange, onOpen = props.onOpen, disabled = props.disabled, popoverTrigger = props.popoverTrigger, popovercontentProps = props.popovercontentProps, useReferenceWidth = props.useReferenceWidth, _c = props.navigation, navigation = _c === void 0 ? true : _c, _d = props.typeahead, typeahead = _d === void 0 ? true : _d, open = props.open, popoverProps = props.popoverProps, rest = __rest(props, ["children", "label", "leftIcon", "variant", "size", "onChange", "onOpen", "disabled", "popoverTrigger", "popovercontentProps", "useReferenceWidth", "navigation", "typeahead", "open", "popoverProps"]);
    var popoverContentFinalProps = React__default.useMemo(function () { return (__assign(__assign({}, popovercontentProps), { styleProps: __assign({ variant: 'boxes.dropdown' }, popovercontentProps === null || popovercontentProps === void 0 ? void 0 : popovercontentProps.styleProps) })); }, [popovercontentProps]);
    var _e = useState(false), isOpen = _e[0], setisOpen = _e[1];
    var handleOptionSelected = function (value) {
        onChange && onChange(value);
        setisOpen(false);
        onOpen && onOpen(false);
    };
    var handleOpen = React__default.useCallback(function (value) {
        setisOpen(value);
        onOpen && onOpen(value);
    }, [onOpen]);
    React__default.useEffect(function () {
        if (!isUndefined$1(open))
            setisOpen(open);
    }, [open]);
    return (jsxs(Popover, __assign({ placement: 'bottom-start', offsetValue: 4, open: isOpen, onOpenChange: handleOpen, navigation: navigation, typeahead: typeahead, useReferenceWidth: useReferenceWidth }, popoverProps, { children: [jsx(PopoverTrigger, __assign({ onClick: function () { return isUndefined$1(open) && handleOpen(!isOpen); } }, { children: popoverTrigger ? popoverTrigger : (jsx(Button, __assign({ ref: ref, variant: variant, size: size, leftIcon: leftIcon, rightIcon: open ? jsx(ChevronUpOutline, {}) : jsx(ChevronDownOutline, {}), disabled: disabled }, rest, { children: label }))) })), jsx(PopoverContent, __assign({}, popoverContentFinalProps, { children: jsx(PopoverList, __assign({ onOptionSelected: handleOptionSelected }, { children: children })) }))] })));
});

var Option = buildLMComponent(function Option(props, ref) {
    var children = props.children, _a = props.value, value = _a === void 0 ? null : _a, label = props.label, styleProps = props.styleProps, onClick = props.onClick, onSelected = props.onSelected, selected = props.selected, rest = __rest(props, ["children", "value", "label", "styleProps", "onClick", "onSelected", "selected"]);
    var onOptionSelected = React__default.useContext(PopoverListContext).onOptionSelected;
    /**
     * Inform the parent Dropdown component that this option was selected.
     */
    var handleOptionClick = React__default.useCallback(function () {
        onClick && onClick(value);
        if (onSelected) {
            onSelected(value);
        }
        else {
            onOptionSelected(value);
        }
    }, [onClick, onSelected, onOptionSelected, value]);
    /**
     * Inform the parent Dropdown component that this option was selected (via keyboard).
     */
    var handleOptionKeyDown = React__default.useCallback(function (event) {
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
            onClick && onClick(value);
            if (onSelected) {
                onSelected(value);
            }
            else {
                onOptionSelected(value);
            }
        }
    }, [onClick, onSelected, onOptionSelected, value]);
    return (jsx(PopoverItem, __assign({ ref: ref, variant: "boxes.option", styleProps: styleProps, label: label }, rest, { onClick: handleOptionClick, onKeyDown: handleOptionKeyDown, selected: selected }, { children: children })));
});

var OptionDescription = buildLMComponent(function OptionDescription(props, ref) {
    var children = props.children, styleProps = props.styleProps;
    return (jsx(Typography, __assign({ ref: ref, variant: 'textXsRegular', styleProps: __assign({ color: 'text.low', marginTop: 'spacing-4' }, styleProps) }, { children: children })));
});

var isIncluding = function (str, substr) { return str.toLowerCase().indexOf(substr.toLowerCase()) > -1; };

var SelectOption = buildLMComponent(function SelectOption(props) {
    var optionValue = props.optionValue, styleProps = props.styleProps, onClick = props.onClick, rest = __rest(props, ["optionValue", "styleProps", "onClick"]);
    var onOptionSelected = React__default.useContext(PopoverListContext).onOptionSelected;
    var _a = React__default.useContext(SelectContext), selectedOption = _a.selectedOption, setSelectedOption = _a.setSelectedOption, searchValue = _a.searchValue, addDisplayedOption = _a.addDisplayedOption, removeDisplayedOption = _a.removeDisplayedOption;
    var _b = React__default.useState(true), displayed = _b[0], setDisplayed = _b[1];
    var handleSelected = React__default.useCallback(function () {
        onClick && onClick(optionValue);
        onOptionSelected(optionValue.key);
        setSelectedOption(optionValue);
    }, [onClick, onOptionSelected, setSelectedOption, optionValue]);
    React__default.useEffect(function () {
        if (!searchValue)
            setDisplayed(true);
        else if (optionValue.value && isIncluding(optionValue.value.toString(), searchValue)) {
            setDisplayed(true);
        }
        else
            setDisplayed(false);
    }, [optionValue, searchValue]);
    React__default.useEffect(function () {
        displayed ? addDisplayedOption(optionValue) : removeDisplayedOption(optionValue);
        return function () { return removeDisplayedOption(optionValue); };
    }, [addDisplayedOption, displayed, optionValue, removeDisplayedOption]);
    if (!displayed)
        return null;
    return (jsx(Option, __assign({ onSelected: handleSelected, value: optionValue.key, selected: (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.key) === optionValue.key, styleProps: styleProps }, rest, { children: jsx(Typography, __assign({ variant: 'span', styleProps: { color: (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.key) === optionValue.key ? 'text.primary' : undefined } }, { children: optionValue.value })) })));
});

var DEFAULT_ROWS_PER_PAGE_OPTIONS = [5, 10, 20, 50, 100];
var TablePagination = buildLMComponent(function TablePagination(props) {
    var _a = props.component, component = _a === void 0 ? 'div' : _a, count = props.count, page = props.page, onPageChange = props.onPageChange, onRowsPerPageChange = props.onRowsPerPageChange, rowsPerPage = props.rowsPerPage, styleProps = props.styleProps, rowsPerPageOptions = props.rowsPerPageOptions, displaySelectStyle = props.displaySelectStyle, pageSelectStyle = props.pageSelectStyle, id = props.id, rest = __rest(props, ["component", "count", "page", "onPageChange", "onRowsPerPageChange", "rowsPerPage", "styleProps", "rowsPerPageOptions", "displaySelectStyle", "pageSelectStyle", "id"]);
    var totalPages = React__default.useMemo(function () { return Math.ceil(count / rowsPerPage); }, [count, rowsPerPage]);
    var pageOptions = React__default.useMemo(function () {
        var options = [];
        for (var i = 1; i <= totalPages; i++) {
            options.push(jsx(SelectOption, { id: id ? "".concat(id, "_page_").concat(i) : undefined, optionValue: { value: i, key: i.toString() }, onClick: function (value) { return onPageChange(value.value); } }, i));
        }
        return options;
    }, [id, onPageChange, totalPages]);
    var rowsPerPageList = React__default.useMemo(function () { return rowsPerPageOptions || DEFAULT_ROWS_PER_PAGE_OPTIONS; }, [rowsPerPageOptions]);
    return (jsxs(Box, __assign({ sx: __assign({ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center', gap: 8, color: 'text.default' }, styleProps), id: id, as: component }, rest, { children: [jsx(Typography, __assign({ styleProps: { fontSize: '2' } }, { children: "Display" })), jsx(Select, __assign({ styleProps: __assign({ width: 68, paddingLeft: 'spacing-8' }, displaySelectStyle), optionValue: { value: rowsPerPage, key: rowsPerPage.toString() }, inputProps: { iconStyle: { marginRight: 'spacing-8' } } }, { children: rowsPerPageList.map(function (option, index) { return (jsx(SelectOption, { optionValue: { value: option, key: option.toString() }, id: id ? "".concat(id, "_rows_per_page_").concat(option) : undefined, onClick: function (value) { return onRowsPerPageChange(value.value); } }, index)); }) })), jsxs(Typography, __assign({ styleProps: { fontSize: '2', width: 150, textAlign: 'center' } }, { children: [rowsPerPage * (page - 1) + 1, "-", Math.min(rowsPerPage * page, count), " of ", count] })), jsx(Select, __assign({ styleProps: __assign({ width: 78, paddingLeft: 'spacing-8' }, pageSelectStyle), optionValue: { value: page, key: page.toString() }, inputProps: { iconStyle: { marginRight: 'spacing-8' } }, searchable: true }, { children: pageOptions })), jsxs(Typography, __assign({ styleProps: { fontSize: '2', width: 100, textAlign: 'center' } }, { children: ["of ", totalPages, " pages"] })), jsxs(Box, { children: [jsx(Button, __assign({ onClick: function () { return onPageChange(page - 1); }, variant: "textGray", disabled: page <= 1 }, { children: jsx(ChevronLeftOutline, { styleProps: { size: 20, color: page > 1 ? 'icon.default' : 'icon.disabled' } }) })), jsx(Button, __assign({ onClick: function () { return onPageChange(page + 1); }, variant: "textGray", disabled: page >= totalPages }, { children: jsx(ChevronRightOutline, { styleProps: { size: 20, color: page < totalPages ? 'icon.default' : 'icon.disabled' } }) }))] })] })));
});

var classNameId = 'lm-scrollbar-invisible';
var useScrollbarDisplay = function () {
    var createInvisibleScrollbarStyle = React__default.useCallback(function () {
        var existingStyleElement = document.getElementById(classNameId);
        if (existingStyleElement)
            return;
        var styleElement = document.createElement('style');
        styleElement.id = classNameId;
        styleElement.innerHTML = "\n\t\t\t\t\t.".concat(classNameId, " {\n\t\t\t\t\t\t-ms-overflow-style: none;  /* IE and Edge */\n\t\t\t\t\t\tscrollbar-width: 0;     /* Firefox */\n\t\t\t\t\t}\n\t\t\t\t\t.").concat(classNameId, "::-webkit-scrollbar {\n\t\t\t\t\t\tdisplay: none;             /* WebKit browsers */\n\t\t\t\t\t}\n\t\t\t\t");
        document.head.appendChild(styleElement);
    }, []);
    var removeInvisibleScrollbarStyle = React__default.useCallback(function () {
        var existingStyleElement = document.getElementById(classNameId);
        if (existingStyleElement) {
            existingStyleElement.remove();
        }
    }, []);
    React__default.useEffect(function () {
        return function () {
            removeInvisibleScrollbarStyle();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var hideScrollbar = React__default.useCallback(function () {
        createInvisibleScrollbarStyle();
        document.body.classList.add(classNameId);
    }, [createInvisibleScrollbarStyle]);
    var showScrollbar = React__default.useCallback(function () {
        document.body.classList.remove(classNameId);
    }, []);
    return { hideScrollbar: hideScrollbar, showScrollbar: showScrollbar };
};

/**
 * Keep track of stacked elements.
 */
var StackManager = /** @class */ (function () {
    function StackManager() {
        this.stack = [];
    }
    /**
     * Add a new item to the stack.
     */
    StackManager.prototype.add = function (id) {
        this.stack.push(id);
    };
    /**
     * Remove the item from the stack.
     *
     * @param id
     */
    StackManager.prototype.remove = function (id) {
        this.stack = this.stack.filter(function (item) { return item !== id; });
    };
    /**
     * Check if the item is at the top of the stack.
     */
    StackManager.prototype.isTopLevel = function (id) {
        return this.stack[this.stack.length - 1] === id;
    };
    /**
     * Get the number of items in the stack.
     */
    StackManager.prototype.count = function () {
        return this.stack.length;
    };
    return StackManager;
}());

var DrawerContext = React__default.createContext({});

var defaultBackdropStyleProps = {
    display: 'block',
    height: '100vh',
    width: '100vw',
    left: 0,
    position: 'fixed',
    top: 0,
    opacity: 1
};
var defaultContainerStyleProps = {
    position: 'fixed',
    visibility: 'visible',
    backgroundColor: 'white',
    minWidth: '200px',
    height: '100vh',
    top: 0,
    display: 'flex',
    flexDirection: 'column',
    width: 'auto',
    boxShadow: 'xl'
};

// Global stack manager for all drawers.
var stackManager = new StackManager();
var Drawer = buildLMComponent(function DrawerProps(props, ref) {
    var id = props.id, open = props.open, _a = props.anchor, anchor = _a === void 0 ? 'right' : _a, onClose = props.onClose, onBack = props.onBack, _b = props.zIndex, zIndex = _b === void 0 ? 10 : _b, children = props.children, containerStyleProps = props.containerStyleProps, _c = props.backdropOverlay, backdropOverlay = _c === void 0 ? true : _c;
    var duration = 225;
    var theme = useLMTheme().theme;
    var _d = useScrollbarDisplay(), hideScrollbar = _d.hideScrollbar, showScrollbar = _d.showScrollbar;
    var transitionDuration = getThemeProp(theme, "transitions.duration.".concat(duration));
    var transitionType = getThemeProp(theme, "transitions.type.inOut");
    var drawerId = useId();
    var _e = useScrollLock({
        autoLock: false
    }), lock = _e.lock, unlock = _e.unlock;
    // Close the drawer on escape key press.
    useEffect(function () {
        if (!open)
            return;
        var eventKeyListener = function (event) {
            if (event.key === 'Escape' && stackManager.isTopLevel(drawerId) && onClose) {
                onClose(event, 'escapeKeyDown');
            }
        };
        document.addEventListener('keydown', eventKeyListener);
        return function () {
            document.removeEventListener('keydown', eventKeyListener);
            window.blur();
        };
    }, [drawerId, open, onClose]);
    // Register the drawer in the stack manager, and apply scroll lock if necessary.
    useEffect(function () {
        var removeDrawer = function () {
            stackManager.remove(drawerId);
            // Unlock the page scroll when we close the last drawer.
            if (stackManager.stack.length === 0) {
                unlock();
                showScrollbar();
            }
        };
        if (open) {
            stackManager.add(drawerId);
            // Lock the page scroll when we open the first drawer.
            if (stackManager.stack.length === 1) {
                if (backdropOverlay)
                    lock();
                else {
                    hideScrollbar();
                }
            }
        }
        else {
            removeDrawer();
        }
        return function () {
            removeDrawer();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [drawerId, open]); // lock, unlock - are triggering a re-render when the lock/unlock is triggered, so we skip adding them as dependencies.
    var containerProps = {
        transform: "translateX(".concat(anchor === 'left' ? '-100%' : '100%', ")"),
        transition: "transform ".concat(transitionDuration, " ").concat(transitionType),
        left: anchor === 'left' ? 0 : undefined,
        right: anchor === 'right' ? 0 : undefined,
        zIndex: zIndex
    };
    var backdropProps = {
        transition: "opacity ".concat(transitionDuration, " ").concat(transitionType),
        background: 'overlay.50',
        zIndex: zIndex
    };
    var containerTransitionStyles = {
        entering: { transform: 'translateX(0)' },
        entered: { transform: 'translateX(0)' },
        exiting: { transform: "translateX(".concat(anchor === 'left' ? '-100%' : '100%', ")") },
        exited: { transform: "translateX(".concat(anchor === 'left' ? '-100%' : '100%', ")") }
    };
    var backdropTransitionStyles = {
        entering: { opacity: 1 },
        entered: { opacity: 1 },
        exiting: { opacity: 0 },
        exited: { opacity: 0 }
    };
    var handleClickClose = React__default.useCallback(function (event) {
        if (onClose && open) {
            onClose(event, 'backdropClick');
        }
        return event;
    }, [onClose, open]);
    var handleBackAction = React__default.useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        onBack && onBack.apply(void 0, args);
    }, [onBack]);
    var contextValue = React__default.useMemo(function () { return ({
        onClose: onClose,
        onBack: handleBackAction
    }); }, [handleBackAction, onClose]);
    var getFocus = React__default.useCallback(function (instance) {
        if (instance) {
            instance.focus();
        }
    }, []);
    return createPortal(jsxs(DrawerContext.Provider, __assign({ value: contextValue }, { children: [backdropOverlay && (jsx(Transition, __assign({ appear: open, in: open, timeout: duration, mountOnEnter: true, unmountOnExit: true }, { children: function (state) { return (jsx(Box, { sx: __assign(__assign(__assign({}, defaultBackdropStyleProps), backdropProps), backdropTransitionStyles[state]), "data-testid": id ? "".concat(id, "_drawerBackdrop") : undefined, onClick: handleClickClose })); } }))), jsx(Transition, __assign({ appear: open, in: open, timeout: duration, mountOnEnter: true, unmountOnExit: true }, { children: function (state) { return (jsxs(Box, __assign({ ref: ref, sx: __assign(__assign(__assign(__assign({}, defaultContainerStyleProps), containerProps), containerStyleProps), containerTransitionStyles[state]), "data-testid": id ? "".concat(id, "_drawerContainer") : undefined }, { children: [jsx(Box, { ref: getFocus, tabIndex: 0 }), " ", children] }))); } }))] })), document.body);
});

var useDrawerContext = function () { return React__default.useContext(DrawerContext); };

var ArrowLeftOutline = createSvgIcon([jsx("path", { stroke: "none", d: "M0 0h24v24H0z" }, "0"), jsx("path", { d: "M5 12h14M5 12l6 6m-6-6 6-6" }, "1")], 'ArrowLeftOutline', { stroke: 'currentColor', strokeLinecap: 'round', strokeWidth: '1.5', fill: 'none', viewBox: '0 0 24 24' });

var DrawerHeader = buildLMComponent(function DrawerHeader(props, ref) {
    var _a = props.variant, variant = _a === void 0 ? 'default' : _a, topContent = props.topContent, topContentProps = props.topContentProps, title = props.title, titleAdditionalContent = props.titleAdditionalContent, titleProps = props.titleProps, _b = props.backButton, backButton = _b === void 0 ? false : _b, _c = props.divider, divider = _c === void 0 ? true : _c, rest = __rest(props, ["variant", "topContent", "topContentProps", "title", "titleAdditionalContent", "titleProps", "backButton", "divider"]);
    var _d = useDrawerContext(), onBack = _d.onBack, onClose = _d.onClose;
    var theme = useLMTheme().theme;
    var handleBack = React__default.useCallback(function (event) {
        onBack(event, 'buttonClick');
    }, [onBack]);
    var handleClose = React__default.useCallback(function (event) {
        onClose(event, 'buttonClick');
    }, [onClose]);
    var variantPrefix = "drawer.header.".concat(variant);
    return (jsxs(Box, __assign({ ref: ref, variant: "".concat(variantPrefix, ".container") }, rest, { children: [jsxs(Box, __assign({ variant: "".concat(variantPrefix, ".topContentContainer") }, topContentProps, { children: [jsxs(Box, __assign({ variant: "".concat(variantPrefix, ".topContentTitleContainer") }, { children: [backButton && (jsx(Button, { "aria-label": "back-button", variant: "textGray", leftIcon: jsx(ArrowLeftOutline, {}), onClick: handleBack, styleProps: getThemeProp(theme, "".concat(variantPrefix, ".backButton")) })), typeof topContent === 'string' ? (jsx(Typography, __assign({ variant: "heading2XsSemibold", styleProps: getThemeProp(theme, "".concat(variantPrefix, ".topContentTitle")), as: "span" }, { children: topContent }))) : (topContent)] })), jsx(Button, { "aria-label": "close-button", variant: "textGray", leftIcon: jsx(XOutline, {}), onClick: handleClose, styleProps: getThemeProp(theme, "".concat(variantPrefix, ".closeButton")) })] })), title && (jsxs(Box, __assign({ variant: "".concat(variantPrefix, ".titleContainer") }, titleProps, { children: [typeof title === 'string' ? (jsx(Typography, __assign({ variant: "headingXsBold", as: "span", styleProps: getThemeProp(theme, "".concat(variantPrefix, ".title")) }, { children: title }))) : (title), titleAdditionalContent] }))), divider && jsx(Divider, {})] })));
});

var DrawerContent = buildLMComponent(function DrawerContent(props, ref) {
    var children = props.children, _a = props.variant, variant = _a === void 0 ? 'default' : _a, rest = __rest(props, ["children", "variant"]);
    return (jsx(Box, __assign({ ref: ref, variant: "drawer.content.".concat(variant, ".container") }, rest, { children: children })));
});

var DrawerActions = buildLMComponent(function DrawerActions(props, ref) {
    var children = props.children, _a = props.variant, variant = _a === void 0 ? 'default' : _a, rest = __rest(props, ["children", "variant"]);
    return (jsx(Box, __assign({ ref: ref, variant: "drawer.actions.".concat(variant, ".container") }, rest, { children: children })));
});

var Switch = buildLMComponent(function Switch(props, ref) {
    var _a = props.size, size = _a === void 0 ? 'medium' : _a, rest = __rest(props, ["size"]);
    var theme = useLMTheme().theme;
    return (jsx(Switch$1, __assign({ ref: ref, sx: __assign({}, getThemeProp(theme, "forms.switch.sizes.".concat(size))) }, rest)));
});

var CheckboxCheckedFilled = createSvgIcon(jsx("path", { fill: "currentColor", d: "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Zm-9 14-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9Z" }), 'CheckboxCheckedFilled');

var CheckboxDisabledBackground = createSvgIcon(jsx("rect", { x: "5", y: "5", width: "14", height: "14", fill: "#84848C", fillOpacity: "0.05" }), 'CheckboxDisabledBackground');

var CheckboxIndeterminatedFilled = createSvgIcon(jsx("path", { fill: "currentColor", d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Zm-2 10H7v-2h10v2Z" }), 'CheckboxIndeterminatedFilled');

var CheckboxUncheckedFilled = createSvgIcon(jsx("path", { fill: "currentColor", d: "M19 5v14H5V5zm0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2" }), 'CheckboxUncheckedFilled', { viewBox: '0 0 24 24' });

var CheckboxIcon = function (props) {
    var checked = props.checked, indeterminate = props.indeterminate, rest = __rest(props, ["checked", "indeterminate"]);
    var Icon;
    if (indeterminate)
        Icon = CheckboxIndeterminatedFilled;
    else if (checked)
        Icon = CheckboxCheckedFilled;
    else
        Icon = CheckboxUncheckedFilled;
    return jsx(Icon, __assign({}, rest));
};
var Checkbox = buildLMComponent(function Checkbox(props, ref) {
    var checked = props.checked, indeterminate = props.indeterminate, _a = props.size, size = _a === void 0 ? 'medium' : _a, styleProps = props.styleProps, onChange = props.onChange, disabled = props.disabled, rest = __rest(props, ["checked", "indeterminate", "size", "styleProps", "onChange", "disabled"]);
    var theme = useLMTheme().theme;
    var variant = checked ? 'checked' : indeterminate ? 'indeterminate' : 'unchecked';
    return (jsxs(Box, __assign({ variant: 'forms.checkbox.default', styleProps: __assign({ ':hover': {
                '> svg': __assign({}, (!checked && !indeterminate && !disabled ? getThemeProp(theme, "forms.checkbox.hovered") : {}))
            } }, styleProps) }, { children: [jsx(Box, __assign({ ref: ref, as: "input", type: "checkbox", checked: checked, onChange: onChange, disabled: disabled, "aria-checked": indeterminate && 'mixed' }, rest, { sx: {
                    cursor: !disabled ? 'pointer' : 'not-allowed',
                    position: 'absolute',
                    opacity: 0,
                    overflow: 'hidden',
                    left: 0,
                    top: 0,
                    right: 0,
                    bottom: 0
                } })), disabled && !checked && !indeterminate && (jsx(CheckboxDisabledBackground, { styleProps: __assign(__assign({}, getThemeProp(theme, "forms.checkbox.sizes.".concat(size))), { position: 'absolute' }) })), jsx(CheckboxIcon, { checked: checked, indeterminate: indeterminate, styleProps: __assign(__assign(__assign({}, getThemeProp(theme, "forms.checkbox.sizes.".concat(size))), getThemeProp(theme, "forms.checkbox.".concat(variant))), (disabled ? getThemeProp(theme, "forms.checkbox.disabled") : {})) })] })));
});

var Differential = buildLMComponent(function Differential(props) {
    var _a = props.variant, variant = _a === void 0 ? 'up' : _a, label = props.label;
    var theme = useLMTheme().theme;
    var statusStyles = React__default.useCallback(function () {
        return getThemeProp(theme, "forms.statusIndicator.differential.".concat(variant));
    }, [theme, variant]);
    return (jsxs(Box, __assign({ styleProps: { display: 'flex', alignItems: 'baseline' } }, { children: [label && jsx(InputLabel, __assign({ style: { marginRight: '6px', marginBottom: 0 } }, { children: label })), variant === 'up'
                ? jsx(Box, { children: jsx(InputLabel, __assign({ styleProps: __assign({}, statusStyles()) }, { children: "\u25B2" })) })
                : jsx(Box, { children: jsx(InputLabel, __assign({ styleProps: __assign({}, statusStyles()) }, { children: "\u25BC" })) })] })));
});

var Dot = function (props) {
    var _a = props.status, status = _a === void 0 ? 'success' : _a, label = props.label, styleProps = props.styleProps;
    var theme = useLMTheme().theme;
    var statusStyles = React__default.useCallback(function () {
        var style = getThemeProp(theme, "forms.statusIndicator.dot.".concat(status));
        if (status === 'custom' && styleProps)
            style = __assign(__assign({}, style), styleProps);
        return style;
    }, [theme, status, styleProps]);
    return (jsxs(Box, __assign({ styleProps: { display: 'flex', alignItems: 'center' } }, { children: [jsx(Box, { styleProps: __assign({}, statusStyles()) }), label && jsx(InputLabel, __assign({ styleProps: { marginLeft: 'spacing-8' } }, { children: label }))] })));
};

var StatusIndicator = function (props) {
    var _a = props.type, type = _a === void 0 ? 'dot' : _a;
    return type === 'dot' ? jsx(Dot, __assign({}, props)) : jsx(Differential, __assign({}, props));
};

/**
 * Custom hook that merges multiple functions into a single function.
 *
 * @returns An object containing the merging function.
 */
var useMergeFunctions = function () {
    var mergeFunctions = React__default.useCallback(
    /**
     * Merges multiple functions into a single function.
     *
     * @param functions - An array of functions to be merged.
     * @returns A function that calls each merged function with the provided arguments.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function () {
        var functions = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            functions[_i] = arguments[_i];
        }
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            functions.forEach(function (fn) {
                // Allowing undefined for easier usage when some functions are optional
                if (fn !== undefined)
                    return fn.apply(void 0, args);
            });
        };
    }, []);
    return { mergeFunctions: mergeFunctions };
};

/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 */
function useMergeRefs(refs) {
    return React__default.useMemo(function () {
        if (refs.every(function (ref) { return ref == null; })) {
            return null;
        }
        return function (value) {
            refs.forEach(function (ref) {
                if (typeof ref === 'function') {
                    ref(value);
                }
                else if (ref != null) {
                    ref.current = value;
                }
            });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

var SearchOutline = createSvgIcon([jsx("path", { stroke: "none", d: "M0 0h24v24H0z" }, "0"), jsx("path", { d: "M3 10a7 7 0 1 0 14 0 7 7 0 1 0-14 0m18 11-6-6" }, "1")], 'SearchOutline', { stroke: 'currentColor', strokeLinecap: 'round', strokeWidth: '1.5', fill: 'none', viewBox: '0 0 24 24' });

var Search = buildLMComponent(function (props, ref) {
    var inputValue = props.inputValue, options = props.options, size = props.size, label = props.label, placeholder = props.placeholder, onOptionSelect = props.onOptionSelect, noOptionsContent = props.noOptionsContent, renderOption = props.renderOption, loading = props.loading, error = props.error, inputProps = props.inputProps, propsOnInputChange = props.onInputChange;
    var _a = React__default.useState(false), open = _a[0], setOpen = _a[1];
    var inputRef = React__default.useRef(null);
    var _b = React__default.useState(null), activeIndex = _b[0], setActiveIndex = _b[1];
    var firstRender = React__default.useRef(true);
    var mergedRef = useMergeRefs([inputRef, ref]);
    var mergeFunctions = useMergeFunctions().mergeFunctions;
    var onOpenChange = React__default.useCallback(function (open) {
        setOpen(open);
    }, []);
    React__default.useEffect(function () {
        if (!firstRender.current) {
            onOpenChange(!!options && !loading);
        }
        firstRender.current = false;
    }, [loading, onOpenChange, options]);
    var onInputChange = React__default.useMemo(function () {
        return mergeFunctions(function (ev) {
            var value = ev.target.value;
            propsOnInputChange(value, 'change');
        }, inputProps === null || inputProps === void 0 ? void 0 : inputProps.onChange);
    }, [mergeFunctions, inputProps === null || inputProps === void 0 ? void 0 : inputProps.onChange, propsOnInputChange]);
    var handleInputClear = React__default.useCallback(function () {
        propsOnInputChange('', 'clear');
    }, [propsOnInputChange]);
    var afterSelect = React__default.useCallback(function () {
        var _a;
        onOpenChange(false);
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
    }, [onOpenChange]);
    var onOptionSelected = React__default.useCallback(function (value) {
        var option = options.find(function (option) { return option.value === value; });
        option && onOptionSelect(option);
        afterSelect();
    }, [options, onOptionSelect, afterSelect]);
    var onFocusInput = React__default.useMemo(function () {
        return mergeFunctions(function () {
            onOpenChange(true);
        }, inputProps === null || inputProps === void 0 ? void 0 : inputProps.onFocus);
    }, [mergeFunctions, inputProps === null || inputProps === void 0 ? void 0 : inputProps.onFocus, onOpenChange]);
    var onInputKeyDown = React__default.useMemo(function () {
        return mergeFunctions(function (event) {
            if (event.key === 'Enter' && activeIndex !== null && (options === null || options === void 0 ? void 0 : options.length) && options[activeIndex]) {
                event.stopPropagation();
                onOptionSelect(options[activeIndex]);
                afterSelect();
            }
        }, inputProps === null || inputProps === void 0 ? void 0 : inputProps.onKeyDown);
    }, [activeIndex, afterSelect, inputProps === null || inputProps === void 0 ? void 0 : inputProps.onKeyDown, mergeFunctions, onOptionSelect, options]);
    var optionsContent = React__default.useMemo(function () {
        if (!options)
            return null;
        if (options.length === 0) {
            return (jsx(Box, __assign({ variant: "boxes.option", styleProps: { '&:hover': { backgroundColor: 'transparent' }, cursor: 'default' } }, { children: noOptionsContent || (jsx(Typography, __assign({ variant: "textSmRegular", styleProps: { color: 'text.low' } }, { children: "No options available" }))) })));
        }
        return options.map(function (option) { return (jsx(Option, __assign({ label: option.label, value: option.value }, { children: renderOption ? renderOption(option) : option.label }), option.id || option.value)); });
    }, [options, noOptionsContent, renderOption]);
    var showDropdown = open && optionsContent !== null;
    var endIcon = React__default.useMemo(function () {
        if (loading) {
            return jsx(Loader, { size: 16 });
        }
        else if (inputValue !== '') {
            return (jsx(Button, { onClick: handleInputClear, variant: 'textGray', leftIcon: jsx(XOutline, {}), styleProps: { cursor: 'pointer', pointerEvents: 'all', padding: '2px !important', minHeight: 'auto' } }));
        }
        else {
            return null;
        }
    }, [inputValue, loading, handleInputClear]);
    return (jsx(Dropdown, __assign({ navigation: optionsContent !== null, open: showDropdown, onOpen: onOpenChange, onChange: onOptionSelected, useReferenceWidth: true, typeahead: false, popoverProps: {
            activeIndex: activeIndex,
            onActiveIndexChange: setActiveIndex,
            virtualNavigation: true
        }, popovercontentProps: {
            returnFocus: false
        }, popoverTrigger: jsx(Input, __assign({ ref: mergedRef, value: inputValue, placeholder: placeholder, sizeVariant: size, label: label, startIcon: jsx(SearchOutline, {}), endIcon: endIcon, role: "combobox", "aria-autocomplete": "list", styleProps: __assign({ fontSize: 2 }, inputProps === null || inputProps === void 0 ? void 0 : inputProps.styleProps), error: error }, inputProps, { onFocus: onFocusInput, onKeyDown: onInputKeyDown, onChange: onInputChange })) }, { children: optionsContent })));
});

var MultiValueSelect = function MultiValueSelect(props) {
    var controlledSelectedOptions = props.selectedOptions, controlledOptions = props.options, onInput = props.onInput, onRemove = props.onRemove, onSelect = props.onSelect, onClear = props.onClear, onDropdownClose = props.onDropdownClose, onChange = props.onChange, optionDecorator = props.optionDecorator, placeholder = props.placeholder, error = props.error, disabled = props.disabled, controlledIsLoading = props.isLoading, noOptionsText = props.noOptionsText, styleProps = props.styleProps, rest = __rest(props, ["selectedOptions", "options", "onInput", "onRemove", "onSelect", "onClear", "onDropdownClose", "onChange", "optionDecorator", "placeholder", "error", "disabled", "isLoading", "noOptionsText", "styleProps"]);
    var mounted = React__default.useRef(true);
    var inputRef = React__default.useRef(null);
    var prevValue = React__default.useRef('');
    var _a = React__default.useState(false), navigation = _a[0], setNavigation = _a[1];
    var _b = React__default.useState(undefined), options = _b[0], setOptions = _b[1];
    var _c = React__default.useState([]), selectedOptions = _c[0], setSelectedOptions = _c[1];
    var _d = React__default.useState(false), isLoading = _d[0], setIsLoading = _d[1];
    // Update the selected options when the parent changes them.
    useEffect(function () {
        if (controlledSelectedOptions !== undefined) {
            setSelectedOptions(__spreadArray([], controlledSelectedOptions, true));
        }
    }, [controlledSelectedOptions]);
    // Update the options when the parent changes them.
    useEffect(function () {
        if (controlledOptions !== undefined) {
            setOptions(__spreadArray([], controlledOptions, true));
        }
    }, [controlledOptions]);
    // Update the loading state when the parent changes it.
    useEffect(function () {
        if (controlledIsLoading !== undefined) {
            setIsLoading(controlledIsLoading);
        }
    }, [controlledIsLoading]);
    // Track the component's mounted state.
    useEffect(function () {
        mounted.current = true;
        return function () {
            mounted.current = false;
        };
    }, []);
    var focusInput = function () {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };
    var clearInput = function () {
        if (inputRef.current) {
            prevValue.current = '';
            inputRef.current.value = '';
        }
    };
    // Handle the removal of an option.
    var handleRemove = React__default.useCallback(function (removedOption) {
        var newSelectedOptions = selectedOptions.filter(function (option) { return option.value !== removedOption.value; });
        setSelectedOptions(newSelectedOptions);
        onChange && onChange(__spreadArray([], newSelectedOptions, true));
        onRemove && onRemove(removedOption);
    }, [selectedOptions, onRemove, onChange]);
    // Handle the clear action.
    var handleClear = React__default.useCallback(function () {
        setOptions(undefined);
        setSelectedOptions([]);
        onChange && onChange([]);
        onClear && onClear();
    }, [onChange, onClear]);
    // Handle the keyboard events on the input.
    var handleInput = function (event) {
        var value = event.currentTarget.value;
        if (event.key === 'ArrowDown' && options && options.length !== 0) {
            setNavigation(true);
        }
        else if (event.key === 'Backspace' && prevValue.current === '' && selectedOptions.length > 0) {
            handleRemove(selectedOptions[selectedOptions.length - 1]);
        }
        else if (value !== '' && value !== prevValue.current) {
            var promise = onInput(value);
            // Check if we received a promise, if so, we need to wait for it to resolve.
            // Otherwise, we expect the parent to control the options.
            if (promise) {
                setIsLoading(true);
                promise
                    .then(function (options) {
                    mounted.current && setOptions(__spreadArray([], options, true));
                })
                    .finally(function () {
                    mounted.current && setIsLoading(false);
                });
            }
        }
        prevValue.current = value;
    };
    var handlePopoverClose = function () {
        // Reset the input after the selection.
        clearInput();
        focusInput();
        setOptions(undefined);
        onDropdownClose && onDropdownClose();
    };
    // Create the options that are selected.
    var selectedOptionsContent = React__default.useMemo(function () {
        if (selectedOptions.length === 0) {
            return null;
        }
        return selectedOptions.map(function (option) { return (jsx(Tag, { label: option.label, onDelete: function () { return handleRemove(option); }, disabled: disabled }, option.id || option.value)); });
    }, [selectedOptions, handleRemove, disabled]);
    // Create the options that are available for selection.
    var optionsContent = React__default.useMemo(function () {
        if (options === undefined || disabled) {
            return null;
        }
        if (options.length === 0) {
            return (jsx(Box, __assign({ variant: "boxes.option", styleProps: { '&:hover': { backgroundColor: 'transparent' }, color: 'text.low', cursor: 'default' } }, { children: noOptionsText || 'No results found' })));
        }
        if (optionDecorator) {
            return options.map(optionDecorator);
        }
        return options.map(function (_a) {
            var id = _a.id, value = _a.value, label = _a.label;
            return (jsx(Option, __assign({ value: value }, { children: label }), id || value));
        });
    }, [options, optionDecorator, noOptionsText, disabled]);
    var handleOptionSelected = function (value) {
        // Inform the parent that this option was selected.
        if (options) {
            var option = options.find(function (option) { return option.value === value; });
            if (option) {
                var newSelectedOptions = __spreadArray(__spreadArray([], selectedOptions, true), [option], false);
                setOptions(undefined);
                setSelectedOptions(newSelectedOptions);
                onSelect && onSelect(option);
                onChange && onChange(__spreadArray([], newSelectedOptions, true));
            }
        }
        // Reset the input after the selection.
        clearInput();
        focusInput();
    };
    var showDropdown = optionsContent !== null;
    var focusDropdown = showDropdown && navigation;
    return (jsxs(Popover, __assign({ placement: 'bottom-start', offsetValue: 4, open: showDropdown, onOpenChange: handlePopoverClose, navigation: focusDropdown, useReferenceWidth: true }, { children: [jsx(PopoverTrigger, { children: jsxs(Box, __assign({ variant: 'boxes.multiValueSelect', styleProps: styleProps, onClick: focusInput, role: "combobox", "aria-disabled": disabled, "aria-invalid": error }, rest, { children: [selectedOptionsContent, jsx("input", { ref: inputRef, onFocus: function () { return setNavigation(false); }, onBlur: function () { return setNavigation(true); }, placeholder: placeholder, onKeyUp: handleInput, disabled: disabled, role: "searchbox" }), isLoading ? (jsx(Loader, { size: 16, className: 'multi-value-select-loading' })) : (selectedOptions.length > 0 && (jsx(Tooltip, __assign({ content: 'Clear all' }, { children: jsx(Button, { onClick: handleClear, variant: 'textGray', leftIcon: jsx(XOutline, {}), className: 'multi-value-select-clear', disabled: disabled }) }))))] })) }), jsx(PopoverContent, __assign({ styleProps: { variant: 'boxes.dropdown', minWidth: '100%' }, disableFocusManagement: !focusDropdown }, { children: jsx(PopoverList, __assign({ onOptionSelected: handleOptionSelected }, { children: optionsContent })) }))] })));
};
var MultiValueSelect$1 = buildLMComponent(MultiValueSelect);

var Menu = buildLMComponent(function Menu(props) {
    var _a;
    var _b = props.type, type = _b === void 0 ? 'multi' : _b, selectedValues = props.selectedValues, displayedValues = props.displayedValues, onChange = props.onChange, initialOpen = props.initialOpen, propsOpen = props.open, propsOnOpenChange = props.onOpenChange, popoverProps = props.popoverProps, propsSearchable = props.searchable, _c = props.loading, loading = _c === void 0 ? false : _c, onSearchInputChange = props.onSearchInputChange, propsRenderValue = props.renderValue, propsSearchInputValue = props.searchInputValue;
    var _d = React__default.useState((_a = propsOpen !== null && propsOpen !== void 0 ? propsOpen : initialOpen) !== null && _a !== void 0 ? _a : false), open = _d[0], setOpen = _d[1];
    var _e = React__default.useState(true), navigation = _e[0], setNavigation = _e[1];
    var _f = React__default.useState(propsSearchInputValue || ''), searchInputValue = _f[0], setSearchInputValue = _f[1];
    var _g = React__default.useState([]), values = _g[0], setValues = _g[1];
    var openControlled = propsOpen !== undefined;
    React__default.useEffect(function () {
        openControlled && setOpen(propsOpen || false);
    }, [openControlled, propsOpen]);
    React__default.useEffect(function () {
        setSearchInputValue(propsSearchInputValue || '');
    }, [propsSearchInputValue]);
    var onOpenChange = React__default.useCallback(function (open) {
        if (openControlled)
            propsOnOpenChange && propsOnOpenChange(open);
        else
            setOpen(open);
    }, [propsOnOpenChange, openControlled]);
    var onOpenHandler = React__default.useCallback(function () {
        onOpenChange(true);
    }, [onOpenChange]);
    var onCloseHandler = React__default.useCallback(function () {
        onOpenChange(false);
    }, [onOpenChange]);
    var onClearHandler = React__default.useCallback(function () {
        onChange([]);
    }, [onChange]);
    var onChangeHandler = React__default.useCallback(function (value) {
        if (type === 'single') {
            onChange([value]);
        }
        else {
            if (selectedValues.includes(value)) {
                onChange(selectedValues.filter(function (v) { return v !== value; }));
            }
            else {
                onChange(__spreadArray(__spreadArray([], selectedValues, true), [value], false));
            }
        }
    }, [onChange, selectedValues, type]);
    var onSearchInputHandler = React__default.useCallback(function (value) {
        setSearchInputValue(value);
        onSearchInputChange && onSearchInputChange(value);
    }, [onSearchInputChange]);
    var renderValue = React__default.useCallback(function (value) { return (propsRenderValue ? propsRenderValue(value) : value); }, [propsRenderValue]);
    var registerOption = React__default.useCallback(function (value) {
        setValues(function (prev) { return __spreadArray(__spreadArray([], prev, true), [value], false); });
    }, []);
    var unregisterOption = React__default.useCallback(function (value) {
        setValues(function (prev) { return prev.filter(function (v) { return v !== value; }); });
    }, []);
    var isValueDisplayed = React__default.useCallback(function (value) { return !displayedValues || displayedValues.includes(value); }, [displayedValues]);
    var searchable = React__default.useMemo(function () { return (propsSearchable !== undefined && propsSearchable) || (propsSearchable === undefined && values.length > 7); }, [propsSearchable, values.length]);
    var context = React__default.useMemo(function () { return ({
        type: type,
        selectedValues: selectedValues,
        open: open,
        renderValue: renderValue,
        onOpen: onOpenHandler,
        onClose: onCloseHandler,
        onChange: onChangeHandler,
        onClear: onClearHandler,
        onNavigationChange: setNavigation,
        registerOption: registerOption,
        unregisterOption: unregisterOption,
        isValueDisplayed: isValueDisplayed,
        searchable: searchable,
        searchInputValue: searchInputValue,
        loading: loading,
        values: values,
        onSearchInputChange: onSearchInputHandler
    }); }, [
        type,
        values,
        selectedValues,
        open,
        isValueDisplayed,
        renderValue,
        onOpenHandler,
        onCloseHandler,
        onChangeHandler,
        onClearHandler,
        registerOption,
        unregisterOption,
        searchable,
        searchInputValue,
        loading,
        onSearchInputHandler
    ]);
    return (jsx(MenuContext.Provider, __assign({ value: context }, { children: jsx(Popover, __assign({ open: open, onOpenChange: onOpenChange, autoClick: true, placement: "bottom-start", navigation: navigation }, popoverProps, { children: props.children })) })));
});

var useStyles$1 = makeLMStyles(function (props) { return ({
    popoverStyles: __assign({ borderColor: 'border.neutral.default', borderWidth: '1px', borderRadius: 'radius4', borderStyle: 'solid', minWidth: '232px', maxWidth: '460px', boxShadow: 'md', backgroundColor: 'white', zIndex: 'dropdown' }, props === null || props === void 0 ? void 0 : props.styleProps),
    searchBarContainer: {
        paddingX: 'spacing-16',
        paddingTop: 'spacing-16',
        paddingBottom: 'spacing-8',
        position: 'static',
        top: 'auto',
        left: 'auto',
        zIndex: 'auto'
    },
    searchBar: {
        height: '32px',
        paddingLeft: 'spacing-32',
        paddingY: 'spacing-16'
    },
    loaderContainer: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '10px',
        height: 120
    },
    popoverButtonsContainer: {
        paddingX: 'spacing-16',
        paddingY: 'spacing-8',
        borderTopWidth: '1px',
        borderTopStyle: 'solid',
        borderTopColor: 'border.subtle',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center'
    },
    clearButton: {
        textTransform: 'uppercase',
        color: 'text.low'
    },
    doneButton: {
        textTransform: 'uppercase'
    },
    footer: {
        paddingX: 'spacing-16',
        paddingY: 'spacing-8',
        borderTopWidth: '1px',
        borderTopStyle: 'solid',
        borderTopColor: 'border.subtle',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center'
    },
    footerContentContainer: {
        flex: 1,
        display: 'flex'
    }
}); });

/**
 * @summary Popover content for the menu component, with search input and clear/close buttons
 */
var MenuDropdown = buildLMComponent(function MenuDropdown(props, ref) {
    var children = props.children, _a = props.clearLabel, clearLabel = _a === void 0 ? 'Clear' : _a, _b = props.doneLabel, doneLabel = _b === void 0 ? 'Done' : _b, _c = props.searchInputPlaceholder, searchInputPlaceholder = _c === void 0 ? 'Search' : _c, _d = props.loadingOptionsLabel, loadingOptionsLabel = _d === void 0 ? 'Loading options...' : _d, _e = props.displayClearButton, displayClearButton = _e === void 0 ? true : _e, styleProps = props.styleProps, propsOnClear = props.onClear, propsOnDone = props.onDone, footerContent = props.footerContent, searchInputProps = props.searchInputProps, clearButtonProps = props.clearButtonProps, doneButtonProps = props.doneButtonProps, rest = __rest(props, ["children", "clearLabel", "doneLabel", "searchInputPlaceholder", "loadingOptionsLabel", "displayClearButton", "styleProps", "onClear", "onDone", "footerContent", "searchInputProps", "clearButtonProps", "doneButtonProps"]);
    var styles = useStyles$1({ styleProps: styleProps });
    var _f = useMenuContext(), onClose = _f.onClose, onClear = _f.onClear, onNavigationChange = _f.onNavigationChange, _g = _f.searchInputValue, searchInputValue = _g === void 0 ? '' : _g, onSearchInputChange = _f.onSearchInputChange, searchable = _f.searchable, loading = _f.loading;
    var popoverRef = React__default.useRef(null);
    var inputRef = React__default.useRef(null);
    var inputChangeHandler = React__default.useCallback(function (ev) {
        var value = ev.target.value;
        onSearchInputChange && onSearchInputChange(value);
    }, [onSearchInputChange]);
    var inputBlurHandler = React__default.useCallback(function (ev) {
        onNavigationChange(true);
        (searchInputProps === null || searchInputProps === void 0 ? void 0 : searchInputProps.onBlur) && searchInputProps.onBlur(ev);
    }, [onNavigationChange, searchInputProps]);
    var inputFocusHandler = React__default.useCallback(function (ev) {
        onNavigationChange(false);
        (searchInputProps === null || searchInputProps === void 0 ? void 0 : searchInputProps.onFocus) && searchInputProps.onFocus(ev);
    }, [onNavigationChange, searchInputProps]);
    var handleKeyboard = React__default.useCallback(function (event) {
        event.key === 'ArrowDown' && inputRef.current.blur();
        (searchInputProps === null || searchInputProps === void 0 ? void 0 : searchInputProps.onKeyUp) && searchInputProps.onKeyUp(event);
    }, [searchInputProps]);
    var onCloseHandler = React__default.useCallback(function () {
        propsOnDone && propsOnDone();
        onClose();
    }, [onClose, propsOnDone]);
    var onClearHandler = React__default.useCallback(function () {
        propsOnClear && propsOnClear();
        onClear();
    }, [onClear, propsOnClear]);
    React__default.useImperativeHandle(ref, function () { return ({
        popover: popoverRef.current,
        input: inputRef.current
    }); });
    return (jsxs(PopoverContent, __assign({ ref: popoverRef, styleProps: styles.popoverStyles }, rest, { children: [searchable && (jsx(Box, __assign({ styleProps: styles.searchBarContainer }, { children: jsx(Input, __assign({ ref: inputRef, placeholder: searchInputPlaceholder, startIcon: jsx(SearchOutline, { styleProps: { fontSize: '16px !important' } }), iconStyle: { marginLeft: 'spacing-8' }, styleProps: styles.searchBar }, searchInputProps, { value: searchInputValue, onChange: inputChangeHandler, onFocus: inputFocusHandler, onBlur: inputBlurHandler, onKeyUp: handleKeyboard })) }))), jsx(Box, { children: loading ? (jsxs(Box, __assign({ styleProps: styles.loaderContainer }, { children: [jsx(Loader, { size: 40 }), jsx(Typography, __assign({ as: "span", variant: "textSmRegular" }, { children: loadingOptionsLabel }))] }))) : (children) }), jsxs(Box, __assign({ styleProps: styles.footer }, { children: [footerContent && jsx(Box, __assign({ styleProps: styles.footerContentContainer }, { children: footerContent })), displayClearButton && (jsx(Button, __assign({ variant: "textGray", size: "small", onClick: onClearHandler }, clearButtonProps, { styleProps: __assign({ textTransform: 'uppercase', color: 'text.low' }, clearButtonProps === null || clearButtonProps === void 0 ? void 0 : clearButtonProps.styleProps) }, { children: clearLabel }))), jsx(Button, __assign({ variant: "textPrimary", size: "small", onClick: onCloseHandler }, doneButtonProps, { styleProps: __assign({ textTransform: 'uppercase' }, doneButtonProps === null || doneButtonProps === void 0 ? void 0 : doneButtonProps.styleProps) }, { children: doneLabel }))] }))] })));
});

/**
 * @summary Component designed to be used as wrapper of MenuOption components
 */
var MenuOptionList = buildLMComponent(function MenuOptionList(props, ref) {
    var children = props.children, _a = props.optionHeight, optionHeight = _a === void 0 ? 36 : _a, _b = props.optionsToScroll, optionsToScroll = _b === void 0 ? 7 : _b, boxProps = props.boxProps, _c = props.disableScroll, disableScroll = _c === void 0 ? false : _c, rest = __rest(props, ["children", "optionHeight", "optionsToScroll", "boxProps", "disableScroll"]);
    var styleProps = React__default.useMemo(function () {
        var maxHeight = optionHeight * optionsToScroll;
        var propsStyleProps = (boxProps === null || boxProps === void 0 ? void 0 : boxProps.styleProps) || {};
        return __assign(__assign({ maxHeight: disableScroll ? 'none' : maxHeight, overflow: 'auto', paddingY: 'spacing-4' }, propsStyleProps), { '&:hover': __assign({ overflowY: 'auto' }, ((propsStyleProps === null || propsStyleProps === void 0 ? void 0 : propsStyleProps['&:hover']) || {})) });
    }, [boxProps, optionHeight, optionsToScroll, disableScroll]);
    return (jsx(PopoverList, __assign({}, rest, { children: jsx(Box, __assign({ ref: ref }, boxProps, { styleProps: styleProps }, { children: children })) })));
});

var RadioChecked = createSvgIcon(jsxs(Fragment, { children: [jsx("path", { d: "M12.2922 2C6.77224 2 2.29224 6.48 2.29224 12C2.29224 17.52 6.77224 22 12.2922 22C17.8122 22 22.2922 17.52 22.2922 12C22.2922 6.48 17.8122 2 12.2922 2ZM12.2922 20C7.87224 20 4.29224 16.42 4.29224 12C4.29224 7.58 7.87224 4 12.2922 4C16.7122 4 20.2922 7.58 20.2922 12C20.2922 16.42 16.7122 20 12.2922 20Z", fill: "currentColor" }), jsx("path", { d: "M12.2922 17C15.0537 17 17.2922 14.7614 17.2922 12C17.2922 9.23858 15.0537 7 12.2922 7C9.53081 7 7.29224 9.23858 7.29224 12C7.29224 14.7614 9.53081 17 12.2922 17Z", fill: "currentColor" })] }), 'RadioChecked', { viewBox: '0 0 25 24' });

var RadioDisabledBackground = createSvgIcon(jsx("circle", { cx: "12.3", cy: "12.1", r: "8", fill: "#84848C", fillOpacity: "0.05" }), 'RadioDisabledBackground', {
    viewBox: '0 0 25 24'
});

var RadioUnchecked = createSvgIcon(jsx("path", { d: "M12.2922 2.12354C6.77224 2.12354 2.29224 6.60354 2.29224 12.1235C2.29224 17.6435 6.77224 22.1235 12.2922 22.1235C17.8122 22.1235 22.2922 17.6435 22.2922 12.1235C22.2922 6.60354 17.8122 2.12354 12.2922 2.12354ZM12.2922 20.1235C7.87224 20.1235 4.29224 16.5435 4.29224 12.1235C4.29224 7.70354 7.87224 4.12354 12.2922 4.12354C16.7122 4.12354 20.2922 7.70354 20.2922 12.1235C20.2922 16.5435 16.7122 20.1235 12.2922 20.1235Z", fill: "currentColor" }), 'RadioUnchecked', { viewBox: '0 0 25 24' });

var RadioContext = React__default.createContext(null);
var RadioGroup = buildLMComponent(function RadioGroup(props, ref) {
    var value = props.value, onChange = props.onChange, styleProps = props.styleProps;
    var _a = React__default.useState(value), stateValue = _a[0], setStateValue = _a[1];
    var handleChange = React__default.useCallback(function (newValue) {
        if (onChange)
            onChange(newValue);
        if (!value)
            setStateValue(newValue);
    }, [onChange, value]);
    React__default.useEffect(function () {
        setStateValue(value);
    }, [value]);
    return (jsx(Box, __assign({ ref: ref, styleProps: styleProps }, { children: jsx(RadioContext.Provider, __assign({ value: { value: stateValue, onChange: handleChange } }, { children: props.children })) })));
});

var Radio = buildLMComponent(function Radio(props, ref) {
    var value = props.value, checked = props.checked, onChange = props.onChange, disabled = props.disabled, _a = props.size, size = _a === void 0 ? 'medium' : _a, styleProps = props.styleProps, rest = __rest(props, ["value", "checked", "onChange", "disabled", "size", "styleProps"]);
    var radioContext = React__default.useContext(RadioContext);
    var theme = useLMTheme().theme;
    var isChecked = checked !== undefined ? checked : radioContext && value ? radioContext.value === value : undefined;
    var variant = isChecked ? 'checked' : 'unchecked';
    var RadioIcon = React__default.useMemo(function () {
        return isChecked ? RadioChecked : RadioUnchecked;
    }, [isChecked]);
    var handleChange = React__default.useCallback(function (event) {
        if (radioContext === null || radioContext === void 0 ? void 0 : radioContext.onChange)
            radioContext.onChange(value);
        if (onChange)
            onChange(event);
    }, [value, radioContext, onChange]);
    return (jsxs(Box, __assign({ variant: 'forms.radio.default', styleProps: __assign({ ':hover': {
                '> svg': __assign({}, (!isChecked && !disabled ? getThemeProp(theme, "forms.radio.hovered") : {}))
            } }, styleProps) }, { children: [jsx(Box, __assign({ ref: ref, as: "input", type: "radio", checked: isChecked, onChange: handleChange, disabled: disabled, "aria-checked": isChecked, value: value }, rest, { sx: {
                    cursor: !disabled ? 'pointer' : 'default',
                    position: 'absolute',
                    opacity: 0,
                    overflow: 'hidden',
                    left: 0,
                    top: 0,
                    right: 0,
                    bottom: 0
                } })), disabled && jsx(RadioDisabledBackground, { styleProps: __assign({ position: 'absolute' }, getThemeProp(theme, "forms.radio.sizes.".concat(size))) }), jsx(RadioIcon, { styleProps: __assign(__assign(__assign({}, getThemeProp(theme, "forms.radio.sizes.".concat(size))), getThemeProp(theme, "forms.radio.".concat(variant))), (disabled ? getThemeProp(theme, "forms.radio.disabled") : {})) })] })));
});

var MenuOption = buildLMComponent(function MenuOption(props, ref) {
    var value = props.value, children = props.children, inputAdditionalProps = props.inputAdditionalProps, rest = __rest(props, ["value", "children", "inputAdditionalProps"]);
    var _a = useMenuItem(value), selectedValues = _a.selectedValues, type = _a.type, onChange = _a.onChange, renderValue = _a.renderValue, displayed = _a.displayed;
    var checked = React__default.useMemo(function () { return selectedValues.includes(value); }, [selectedValues, value]);
    var onClickHandler = React__default.useCallback(function () {
        onChange(value);
    }, [onChange, value]);
    var onChangeHandler = React__default.useCallback(function (ev) {
        ev.preventDefault();
    }, []);
    var inputElement = React__default.useMemo(function () {
        if (type === 'multi') {
            return jsx(Checkbox, __assign({ checked: checked, onChange: onChangeHandler, value: value }, inputAdditionalProps));
        }
        else {
            return jsx(Radio, __assign({ value: value, checked: checked, onChange: onChangeHandler }, inputAdditionalProps));
        }
    }, [checked, onChangeHandler, type, value, inputAdditionalProps]);
    var renderedValue = React__default.useMemo(function () { return renderValue(value); }, [renderValue, value]);
    if (!displayed)
        return null;
    return (jsxs(Option, __assign({ ref: ref }, rest, { styleProps: __assign({ display: 'flex', height: '36px', alignItems: 'center', gap: 'spacing-8' }, rest.styleProps), onSelected: onClickHandler, value: value }, { children: [inputElement, jsx(Box, __assign({ styleProps: { overflow: 'hidden', textOverflow: 'ellipsis' } }, { children: children !== null && children !== void 0 ? children : (jsx(Typography, __assign({ as: 'span', variant: 'textSmRegular', styleProps: { color: 'text.default', whiteSpace: 'nowrap' }, title: typeof renderedValue === 'string' || typeof renderedValue === 'number' ? renderedValue.toString() : value.toString() }, { children: renderedValue }))) }))] })));
});

var useStyles = makeLMStyles(function () { return ({
    lineStyles: {
        width: '100%',
        borderColor: 'border.neutral.default'
    },
    titleStyles: {
        paddingTop: 'spacing-8',
        paddingBottom: 'spacing-8',
        paddingRight: 'spacing-16',
        paddingLeft: 'spacing-16',
        fontSize: 1,
        color: 'text.low'
    }
}); });

var MenuOptionGroup = buildLMComponent(function MenuOptionGroup(props, ref) {
    var title = props.title, children = props.children, _a = props.divider, divider = _a === void 0 ? true : _a, rest = __rest(props, ["title", "children", "divider"]);
    var styles = useStyles();
    return (jsxs(Box, __assign({ ref: ref }, rest, { children: [divider && jsx(Divider, { "data-testid": 'menu-option-group-line', styleProps: styles.lineStyles }), title && jsx(Typography, __assign({ styleProps: styles.titleStyles }, { children: title })), children] })));
});

var useModal = function (options) {
    if (options === void 0) { options = {}; }
    var _a = options.initialOpen, initialOpen = _a === void 0 ? false : _a, controlledOpen = options.open, setControlledOpen = options.onOpenChange, _b = options.variant, variant = _b === void 0 ? 'aligned' : _b;
    var _c = React__default.useState(initialOpen), uncontrolledOpen = _c[0], setUncontrolledOpen = _c[1];
    var _d = React__default.useState(), labelId = _d[0], setLabelId = _d[1];
    var _e = React__default.useState(), descriptionId = _e[0], setDescriptionId = _e[1];
    var open = controlledOpen !== null && controlledOpen !== void 0 ? controlledOpen : uncontrolledOpen;
    var setOpen = setControlledOpen !== null && setControlledOpen !== void 0 ? setControlledOpen : setUncontrolledOpen;
    var data = useFloating({
        open: open,
        onOpenChange: setOpen
    });
    var context = data.context;
    var click = useClick(context, {
        enabled: controlledOpen == null
    });
    var dismiss = useDismiss(context, { outsidePressEvent: 'mousedown' });
    var role = useRole(context);
    var interactions = useInteractions([click, dismiss, role]);
    // This duration has to match the the transition length of the floating element (check modal content component)
    var transitionStatus = useTransitionStatus(context, { duration: 300 });
    return React__default.useMemo(function () { return (__assign(__assign(__assign({ open: open, setOpen: setOpen }, interactions), data), { labelId: labelId, descriptionId: descriptionId, setLabelId: setLabelId, setDescriptionId: setDescriptionId, variant: variant, transitionStatus: transitionStatus })); }, [open, setOpen, interactions, data, labelId, descriptionId, variant, transitionStatus]);
};
var ModalContext = React__default.createContext(null);

var Modal = buildLMComponent(function Modal(_a) {
    var children = _a.children, options = __rest(_a, ["children"]);
    var dialog = useModal(options);
    return jsx(ModalContext.Provider, __assign({ value: dialog }, { children: children }));
});

var useVariant = function (themePath, variant, defaultVariant) {
    if (defaultVariant === void 0) { defaultVariant = 'default'; }
    var theme = useLMTheme().theme;
    var variantKey = variant;
    var variantExists = !!get$1(theme, "".concat(themePath, ".").concat(variantKey));
    if (!variantExists)
        variantKey = defaultVariant;
    return variantKey;
};
var useGetThemeProps = function () {
    var theme = useLMTheme().theme;
    var get = React__default.useCallback(function (path) { return getThemeProp(theme, path); }, [theme]);
    return { get: get };
};

var useModalContext = function () {
    var context = React__default.useContext(ModalContext);
    if (context == null) {
        throw new Error('Modal components must be wrapped in <Modal />');
    }
    return context;
};
var useSelectedModalVariant = function (props, modalComponent, defaultComponentVariant) {
    var _a;
    if (defaultComponentVariant === void 0) { defaultComponentVariant = 'aligned'; }
    var variant = useModalContext().variant;
    var variantKey = (_a = props.variant) !== null && _a !== void 0 ? _a : variant;
    var modalComponentPrefix = "modal.".concat(modalComponent);
    var finalVariant = useVariant(modalComponentPrefix, variantKey, defaultComponentVariant);
    return "".concat(modalComponentPrefix, ".").concat(finalVariant);
};

var ModalContent = buildLMComponent(function ModalContent(props, propRef) {
    var _a;
    var children = props.children, _b = props.size, size = _b === void 0 ? 'medium' : _b, _c = props.displayClose, displayClose = _c === void 0 ? true : _c, onPressEnter = props.onPressEnter, rest = __rest(props, ["children", "size", "displayClose", "onPressEnter"]);
    var _d = useModalContext(), floatingContext = _d.context, setOpen = _d.setOpen, context = __rest(_d, ["context", "setOpen"]);
    var ref = useMergeRefs$1([context.refs.setFloating, propRef]);
    var variantPath = useSelectedModalVariant(props, 'content');
    var get = useGetThemeProps().get;
    var themePrefix = 'modal.content';
    var boxStyles = React__default.useMemo(function () { return (__assign(__assign(__assign({}, get("".concat(variantPath, ".box"))), get("".concat(themePrefix, ".sizes.").concat(size))), rest.styleProps)); }, [get, rest.styleProps, size, variantPath]);
    var overlayStyles = ((_a = rest.styleProps) === null || _a === void 0 ? void 0 : _a.zIndex)
        ? __assign(__assign({}, get("".concat(variantPath, ".overlay"))), { zIndex: rest.styleProps.zIndex }) : get("".concat(variantPath, ".overlay"));
    var handleKeyDown = React__default.useCallback(function (ev) {
        if (ev.key === 'Enter') {
            if (onPressEnter)
                onPressEnter(ev);
        }
    }, [onPressEnter]);
    if (!context.transitionStatus.isMounted)
        return null;
    return (jsx(FloatingPortal, { children: jsx(FloatingOverlay, __assign({ lockScroll: true, "data-status": context.transitionStatus.status, sx: overlayStyles }, { children: jsx(FloatingFocusManager, __assign({ context: floatingContext, returnFocus: false }, { children: jsxs(Box, __assign({ ref: ref, "aria-labelledby": context.labelId, "aria-describedby": context.descriptionId }, context.getFloatingProps(__assign({ children: children }, rest)), rest, { "data-status": context.transitionStatus.status, styleProps: boxStyles, onKeyDown: handleKeyDown }, { children: [jsx(Box, { tabIndex: 0 }), " ", displayClose && (jsx(Button, { leftIcon: jsx(XOutline, {}), variant: "textGray", onClick: function () { return setOpen(false); }, styleProps: get("".concat(variantPath, ".closeButton")) })), children] })) })) })) }));
});

var ModalHeading = buildLMComponent(function ModalHeading(props, ref) {
    var children = props.children, icon = props.icon, rest = __rest(props, ["children", "icon"]);
    var variantPath = useSelectedModalVariant(props, 'heading');
    var get = useGetThemeProps().get;
    var iconElement = React__default.useMemo(function () {
        if (!icon)
            return null;
        return React__default.cloneElement(icon, { className: "".concat(icon.props.className || '', " modal-heading-icon") });
    }, [icon]);
    return (jsxs(Box, __assign({ ref: ref }, rest, { styleProps: __assign(__assign({}, get("".concat(variantPath, ".container"))), rest.styleProps) }, { children: [iconElement, typeof children === 'string' ? (jsx(Typography, __assign({ as: "h2", styleProps: get("".concat(variantPath, ".text")) }, { children: children }))) : (children)] })));
});

var ModalTrigger = buildLMComponent(function ModalTrigger(props) {
    var children = props.children, rest = __rest(props, ["children"]);
    var context = useModalContext();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var childrenRef = children.ref;
    var ref = useMergeRefs$1([context.refs.setReference, childrenRef]);
    return React__default.cloneElement(children, context.getReferenceProps(__assign(__assign(__assign({ ref: ref }, rest), children.props), { 'data-state': context.open ? 'open' : 'closed' })));
});

var ModalActions = buildLMComponent(function ModalActions(props, ref) {
    var children = props.children, rest = __rest(props, ["children"]);
    var variantPath = useSelectedModalVariant(props, 'actions');
    var get = useGetThemeProps().get;
    return (jsx(Box, __assign({ ref: ref }, rest, { styleProps: __assign(__assign({}, get(variantPath)), rest.styleProps) }, { children: children })));
});

var ModalButton = buildLMComponent(function ModalButton(props, ref) {
    var children = props.children, onClick = props.onClick, rest = __rest(props, ["children", "onClick"]);
    var setOpen = useModalContext().setOpen;
    var onClickHandler = React__default.useCallback(function (ev) {
        // If the onClick prop is defined, call it and let the implementor be responsible of closing the modal afterwards
        onClick ? onClick(ev) : setOpen(false);
    }, [onClick, setOpen]);
    return (jsx(Button, __assign({ ref: ref, variant: "primary" }, rest, { onClick: onClickHandler }, { children: children })));
});

var ModalDescription = buildLMComponent(function ModalDescription(props, ref) {
    var children = props.children, rest = __rest(props, ["children"]);
    var variantPath = useSelectedModalVariant(props, 'description');
    var get = useGetThemeProps().get;
    return (jsx(Typography, __assign({ as: "p", ref: ref }, rest, { styleProps: __assign(__assign({}, get("".concat(variantPath))), rest.styleProps) }, { children: children })));
});

var ModalAccentIcon = buildLMComponent(function ModalAccentIconProps(props, ref) {
    var icon = props.icon, rest = __rest(props, ["icon"]);
    var variantPath = useSelectedModalVariant(props, 'accentIcon');
    var get = useGetThemeProps().get;
    return (jsx(Box, __assign({ ref: ref }, rest, { styleProps: __assign(__assign({}, get("".concat(variantPath, ".container"))), rest.styleProps) }, { children: React__default.cloneElement(icon, { className: "".concat(icon.props.className || '', " modal-accent-icon") }) })));
});

var Error$1 = createSvgIcon(jsx("g", __assign({ id: "tabler-icon-circle-x-filled" }, { children: jsx("path", { id: "Vector", d: "M14.1667 2.78336C15.4236 3.50907 16.4691 4.55046 17.1999 5.80444C17.9306 7.05842 18.3211 8.4815 18.3329 9.93281C18.3446 11.3841 17.9771 12.8133 17.2667 14.0789C16.5563 15.3446 15.5277 16.4027 14.2827 17.1486C13.0377 17.8945 11.6195 18.3024 10.1684 18.3317C8.71736 18.3611 7.2838 18.011 6.00963 17.3161C4.73547 16.6211 3.6649 15.6055 2.90389 14.3696C2.14289 13.1338 1.71785 11.7206 1.67084 10.27L1.66667 10L1.67084 9.73002C1.71751 8.29085 2.13629 6.88832 2.88637 5.65918C3.63645 4.43004 4.69222 3.41623 5.95075 2.71659C7.20928 2.01695 8.62763 1.65535 10.0675 1.66705C11.5074 1.67875 12.9197 2.06335 14.1667 2.78336ZM8.75917 7.61669C8.58457 7.51275 8.37801 7.47619 8.17835 7.51388C7.97868 7.55157 7.79966 7.66091 7.67496 7.82134C7.55026 7.98177 7.48848 8.18223 7.50122 8.38503C7.51397 8.58782 7.60037 8.77897 7.74417 8.92252L8.82084 10L7.74417 11.0775L7.67501 11.1559C7.5455 11.3233 7.48459 11.5339 7.50467 11.7446C7.52475 11.9554 7.6243 12.1506 7.78311 12.2906C7.94191 12.4307 8.14806 12.505 8.35969 12.4985C8.57131 12.4921 8.77254 12.4053 8.92251 12.2559L10 11.1792L11.0775 12.2559L11.1558 12.325C11.3233 12.4545 11.5338 12.5154 11.7446 12.4954C11.9554 12.4753 12.1506 12.3757 12.2906 12.2169C12.4307 12.0581 12.505 11.852 12.4985 11.6403C12.4921 11.4287 12.4053 11.2275 12.2558 11.0775L11.1792 10L12.2558 8.92252L12.325 8.84419C12.4545 8.67669 12.5154 8.46619 12.4953 8.25542C12.4753 8.04465 12.3757 7.84942 12.2169 7.7094C12.0581 7.56937 11.8519 7.49504 11.6403 7.5015C11.4287 7.50796 11.2275 7.59473 11.0775 7.74419L10 8.82085L8.92251 7.74419L8.84417 7.67502L8.75917 7.61669Z", fill: "currentColor" }) })), 'Error', {
    viewBox: '0 0 20 20',
    styleProps: {
        color: 'icon.danger'
    }
});

var Info = createSvgIcon(jsx("g", __assign({ id: "tabler-icon-info-circle-filled" }, { children: jsx("path", { id: "Vector", d: "M10 1.66666C14.6025 1.66666 18.3334 5.39749 18.3334 9.99999C18.3351 12.1879 17.4763 14.2887 15.9424 15.8489C14.4086 17.409 12.3226 18.3034 10.135 18.3388C7.94743 18.3743 5.83364 17.548 4.25002 16.0383C2.6664 14.5287 1.74001 12.4568 1.67085 10.27L1.66669 9.99999L1.67002 9.76666C1.79335 5.27249 5.47502 1.66666 10 1.66666ZM10 9.16666H9.16669L9.06919 9.17249C8.86665 9.19658 8.67997 9.29412 8.54453 9.44663C8.40909 9.59913 8.33428 9.79602 8.33428 9.99999C8.33428 10.204 8.40909 10.4008 8.54453 10.5534C8.67997 10.7059 8.86665 10.8034 9.06919 10.8275L9.16669 10.8333V13.3333L9.17252 13.4308C9.19446 13.6168 9.27842 13.79 9.41086 13.9225C9.54331 14.0549 9.71651 14.1389 9.90252 14.1608L10 14.1667H10.8334L10.9309 14.1608C11.1169 14.1389 11.2901 14.0549 11.4225 13.9225C11.555 13.79 11.6389 13.6168 11.6609 13.4308L11.6667 13.3333L11.6609 13.2358C11.6409 13.0658 11.5691 12.906 11.4552 12.7783C11.3413 12.6505 11.1908 12.5609 11.0242 12.5217L10.9309 12.505L10.8334 12.5V9.99999L10.8275 9.90249C10.8056 9.71648 10.7216 9.54328 10.5892 9.41083C10.4567 9.27839 10.2835 9.19443 10.0975 9.17249L10 9.16666ZM10.0084 6.66666L9.90252 6.67249C9.69998 6.69658 9.51331 6.79412 9.37786 6.94663C9.24242 7.09913 9.16761 7.29602 9.16761 7.49999C9.16761 7.70396 9.24242 7.90084 9.37786 8.05335C9.51331 8.20586 9.69998 8.3034 9.90252 8.32749L10 8.33332L10.1059 8.32749C10.3084 8.3034 10.4951 8.20586 10.6305 8.05335C10.766 7.90084 10.8408 7.70396 10.8408 7.49999C10.8408 7.29602 10.766 7.09913 10.6305 6.94663C10.4951 6.79412 10.3084 6.69658 10.1059 6.67249L10.0084 6.66666Z", fill: "currentColor" }) })), 'Info', {
    viewBox: '0 0 20 20',
    styleProps: {
        color: 'icon.info'
    }
});

var Success = createSvgIcon(jsx("path", { fill: "currentColor", d: "M14.1667 2.78334C15.4236 3.50905 16.4691 4.55044 17.1999 5.80442C17.9306 7.0584 18.3212 8.48148 18.3329 9.93279C18.3446 11.3841 17.9771 12.8133 17.2667 14.0789C16.5563 15.3445 15.5277 16.4027 14.2827 17.1486C13.0377 17.8945 11.6195 18.3024 10.1684 18.3317C8.71738 18.3611 7.28381 18.011 6.00965 17.316C4.73549 16.6211 3.66491 15.6054 2.90391 14.3696C2.14291 13.1338 1.71786 11.7206 1.67085 10.27L1.66669 10L1.67085 9.73001C1.71752 8.29083 2.13631 6.88831 2.88639 5.65917C3.63646 4.43003 4.69223 3.41622 5.95076 2.71658C7.2093 2.01693 8.62764 1.65534 10.0675 1.66704C11.5074 1.67874 12.9197 2.06334 14.1667 2.78334ZM13.0892 7.74417C12.9457 7.60069 12.7548 7.5145 12.5523 7.50177C12.3497 7.48903 12.1495 7.55063 11.9892 7.67501L11.9109 7.74417L9.16669 10.4875L8.08919 9.41084L8.01085 9.34167C7.85051 9.21739 7.65033 9.15586 7.44786 9.16863C7.24539 9.18141 7.05453 9.2676 6.91107 9.41106C6.76762 9.55451 6.68142 9.74537 6.66865 9.94784C6.65587 10.1503 6.7174 10.3505 6.84169 10.5108L6.91085 10.5892L8.57752 12.2558L8.65585 12.325C8.802 12.4384 8.98171 12.4999 9.16669 12.4999C9.35166 12.4999 9.53138 12.4384 9.67752 12.325L9.75585 12.2558L13.0892 8.92251L13.1584 8.84417C13.2827 8.68384 13.3443 8.48363 13.3316 8.28111C13.3189 8.07858 13.2327 7.88767 13.0892 7.74417Z" }), 'Success', {
    viewBox: '0 0 20 20',
    styleProps: {
        color: 'icon.success'
    }
});

var Warning = createSvgIcon(jsx("g", __assign({ id: "tabler-icon-alert-circle-filled" }, { children: jsx("path", { id: "Vector", d: "M9.99999 1.66666C14.6025 1.66666 18.3333 5.39749 18.3333 9.99999C18.3351 12.1879 17.4763 14.2887 15.9424 15.8489C14.4085 17.409 12.3226 18.3034 10.135 18.3388C7.9474 18.3743 5.83361 17.548 4.24999 16.0383C2.66637 14.5287 1.73998 12.4568 1.67082 10.27L1.66666 9.99999L1.66999 9.76666C1.79332 5.27249 5.47499 1.66666 9.99999 1.66666ZM10.0083 12.5L9.90249 12.5058C9.69995 12.5299 9.51328 12.6275 9.37783 12.78C9.24239 12.9325 9.16758 13.1294 9.16758 13.3333C9.16758 13.5373 9.24239 13.7342 9.37783 13.8867C9.51328 14.0392 9.69995 14.1367 9.90249 14.1608L9.99999 14.1667L10.1058 14.1608C10.3084 14.1367 10.495 14.0392 10.6305 13.8867C10.7659 13.7342 10.8407 13.5373 10.8407 13.3333C10.8407 13.1294 10.7659 12.9325 10.6305 12.78C10.495 12.6275 10.3084 12.5299 10.1058 12.5058L10.0083 12.5ZM9.99999 5.83332C9.79588 5.83335 9.59888 5.90829 9.44635 6.04392C9.29382 6.17955 9.19637 6.36645 9.17249 6.56916L9.16666 6.66666V9.99999L9.17249 10.0975C9.19658 10.3 9.29412 10.4867 9.44663 10.6221C9.59913 10.7576 9.79602 10.8324 9.99999 10.8324C10.204 10.8324 10.4008 10.7576 10.5534 10.6221C10.7059 10.4867 10.8034 10.3 10.8275 10.0975L10.8333 9.99999V6.66666L10.8275 6.56916C10.8036 6.36645 10.7062 6.17955 10.5536 6.04392C10.4011 5.90829 10.2041 5.83335 9.99999 5.83332Z", fill: "currentColor" }) })), 'Warning', {
    viewBox: '0 0 20 20',
    styleProps: {
        color: 'icon.warning'
    }
});

var InlineNotification = buildLMComponent(function InlineNotification(props) {
    var type = props.type, _a = props.size, size = _a === void 0 ? 'medium' : _a, message = props.message, linkProps = props.linkProps, actionProps = props.actionProps, iconProp = props.icon, styleProps = props.styleProps, rest = __rest(props, ["type", "size", "message", "linkProps", "actionProps", "icon", "styleProps"]);
    var theme = useLMTheme().theme;
    var isString = typeof message === 'string';
    var containerStyles = React__default.useMemo(function () { return ({
        containerStyles: __assign(__assign({}, getThemeProp(theme, "inlineNotification.".concat(size, ".container"))), getThemeProp(theme, "inlineNotification.colors.".concat(type, ".container")))
    }); }, [type, size, theme]).containerStyles;
    var icon = React__default.useMemo(function () {
        if (iconProp)
            return iconProp;
        var styles = getThemeProp(theme, "inlineNotification.icon");
        switch (type) {
            case 'info':
                return jsx(Info, { styleProps: styles });
            case 'success':
                return jsx(Success, { styleProps: styles });
            case 'warning':
                return jsx(Warning, { styleProps: styles });
            case 'error':
                return jsx(Error$1, { styleProps: styles });
            default:
                return null;
        }
    }, [theme, type, iconProp]);
    return (jsxs(Box, __assign({ styleProps: __assign(__assign({}, containerStyles), styleProps) }, rest, { children: [icon, jsx(Box, __assign({ styleProps: getThemeProp(theme, "inlineNotification.textContainer") }, { children: isString ? (jsxs(Typography, __assign({ styleProps: getThemeProp(theme, "inlineNotification.message") }, { children: [message, linkProps && (jsxs(Fragment, { children: ["\u00A0", jsx(Link, __assign({ href: linkProps.href, onClick: linkProps.onClick, styleProps: getThemeProp(theme, "inlineNotification.link") }, { children: linkProps.label }))] }))] }))) : (message) })), actionProps && (jsxs(Box, __assign({ styleProps: getThemeProp(theme, "inlineNotification.actionContainer") }, { children: [jsx(Divider, { styleProps: getThemeProp(theme, "inlineNotification.divider"), orientation: "vertical" }), jsx(Button, __assign({ styleProps: getThemeProp(theme, "inlineNotification.actionButton"), variant: "inlineGray", onClick: actionProps.callback }, { children: actionProps.label }))] })))] })));
});

var isBadgeIndicatorSize = function (size) {
    return ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'].includes(size);
};
var isBadgeIndicatorSizeWithLabel = function (size) {
    return ['sm', 'md'].includes(size);
};
var isLabelType = function (props) {
    return props.label !== undefined;
};

var BadgeIndicator = buildLMComponent(function BadgeIndicator(props, ref) {
    var _a = props.type, type = _a === void 0 ? 'alert' : _a, _b = props.size, sizeProp = _b === void 0 ? 'md' : _b, _c = props.placement, placement = _c === void 0 ? 'top' : _c, styleProps = props.styleProps, children = props.children, rest = __rest(props, ["type", "size", "placement", "styleProps", "children"]);
    var label = isLabelType(props) ? props.label : undefined;
    var theme = useLMTheme().theme;
    var size = React__default.useMemo(function () {
        return (!isUndefined(label) && isBadgeIndicatorSizeWithLabel(sizeProp)) || (isUndefined(label) && isBadgeIndicatorSize(sizeProp))
            ? sizeProp
            : 'md';
    }, [label, sizeProp]);
    var themeStyles = React__default.useMemo(function () {
        var styles = __assign(__assign(__assign({}, getThemeProp(theme, "badgeIndicator.default")), getThemeProp(theme, "badgeIndicator.".concat(!isUndefined(label) ? 'sizesWithLabel' : 'sizes', ".").concat(size))), getThemeProp(theme, "badgeIndicator.types.".concat(type)));
        return children
            ? __assign(__assign({}, styles), getThemeProp(theme, "badgeIndicator.".concat(!isUndefined(label) ? 'placementWithLabel' : 'placement', ".").concat(placement))) : styles;
    }, [size, type, theme, label, placement, children]);
    var isLabelString = typeof label === 'string' || typeof label === 'number';
    return (jsxs(Box, __assign({ styleProps: getThemeProp(theme, 'badgeIndicator.container') }, { children: [children, jsx(Box, __assign({ styleProps: __assign(__assign({}, themeStyles), styleProps), ref: ref }, rest, { children: !isUndefined(label) && isLabelString ? (jsx(Typography, __assign({ variant: getThemeProp(theme, "badgeIndicator.label.".concat(size)), styleProps: getThemeProp(theme, "badgeIndicator.label.".concat(size)) }, { children: label }))) : (label) }))] })));
});

var addToastFn = null;
var removeToastFn = null;
var ToastContainer = function () {
    var _a = useState([]), toasts = _a[0], setToasts = _a[1];
    addToastFn = function (newToast) {
        var timestamp = Date.now().toString();
        newToast.id = newToast.id ? "".concat(newToast.id, "-").concat(timestamp) : timestamp;
        setToasts(function (prevToasts) { return __spreadArray(__spreadArray([], prevToasts, true), [newToast], false); });
    };
    removeToastFn = function (id) {
        setToasts(function (prevToasts) { return prevToasts.filter(function (toast) { return toast.id !== id; }); });
    };
    return (jsx(Box, __assign({ styleProps: {
            position: 'fixed',
            bottom: 24,
            left: 24,
            zIndex: 1000
        } }, { children: toasts.map(function (toast) {
            return jsx(Toast, __assign({}, toast), toast.id);
        }) })));
};
var ToastService = {
    show: function (toast) {
        if (addToastFn) {
            addToastFn(toast);
        }
        else {
            throw new ToastServiceException("ToastContainer is not mounted. Cannot show the toast.");
        }
    },
    remove: function (id) {
        if (!id)
            return;
        if (removeToastFn) {
            removeToastFn(id);
        }
        else {
            throw new ToastServiceException("ToastContainer is not mounted. Cannot remove the toast.");
        }
    }
};
var ToastServiceException = /** @class */ (function (_super) {
    __extends(ToastServiceException, _super);
    function ToastServiceException(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, ToastServiceException.prototype);
        _this.name = 'ToastServiceException';
        return _this;
    }
    return ToastServiceException;
}(Error));

var ToastAction = buildLMComponent(function (_a) {
    var id = _a.id, action = _a.action, inline = _a.inline, isNeutral = _a.isNeutral;
    var theme = useLMTheme().theme;
    if (!action)
        return null;
    var getButtonVariant = function () {
        if (isNeutral) {
            return inline ? 'textPrimary' : 'primary';
        }
        return inline ? 'textGray' : 'tertiary';
    };
    return (jsx(Box, __assign({ id: "".concat(id, "-toast-action"), styleProps: __assign({ marginTop: !inline ? 24 : 0 }, getThemeProp(theme, "toast.action")) }, { children: jsx(Button, __assign({ variant: getButtonVariant(), styleProps: { paddingX: inline ? 32 : 12 }, onClick: action.fn }, { children: action.text })) })));
});

var ToastClose = buildLMComponent(function (_a) {
    var onClose = _a.onClose, inline = _a.inline;
    var theme = useLMTheme().theme;
    return (jsx(Box, __assign({ styleProps: __assign({ cursor: 'pointer' }, getThemeProp(theme, inline ? 'toast.closeButtonContainerBasic' : 'toast.closeButtonContainer')) }, { children: jsx(XOutline, { style: { width: 20, height: 20 }, onClick: onClose }) })));
});

var icons = {
    success: jsx(Success, {}),
    error: jsx(Error$1, {}),
    warning: jsx(Warning, {}),
    info: jsx(Info, {}),
    neutral: null,
};
// Header component can be basic or noBasic
var ToastHeader = buildLMComponent(function (_a) {
    var id = _a.id, type = _a.type, title = _a.title, action = _a.action, inline = _a.inline, onClose = _a.onClose;
    var theme = useLMTheme().theme;
    var isNeutral = type === "neutral";
    var getMaxWidthForTitle = function () { return (action ? (isNeutral ? "95%" : "80%") : "100%"); };
    return (jsxs(Box, __assign({ styleProps: getThemeProp(theme, inline ? "toast.headerBasic" : "toast.header") }, { children: [jsxs(Box, __assign({ id: "".concat(id, "-toast-header"), styleProps: getThemeProp(theme, "toast.titleIconWrapper") }, { children: [icons[type], jsx(Typography, __assign({ styleProps: {
                            color: "#252527",
                            fontSize: inline ? 14 : undefined,
                            fontWeight: 500,
                            maxWidth: inline ? getMaxWidthForTitle() : undefined,
                            lineHeight: inline ? 1.25 : undefined,
                        } }, { children: title }))] })), inline && (jsxs(Box, __assign({ styleProps: __assign(__assign({}, getThemeProp(theme, "toast.actionCloseWrapper")), { marginLeft: !action ? 24 : 0 }) }, { children: [action && jsx(ToastAction, { id: id, action: action, inline: true, isNeutral: isNeutral }), jsx(ToastClose, { inline: true, onClose: onClose ? onClose : function () { return; } })] })))] })));
});

// Main Toast component
var Toast = buildLMComponent(function Toast(props) {
    var theme = useLMTheme().theme;
    var id = props.id, type = props.type, title = props.title, description = props.description, action = props.action, duration = props.duration;
    var _a = useState(false), isClosing = _a[0], setIsClosing = _a[1];
    // Timer for automatic closing based on duration
    useEffect(function () {
        if (!duration)
            return;
        var timer = setTimeout(function () { return setIsClosing(true); }, duration);
        return function () { return clearTimeout(timer); };
    }, [duration]);
    useEffect(function () {
        if (isClosing) {
            var removalTimer_1 = setTimeout(function () { return ToastService.remove(id); }, 100);
            return function () { return clearTimeout(removalTimer_1); };
        }
    }, [id, isClosing]);
    var containerClass = isClosing ? "fade-out" : "slide-in";
    var inline = !description;
    var isExpandable = !description && !action;
    var containerStyles = __assign(__assign({}, getThemeProp(theme, "toast.container")), { padding: inline ? 16 : 24, width: !isExpandable ? 400 : 'fit-content', maxWidth: !inline ? 400 : 600 });
    return (jsxs(Fragment, { children: [jsx("style", { children: "\n\t\t\t\t@keyframes slideIn {\n\t\t\t\t\tfrom { transform: translateX(-100%); }\n\t\t\t\t\tto { transform: translateX(0); }\n\t\t\t\t}\n\t\t\t\t@keyframes fadeOut {\n\t\t\t\t\tfrom { opacity: 1; }\n\t\t\t\t\tto { opacity: 0; }\n\t\t\t\t}\n\t\t\t\t.slide-in {\n\t\t\t\t\tanimation: slideIn 0.2s ease-out;\n\t\t\t\t}\n\t\t\t\t.fade-out {\n\t\t\t\t\tanimation: fadeOut 0.2s linear;\n\t\t\t\t}\n\t\t\t\t" }), jsx(Box, __assign({ className: containerClass, styleProps: containerStyles, id: id }, { children: inline ? (jsx(ToastHeader, { id: id, type: type, title: title, action: action, inline: inline, onClose: function () { return setIsClosing(true); } })) : (jsxs(Fragment, { children: [jsx(ToastClose, { inline: inline, onClose: function () { return setIsClosing(true); } }), jsx(ToastHeader, { id: id, type: type, title: title, action: action }), jsx(Typography, __assign({ styleProps: { fontWeight: 400, fontSize: 14, color: "#5A5A60" } }, { children: description })), jsx(ToastAction, { id: id, action: action, inline: inline, isNeutral: type === "neutral" })] })) }))] }));
});

var ExclamationCircleOutline = createSvgIcon([jsx("path", { stroke: "none", d: "M0 0h24v24H0z" }, "0"), jsx("path", { d: "M3 12a9 9 0 1 0 18 0 9 9 0 1 0-18 0m9-3v4m0 3v.01" }, "1")], 'ExclamationCircleOutline', { stroke: 'currentColor', strokeLinecap: 'round', strokeWidth: '1.5', fill: 'none', viewBox: '0 0 24 24' });

var CircleCheckFilled = createSvgIcon([
    jsx("path", { fill: "none", d: "M0 0h24v24H0z" }, "0"),
    jsx("path", { d: "M17 3.34a10 10 0 1 1-14.995 8.984L2 12l.005-.324A10 10 0 0 1 17 3.34m-1.293 5.953a1 1 0 0 0-1.32-.083l-.094.083L11 12.585l-1.293-1.292-.094-.083a1 1 0 0 0-1.403 1.403l.083.094 2 2 .094.083a1 1 0 0 0 1.226 0l.094-.083 4-4 .083-.094a1 1 0 0 0-.083-1.32" }, "1")
], 'CircleCheckFilled', { fill: 'currentColor', viewBox: '0 0 24 24' });

var ProgressBar = buildLMComponent(function ProgressBar(props) {
    var theme = useLMTheme().theme;
    var _a = props.id, id = _a === void 0 ? 'progress-bar' : _a, _b = props.value, value = _b === void 0 ? 0 : _b, _c = props.size, size = _c === void 0 ? 'medium' : _c, _d = props.max, max = _d === void 0 ? 100 : _d, styleProps = props.styleProps, label = props.label, hint = props.hint, completedHint = props.completedHint, loading = props.loading, _e = props.color, color = _e === void 0 ? 'info.600' : _e, _f = props.completedColor, completedColor = _f === void 0 ? 'success.500' : _f;
    var hintWhenCompleted = completedHint || hint;
    var _g = useState(false), completed = _g[0], setCompleted = _g[1];
    var _h = useState(completed ? completedColor : color), finalColor = _h[0], setFinalColor = _h[1];
    useEffect(function () {
        if (value >= max) {
            setCompleted(true);
            setFinalColor(completedColor);
        }
        else {
            setCompleted(false);
            setFinalColor(color);
        }
    }, [color, completedColor, max, value]);
    var getHintColor = function () {
        if (props.completedColor && completed)
            return completedColor;
        return completed ? 'text.success' : 'text.low';
    };
    var getPercentage = function () {
        if (value < max) {
            return (jsxs(Typography, __assign({ variant: size === 'small' ? 'textXsRegular' : 'textSmRegular', styleProps: __assign({}, getThemeProp(theme, 'progressBar.percentage')) }, { children: [(value * 100) / max, "%"] })));
        }
        if (value >= max) {
            return (jsx(CircleCheckFilled, { styleProps: __assign({}, getThemeProp(theme, 'progressBar.completeIcon')), color: completedColor, width: size === 'small' ? 16 : 20, height: size === 'small' ? 16 : 20 }));
        }
        return null;
    };
    return (jsxs(Box, __assign({ id: id }, { children: [label && (jsx(InputLabel, __assign({ variant: size, styleProps: __assign({}, getThemeProp(theme, 'progressBar.label')) }, { children: label }))), jsxs(Box, __assign({ styleProps: __assign({}, getThemeProp(theme, 'progressBar.container')) }, { children: [jsx(Box, { id: "".concat(id, "-bar"), as: "progress", value: value, max: max, styleProps: __assign(__assign(__assign({}, getThemeProp(theme, 'progressBar.bar')), { height: size === 'small' ? '4px' : '8px', '&::-webkit-progress-value': {
                                backgroundColor: finalColor,
                                borderRadius: 'radius16'
                            } }), styleProps) }), getPercentage()] })), hint && (jsxs(Box, __assign({ id: "".concat(id, "-hint"), styleProps: __assign({}, getThemeProp(theme, 'progressBar.hint')) }, { children: [loading && value < max && jsx(Loader, { styleProps: __assign({}, getThemeProp(theme, 'progressBar.loader')), size: 16 }), jsx(InputHint, __assign({ sx: { padding: 0, margin: 0, color: getHintColor() } }, { children: completed ? hintWhenCompleted : hint }))] })))] })));
});

var StyledIcon = function (_a) {
    var icon = _a.icon;
    return React__default.cloneElement(icon, { styleProps: { width: 24, height: 24, color: 'icon.subtle' } });
};
var StyledAction = function (_a) {
    var icon = _a.icon;
    var _b = useState(false), isHovered = _b[0], setIsHovered = _b[1];
    var styles = {
        width: 20,
        height: 20,
        cursor: 'pointer',
        marginLeft: 'spacing-12',
        color: isHovered ? 'icon.default' : 'icon.low',
    };
    return React__default.cloneElement(icon, {
        styleProps: styles,
        onMouseEnter: function () { return setIsHovered(true); },
        onMouseLeave: function () { return setIsHovered(false); },
    });
};
var FileStatusCard = buildLMComponent(function FileStatusCard(props) {
    var theme = useLMTheme().theme;
    var progressBar = props.progressBar, title = props.title, status = props.status, icon = props.icon, errorText = props.errorText, tryAgain = props.tryAgain, onTryAgain = props.onTryAgain, action = props.action, rest = __rest(props, ["progressBar", "title", "status", "icon", "errorText", "tryAgain", "onTryAgain", "action"]);
    return (jsxs(Box, __assign({ as: "div" }, rest, { styleProps: __assign(__assign({}, getThemeProp(theme, "fileStatusCard.container-".concat(status))), rest.styleProps) }, { children: [icon && jsx(StyledIcon, { icon: icon }), jsxs(Box, __assign({ styleProps: __assign({}, getThemeProp(theme, 'fileStatusCard.content')) }, { children: [jsxs(Box, __assign({ styleProps: __assign({}, getThemeProp(theme, 'fileStatusCard.infoContainer')) }, { children: [typeof title === 'string' ? (jsx(Typography, __assign({ as: 'span', variant: 'textSmMedium', color: "text.default" }, { children: title }))) :
                                (title), action && jsx(StyledAction, { icon: action })] })), status !== 'error' && progressBar && jsx(ProgressBar, __assign({}, progressBar)), errorText &&
                        jsxs(Fragment, { children: [jsxs(Box, __assign({ styleProps: __assign({}, getThemeProp(theme, 'fileStatusCard.errorInfo')) }, { children: [jsx(ExclamationCircleOutline, { styleProps: __assign({}, getThemeProp(theme, 'fileStatusCard.errorIcon')) }), jsx(Typography, __assign({ as: 'span', variant: 'textXsRegular', color: 'text.error' }, { children: errorText }))] })), jsx(Button, __assign({ variant: "inlineGray", size: "small", styleProps: __assign({}, getThemeProp(theme, 'fileStatusCard.tryAgain')), onClick: onTryAgain }, { children: tryAgain }))] })] }))] })));
});

export { Avatar, Badge, BadgeIndicator, Box, Button, Checkbox, Divider, Drawer, DrawerActions, DrawerContent, DrawerHeader, Dropdown, FileStatusCard, FilterBar, FilterButton, Funnel, InlineNotification, Input, InputHint, InputLabel, KeyMetric, KeyMetrics, LMThemeProvider$1 as LMThemeProvider, Link, Loader, Menu, MenuDropdown, MenuOption, MenuOptionGroup, MenuOptionList, MenuTrigger, Modal, ModalAccentIcon, ModalActions, ModalButton, ModalContent, ModalDescription, ModalHeading, ModalTrigger, MultiValueSelect$1 as MultiValueSelect, Option, OptionDescription, Popover, PopoverContent, PopoverItem, PopoverList, PopoverListComponent, PopoverListContext, PopoverTrigger, Profile, ProgressBar, Radio, RadioGroup, Search, Select, SelectOption, StatusIndicator, SvgIcon, Switch, TableBody as TBody, TableCell as TCell, TableFooter as TFoot, TableHeader as THCell, TableHead as THead, TableRow as TRow, Tab, Table$1 as Table, TableColumnGroup, TablePagination, TableSortLabel, Tabs, Tag, Toast, ToastContainer, ToastService, Tooltip, TooltipContent, Typography, getFontSizeValue, getFromTheme, getThemeProp, makeLMStyles, theme, useDrawerContext, useLMTheme, useMenuContext, useMenuItem, useNumberFormatter };
